import { Icon, IconProps } from '@chakra-ui/react';

export const EyeShutIcon = (props: IconProps) => (
  <Icon
    width="21px"
    height="12px"
    viewBox="0 0 21 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.76 5.22023L18.34 3.59023C18.72 3.09023 18.94 2.73023 18.97 2.67023C19.25 2.20023 19.09 1.58023 18.62 1.30023C18.15 1.02023 17.53 1.17023 17.25 1.65023C17.22 1.70023 14.36 6.40023 9.99999 6.40023C5.63999 6.40023 2.98999 1.90023 2.80999 1.59023C2.66999 1.28023 2.38 1.05023 2.01 1.00023C1.45 0.940229 0.969985 1.33023 0.899985 1.88023C0.849985 2.28023 1.25998 2.95023 1.70998 3.56023L0.260001 5.22023C-0.0999988 5.64023 -0.0600232 6.27023 0.359977 6.63023C0.549977 6.80023 0.779981 6.88023 1.01998 6.88023C1.29998 6.88023 1.57998 6.76023 1.76998 6.54023L3.02999 5.10023C3.54999 5.63023 4.14999 6.17023 4.83999 6.66023L3.6 8.93023C3.34 9.41023 3.50999 10.0202 3.99999 10.2902C4.14999 10.3702 4.32 10.4102 4.48 10.4102C4.83 10.4102 5.17998 10.2202 5.35998 9.89023L6.57998 7.66023C7.31998 7.99023 8.13998 8.22023 9.01998 8.33023V10.3802C9.01998 10.9302 9.46998 11.3802 10.02 11.3802C10.57 11.3802 11.02 10.9302 11.02 10.3802V8.34023C11.9 8.23023 12.71 7.98023 13.45 7.65023L14.68 9.90023C14.86 10.2302 15.2 10.4202 15.56 10.4202C15.72 10.4202 15.89 10.3802 16.04 10.3002C16.52 10.0402 16.7 9.43023 16.44 8.94023L15.2 6.67023C15.91 6.18023 16.52 5.64023 17.04 5.11023L18.27 6.52023C18.47 6.75023 18.74 6.86023 19.02 6.86023C19.25 6.86023 19.49 6.78023 19.68 6.61023C20.1 6.25023 20.14 5.62023 19.78 5.20023L19.76 5.22023Z"
      fill="black"
    />
  </Icon>
);

export const EyeOpenIcon = (props: IconProps) => (
  <Icon
    width="22px"
    height="18px"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.03555 9.3224C0.966466 9.11513 0.9664 8.89073 1.03536 8.68343C2.42372 4.50972 6.36079 1.5 11.0008 1.5C15.6387 1.5 19.5742 4.50692 20.9643 8.6776C21.0334 8.88487 21.0335 9.10927 20.9645 9.31658C19.5761 13.4903 15.6391 16.5 10.9991 16.5C6.36119 16.5 2.42564 13.4931 1.03555 9.3224Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 9C14 10.6569 12.6569 12 11 12C9.34314 12 8 10.6569 8 9C8 7.34315 9.34314 6 11 6C12.6569 6 14 7.34315 14 9Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const EyeSlashIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.53033 2.46967C3.23744 2.17678 2.76256 2.17678 2.46967 2.46967C2.17678 2.76256 2.17678 3.23744 2.46967 3.53033L20.4697 21.5303C20.7626 21.8232 21.2374 21.8232 21.5303 21.5303C21.8232 21.2374 21.8232 20.7626 21.5303 20.4697L3.53033 2.46967Z"
      fill="#0F172A"
    />
    <path
      d="M22.6759 12.5533C22.1319 14.1887 21.2226 15.6575 20.0447 16.8627L16.9462 13.7642C17.1429 13.2129 17.25 12.6189 17.25 12C17.25 9.1005 14.8995 6.75 12 6.75C11.3811 6.75 10.7871 6.8571 10.2358 7.05379L7.75898 4.577C9.06783 4.04381 10.4998 3.75 12.0005 3.75C16.9708 3.75 21.1864 6.97271 22.6755 11.4405C22.7959 11.8015 22.796 12.1922 22.6759 12.5533Z"
      fill="#0F172A"
    />
    <path
      d="M15.75 12C15.75 12.1802 15.7373 12.3574 15.7127 12.5308L11.4692 8.28727C11.6426 8.2627 11.8198 8.25 12 8.25C14.0711 8.25 15.75 9.92893 15.75 12Z"
      fill="#0F172A"
    />
    <path
      d="M12.5308 15.7127L8.28727 11.4692C8.2627 11.6426 8.25 11.8198 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C12.1802 15.75 12.3574 15.7373 12.5308 15.7127Z"
      fill="#0F172A"
    />
    <path
      d="M6.75 12C6.75 11.3811 6.8571 10.7871 7.05379 10.2358L3.95492 7.1369C2.77687 8.34222 1.86747 9.81114 1.32341 11.4467C1.20328 11.8078 1.2034 12.1985 1.32374 12.5595C2.81284 17.0273 7.02847 20.25 11.9988 20.25C13.4997 20.25 14.9318 19.9561 16.2408 19.4228L13.7642 16.9462C13.2129 17.1429 12.6189 17.25 12 17.25C9.1005 17.25 6.75 14.8995 6.75 12Z"
      fill="#0F172A"
    />
  </Icon>
);

export const CheckedIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="24" height="24" rx="12" />
    <path
      d="M7.01099 12.2945L10.1409 15.4241L16.9889 8.57593"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CheckedDarkIcon = (props: IconProps) => (
  <Icon
    width="25px"
    height="24px"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="0.5" width="24" height="24" rx="12" fill="#1A1C1F" />
    <path
      d="M7.51123 12.2943L10.6411 15.4239L17.4892 8.57568"
      stroke="#00C707"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const UncheckedIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="24" height="24" rx="12" fill="#F9FAFA" />
    <path
      d="M7.01099 12.2945L10.1409 15.4241L16.9889 8.57593"
      stroke="#EBEDEF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const BuildingStoreFrontIcon = (props?: IconProps) => (
  <Icon
    width="44px"
    height="44px"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.57614 4.125C8.66446 4.125 7.79012 4.48716 7.14546 5.13182L4.76364 7.51364C2.07879 10.1985 2.07879 14.5515 4.76364 17.2364C7.21509 19.6878 11.0573 19.9009 13.7505 17.8757C14.8989 18.7378 16.3276 19.25 17.875 19.25C19.4226 19.25 20.8515 18.7377 22 17.8753C23.1485 18.7377 24.5774 19.25 26.125 19.25C27.6724 19.25 29.1011 18.7378 30.2495 17.8757C32.9427 19.9009 36.7849 19.6878 39.2364 17.2364C41.9212 14.5515 41.9212 10.1985 39.2364 7.51364L36.8545 5.13183C36.2099 4.48717 35.3355 4.12501 34.4239 4.12501L9.57614 4.125Z"
      fill="#0F172A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 37.125V21.0744C8.10372 22.309 11.1465 22.3082 13.7508 21.073C15.0015 21.6668 16.4012 22 17.875 22C19.3491 22 20.7491 21.6667 22 21.0726C23.2509 21.6667 24.6509 22 26.125 22C27.5988 22 28.9985 21.6668 30.2492 21.073C32.8535 22.3082 35.8963 22.309 38.5 21.0744V37.125H39.875C40.6344 37.125 41.25 37.7406 41.25 38.5C41.25 39.2594 40.6344 39.875 39.875 39.875H4.125C3.36561 39.875 2.75 39.2594 2.75 38.5C2.75 37.7406 3.36561 37.125 4.125 37.125H5.5ZM11 26.125C11 25.3656 11.6156 24.75 12.375 24.75H17.875C18.6344 24.75 19.25 25.3656 19.25 26.125V31.625C19.25 32.3844 18.6344 33 17.875 33H12.375C11.6156 33 11 32.3844 11 31.625V26.125ZM26.125 24.75C25.3656 24.75 24.75 25.3656 24.75 26.125V35.75C24.75 36.5094 25.3656 37.125 26.125 37.125H31.625C32.3844 37.125 33 36.5094 33 35.75V26.125C33 25.3656 32.3844 24.75 31.625 24.75H26.125Z"
      fill="#0F172A"
    />
  </Icon>
);

export const OutletStoreIcon = (props?: IconProps) => (
  <Icon
    width="36px"
    height="36px"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="1" y="1" width="34" height="34" rx="17" fill="#FBE5B6" />
    <path
      d="M10.8787 15.1211C12.0503 16.2926 13.9497 16.2926 15.1213 15.1211C15.2653 14.9771 15.3916 14.8221 15.5001 14.6589C16.0376 15.4671 16.9566 15.9998 18 15.9998C19.0435 15.9998 19.9626 15.467 20.5001 14.6586C20.6087 14.8219 20.7351 14.977 20.8791 15.1211C22.0507 16.2927 23.9502 16.2927 25.1218 15.1211C26.2933 13.9495 26.2933 12.05 25.1218 10.8785L24.8291 10.5858C24.454 10.2107 23.9453 10 23.4149 10H12.5855C12.0551 10 11.5464 10.2107 11.1713 10.5858L10.8787 10.8784C9.70711 12.05 9.70711 13.9495 10.8787 15.1211Z"
      fill="#CC8806"
    />
    <path
      d="M11 17.0322C12.428 17.7407 14.1539 17.6439 15.5006 16.742C16.215 17.2201 17.0747 17.4998 18 17.4998C18.9254 17.4998 19.7852 17.22 20.4996 16.7419C21.8462 17.6439 23.572 17.7407 25 17.0325V24.5H25.25C25.6642 24.5 26 24.8358 26 25.25C26 25.6642 25.6642 26 25.25 26H20.75C20.3358 26 20 25.6642 20 25.25V21.75C20 21.3358 19.6642 21 19.25 21H16.75C16.3358 21 16 21.3358 16 21.75V25.25C16 25.6642 15.6642 26 15.25 26H10.75C10.3358 26 10 25.6642 10 25.25C10 24.8358 10.3358 24.5 10.75 24.5H11V17.0322Z"
      fill="#CC8806"
    />
    <rect
      x="1"
      y="1"
      width="34"
      height="34"
      rx="17"
      stroke="white"
      strokeWidth="2"
    />
  </Icon>
);

export const RoofFilledOutletStoreIcon = (props?: IconProps) => (
  <Icon
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5013 6.7085C1.96154 6.7085 2.33464 7.08159 2.33464 7.54183L2.33464 11.7085C2.33464 12.9106 2.33641 13.7283 2.41874 14.3406C2.49784 14.929 2.63732 15.2015 2.82279 15.387C3.00827 15.5725 3.28079 15.712 3.86916 15.7911C4.48151 15.8734 5.29923 15.8752 6.5013 15.8752H11.5013C12.7034 15.8752 13.5211 15.8734 14.1334 15.7911C14.7218 15.712 14.9943 15.5725 15.1798 15.387C15.3653 15.2015 15.5048 14.929 15.5839 14.3406C15.6662 13.7283 15.668 12.9106 15.668 11.7085L15.668 7.54183C15.668 7.08159 16.0411 6.7085 16.5013 6.7085C16.9615 6.7085 17.3346 7.08159 17.3346 7.54183V11.7673C17.3347 12.8957 17.3347 13.8262 17.2357 14.5627C17.1317 15.3359 16.9051 16.0188 16.3583 16.5655C15.8116 17.1123 15.1287 17.3389 14.3555 17.4429C13.6191 17.5419 12.6885 17.5419 11.5601 17.5418L6.44249 17.5418C5.31406 17.5419 4.38355 17.5419 3.64708 17.4429C2.87389 17.3389 2.19104 17.1123 1.64428 16.5655C1.09752 16.0188 0.870884 15.3359 0.766931 14.5627C0.667916 13.8263 0.66794 12.8957 0.66797 11.7673L0.667971 7.54183C0.667971 7.08159 1.04107 6.7085 1.5013 6.7085Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.87808 12.4051C6.18361 12.0609 6.71031 12.0296 7.05451 12.3351C7.44268 12.6797 8.1398 12.9583 9.00131 12.9583C9.86282 12.9583 10.5599 12.6797 10.9481 12.3351C11.2923 12.0296 11.819 12.0609 12.1245 12.4051C12.4301 12.7493 12.3987 13.276 12.0545 13.5816C11.3025 14.2491 10.1844 14.625 9.00131 14.625C7.81823 14.625 6.7001 14.2491 5.94811 13.5816C5.60391 13.276 5.57256 12.7493 5.87808 12.4051Z"
      fill="#00151A"
    />
    <path
      d="M13.5562 0.458496C14.0858 0.458476 14.537 0.458458 14.9065 0.502146C15.3015 0.548856 15.6658 0.651081 15.9956 0.897238C16.3235 1.14203 16.5287 1.46304 16.6934 1.82978C16.8489 2.176 16.9907 2.61643 17.1588 3.13882L17.739 4.94144L17.7515 4.9802C17.8982 5.43539 18.0158 5.80031 17.9297 6.35209C17.8941 6.58078 17.8485 6.76843 17.7712 6.94221C17.6985 7.10567 17.6079 7.2309 17.5385 7.32687L17.5282 7.34114C16.7081 8.47666 15.2043 9.2085 13.7965 9.2085C12.8968 9.2085 12.0656 8.91126 11.3985 8.41039C10.7312 8.91159 9.90037 9.2085 9.0004 9.2085C8.10089 9.2085 7.26995 8.91143 6.60292 8.41081C5.9357 8.91176 5.1051 9.2085 4.20538 9.2085C2.79765 9.2085 1.29387 8.47666 0.473738 7.34114L0.46343 7.32688C0.393997 7.23091 0.303392 7.10568 0.23072 6.94222C0.153461 6.76843 0.107875 6.58078 0.0721874 6.35209C-0.0139199 5.80031 0.103705 5.43538 0.250427 4.98019L0.262909 4.94144L0.832681 3.17125L0.843115 3.13883L0.843116 3.13882C1.01124 2.61644 1.15299 2.176 1.30851 1.82978C1.47325 1.46304 1.67839 1.14203 2.00634 0.897238C2.33611 0.651081 2.7004 0.548856 3.09546 0.502146C3.46496 0.458458 3.9161 0.458476 4.44568 0.458496H4.44571L13.5562 0.458496H13.5562Z"
      fill="#00151A"
    />
  </Icon>
);

export const ChatBubbleIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.91307 2.65823C6.9877 2.38888 9.10296 2.25 11.2503 2.25C13.3974 2.25 15.5124 2.38885 17.5869 2.65815C19.5091 2.90769 20.8783 4.51937 20.9923 6.38495C20.6665 6.27614 20.3212 6.20396 19.96 6.17399C18.5715 6.05874 17.1673 6 15.75 6C14.3326 6 12.9285 6.05874 11.54 6.17398C9.1817 6.36971 7.5 8.36467 7.5 10.6082V14.8937C7.5 16.5844 8.45468 18.1326 9.9328 18.8779L7.28033 21.5303C7.06583 21.7448 6.74324 21.809 6.46299 21.6929C6.18273 21.5768 6 21.3033 6 21V16.9705C5.63649 16.9316 5.27417 16.8887 4.91308 16.8418C2.90466 16.581 1.5 14.8333 1.5 12.8626V6.63738C1.5 4.66672 2.90466 2.91899 4.91307 2.65823Z"
      fill="white"
    />
    <path
      d="M15.75 7.5C14.3741 7.5 13.0114 7.55702 11.6641 7.66884C10.1248 7.7966 9 9.10282 9 10.6082V14.8937C9 16.4014 10.128 17.7083 11.6692 17.8341C12.9131 17.9357 14.17 17.9912 15.4384 17.999L18.2197 20.7803C18.4342 20.9948 18.7568 21.059 19.037 20.9429C19.3173 20.8268 19.5 20.5533 19.5 20.25V17.8601C19.6103 17.8518 19.7206 17.8432 19.8307 17.8342C21.372 17.7085 22.5 16.4015 22.5 14.8938V10.6082C22.5 9.10283 21.3752 7.79661 19.836 7.66885C18.4886 7.55702 17.1259 7.5 15.75 7.5Z"
      fill="white"
    />
  </Icon>
);

export const ArrowUpOnSquareIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 6.875H6.25C5.21447 6.875 4.375 7.71447 4.375 8.75V16.25C4.375 17.2855 5.21447 18.125 6.25 18.125H13.75C14.7855 18.125 15.625 17.2855 15.625 16.25V8.75C15.625 7.71447 14.7855 6.875 13.75 6.875H12.5M12.5 4.375L10 1.875M10 1.875L7.5 4.375M10 1.875L10 12.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowUpOnSquareGreenIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.55806 1.43306C9.80214 1.18898 10.1979 1.18898 10.4419 1.43306L12.9419 3.93306C13.186 4.17714 13.186 4.57286 12.9419 4.81694C12.6979 5.06102 12.3021 5.06102 12.0581 4.81694L10.625 3.38388L10.625 6.25H9.375V3.38388L7.94194 4.81694C7.69786 5.06102 7.30214 5.06102 7.05806 4.81694C6.81398 4.57286 6.81398 4.17713 7.05806 3.93306L9.55806 1.43306Z"
      fill="#1A1C1F"
    />
    <path
      d="M9.375 6.25L9.375 12.5C9.375 12.8452 9.65482 13.125 10 13.125C10.3452 13.125 10.625 12.8452 10.625 12.5V6.25H13.75C15.1307 6.25 16.25 7.36929 16.25 8.75V16.25C16.25 17.6307 15.1307 18.75 13.75 18.75H6.25C4.86929 18.75 3.75 17.6307 3.75 16.25V8.75C3.75 7.36929 4.86929 6.25 6.25 6.25H9.375Z"
      fill="currentColor"
    />
  </Icon>
);

export const BankNotesIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.875 15.625C6.431 15.625 10.8447 16.2344 15.039 17.376C15.6448 17.5409 16.25 17.0905 16.25 16.4626V15.625M3.125 3.75V4.375C3.125 4.72018 2.84518 5 2.5 5H1.875M1.875 5V4.6875C1.875 4.16973 2.29473 3.75 2.8125 3.75H16.875M1.875 5V12.5M16.875 3.75V4.375C16.875 4.72018 17.1548 5 17.5 5H18.125M16.875 3.75H17.1875C17.7053 3.75 18.125 4.16973 18.125 4.6875V12.8125C18.125 13.3303 17.7053 13.75 17.1875 13.75H16.875M18.125 12.5H17.5C17.1548 12.5 16.875 12.7798 16.875 13.125V13.75M16.875 13.75H3.125M3.125 13.75H2.8125C2.29473 13.75 1.875 13.3303 1.875 12.8125V12.5M3.125 13.75V13.125C3.125 12.7798 2.84518 12.5 2.5 12.5H1.875M12.5 8.75C12.5 10.1307 11.3807 11.25 10 11.25C8.61929 11.25 7.5 10.1307 7.5 8.75C7.5 7.36929 8.61929 6.25 10 6.25C11.3807 6.25 12.5 7.36929 12.5 8.75ZM15 8.75H15.0062V8.75625H15V8.75ZM5 8.75H5.00625V8.75625H5V8.75Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CalculatorIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.125 13.125V15M6.875 9.375H6.88125V9.38125H6.875V9.375ZM6.875 11.25H6.88125V11.2563H6.875V11.25ZM6.875 13.125H6.88125V13.1313H6.875V13.125ZM6.875 15H6.88125V15.0063H6.875V15ZM8.9563 9.375H8.96255V9.38125H8.9563V9.375ZM8.9563 11.25H8.96255V11.2563H8.9563V11.25ZM8.9563 13.125H8.96255V13.1313H8.9563V13.125ZM8.9563 15H8.96255V15.0063H8.9563V15ZM11.0437 9.375H11.05V9.38125H11.0437V9.375ZM11.0437 11.25H11.05V11.2563H11.0437V11.25ZM11.0437 13.125H11.05V13.1313H11.0437V13.125ZM11.0437 15H11.05V15.0063H11.0437V15ZM13.125 9.375H13.1313V9.38125H13.125V9.375ZM13.125 11.25H13.1313V11.2563H13.125V11.25ZM6.875 5H13.125V6.875H6.875V5ZM10 1.875C8.42333 1.875 6.86797 1.96622 5.3389 2.14367C4.42173 2.25011 3.75 3.04083 3.75 3.96416V16.25C3.75 17.2855 4.58947 18.125 5.625 18.125H14.375C15.4105 18.125 16.25 17.2855 16.25 16.25V3.96416C16.25 3.04083 15.5783 2.25011 14.6611 2.14367C13.132 1.96622 11.5767 1.875 10 1.875Z"
      stroke={String(props.stroke ?? '#1A1C1F')}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ChartPieIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.75 5C5.29822 5 2.5 7.79822 2.5 11.25C2.5 14.7018 5.29822 17.5 8.75 17.5C12.2018 17.5 15 14.7018 15 11.25H8.75V5Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.25 8.75H17.5C17.5 5.29822 14.7018 2.5 11.25 2.5V8.75Z"
      stroke={String(props.stroke ?? '#1A1C1F')}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CogToothIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.99473 3.28338C8.07007 2.83132 8.46119 2.5 8.91947 2.5H11.0811C11.5394 2.5 11.9305 2.83132 12.0059 3.28338L12.1838 4.35092C12.2357 4.66262 12.444 4.92226 12.7205 5.0753C12.7823 5.10952 12.8434 5.14486 12.9038 5.18131C13.1746 5.34487 13.5041 5.39572 13.8004 5.28471L14.8144 4.90481C15.2436 4.74404 15.7261 4.91709 15.9552 5.31398L17.0361 7.18601C17.2652 7.5829 17.1738 8.08728 16.82 8.37855L15.9831 9.06756C15.7393 9.26823 15.6185 9.5781 15.6243 9.89377C15.625 9.9291 15.6253 9.96451 15.6253 10C15.6253 10.0355 15.625 10.0709 15.6243 10.1062C15.6185 10.4219 15.7393 10.7318 15.9831 10.9324L16.82 11.6214C17.1738 11.9127 17.2652 12.4171 17.0361 12.814L15.9552 14.686C15.7261 15.0829 15.2436 15.256 14.8144 15.0952L13.8004 14.7153C13.5041 14.6043 13.1747 14.6551 12.9038 14.8187C12.8434 14.8551 12.7823 14.8905 12.7205 14.9247C12.444 15.0777 12.2357 15.3374 12.1838 15.6491L12.0059 16.7166C11.9305 17.1687 11.5394 17.5 11.0811 17.5H8.91947C8.46119 17.5 8.07007 17.1687 7.99473 16.7166L7.8168 15.6491C7.76485 15.3374 7.55654 15.0777 7.28007 14.9247C7.21826 14.8905 7.15716 14.8551 7.0968 14.8187C6.82594 14.6551 6.49649 14.6043 6.20019 14.7153L5.18613 15.0952C4.75698 15.256 4.27448 15.0829 4.04534 14.686L2.96452 12.814C2.73538 12.4171 2.82676 11.9127 3.18057 11.6215L4.01753 10.9324C4.26129 10.7318 4.38212 10.4219 4.37627 10.1062C4.37562 10.0709 4.37529 10.0355 4.37529 10C4.37529 9.96452 4.37562 9.92911 4.37627 9.89379C4.38212 9.57811 4.26129 9.26824 4.01753 9.06758L3.18057 8.37856C2.82675 8.08729 2.73538 7.58291 2.96452 7.18602L4.04534 5.31399C4.27448 4.9171 4.75698 4.74405 5.18613 4.90483L6.20018 5.28472C6.49648 5.39573 6.82593 5.34487 7.09679 5.18132C7.15715 5.14487 7.21825 5.10952 7.28007 5.0753C7.55654 4.92226 7.76485 4.66262 7.8168 4.35092L7.99473 3.28338Z"
      stroke={String(props.stroke ?? '#1A1C1F')}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5001 9.99993C12.5001 11.3806 11.3808 12.4999 10.0001 12.4999C8.61939 12.4999 7.5001 11.3806 7.5001 9.99993C7.5001 8.61922 8.61939 7.49993 10.0001 7.49993C11.3808 7.49993 12.5001 8.61922 12.5001 9.99993Z"
      stroke={String(props.stroke ?? '#1A1C1F')}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CreditCardIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.875 6.875H18.125M1.875 7.5H18.125M4.375 11.875H9.375M4.375 13.75H6.875M3.75 16.25H16.25C17.2855 16.25 18.125 15.4105 18.125 14.375V5.625C18.125 4.58947 17.2855 3.75 16.25 3.75H3.75C2.71447 3.75 1.875 4.58947 1.875 5.625V14.375C1.875 15.4105 2.71447 16.25 3.75 16.25Z"
      stroke={String(props.stroke ?? '#1A1C1F')}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const DocumentChartBarIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.25 11.875V9.6875C16.25 8.1342 14.9908 6.875 13.4375 6.875H12.1875C11.6697 6.875 11.25 6.45527 11.25 5.9375V4.6875C11.25 3.1342 9.9908 1.875 8.4375 1.875H6.875M7.5 13.75V14.375M10 11.875V14.375M12.5 10V14.375M8.75 1.875H4.6875C4.16973 1.875 3.75 2.29473 3.75 2.8125V17.1875C3.75 17.7053 4.16973 18.125 4.6875 18.125H15.3125C15.8303 18.125 16.25 17.7053 16.25 17.1875V9.375C16.25 5.23286 12.8921 1.875 8.75 1.875Z"
      stroke={String(props.stroke ?? '#1A1C1F')}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const FlagIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 2.5V3.75M2.5 17.5V12.5M2.5 12.5L4.80841 11.9229C6.54529 11.4887 8.3802 11.6901 9.98153 12.4908L10.0713 12.5356C11.6406 13.3203 13.4353 13.5299 15.1432 13.1281L17.7384 12.5174C17.5809 11.075 17.5 9.60942 17.5 8.125C17.5 6.65285 17.5795 5.19928 17.7345 3.76835L15.1432 4.37807C13.4353 4.77993 11.6406 4.5703 10.0713 3.78565L9.98153 3.74076C8.3802 2.9401 6.54529 2.73868 4.80841 3.1729L2.5 3.75M2.5 12.5V3.75"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const GiftIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5 9.375V16.25C17.5 16.9404 16.9404 17.5 16.25 17.5H4.375C3.68464 17.5 3.125 16.9404 3.125 16.25V9.375M10 4.0625C10 2.85438 9.02062 1.875 7.8125 1.875C6.60438 1.875 5.625 2.85438 5.625 4.0625C5.625 5.27062 6.60438 6.25 7.8125 6.25C8.42459 6.25 10 6.25 10 6.25M10 4.0625C10 4.65853 10 6.25 10 6.25M10 4.0625C10 2.85438 10.9794 1.875 12.1875 1.875C13.3956 1.875 14.375 2.85438 14.375 4.0625C14.375 5.27062 13.3956 6.25 12.1875 6.25C11.5754 6.25 10 6.25 10 6.25M10 6.25V17.5M2.8125 9.375H17.8125C18.3303 9.375 18.75 8.95527 18.75 8.4375V7.1875C18.75 6.66973 18.3303 6.25 17.8125 6.25H2.8125C2.29473 6.25 1.875 6.66973 1.875 7.1875V8.4375C1.875 8.95527 2.29473 9.375 2.8125 9.375Z"
      stroke={String(props.stroke ?? '#1A1C1F')}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const TransactionsIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3081 2.05806C13.5521 1.81398 13.9479 1.81398 14.1919 2.05806L17.9419 5.80806C18.0592 5.92527 18.125 6.08424 18.125 6.25C18.125 6.41576 18.0592 6.57473 17.9419 6.69194L14.1919 10.4419C13.9479 10.686 13.5521 10.686 13.3081 10.4419C13.064 10.1979 13.064 9.80214 13.3081 9.55806L15.9911 6.875L6.25 6.875C5.90482 6.875 5.625 6.59518 5.625 6.25C5.625 5.90482 5.90482 5.625 6.25 5.625L15.9911 5.625L13.3081 2.94194C13.064 2.69786 13.064 2.30214 13.3081 2.05806ZM6.69194 9.55806C6.93602 9.80214 6.93602 10.1979 6.69194 10.4419L4.00888 13.125H13.75C14.0952 13.125 14.375 13.4048 14.375 13.75C14.375 14.0952 14.0952 14.375 13.75 14.375H4.00888L6.69194 17.0581C6.93602 17.3021 6.93602 17.6979 6.69194 17.9419C6.44786 18.186 6.05214 18.186 5.80806 17.9419L2.05806 14.1919C1.81398 13.9479 1.81398 13.5521 2.05806 13.3081L5.80806 9.55806C6.05214 9.31398 6.44786 9.31398 6.69194 9.55806Z"
      fill="currentColor"
    />
  </Icon>
);

export const GlobeAltIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 17.5C13.4938 17.5 16.4296 15.111 17.2631 11.8775M10 17.5C6.50619 17.5 3.57035 15.111 2.73692 11.8775M10 17.5C12.0711 17.5 13.75 14.1421 13.75 10C13.75 5.85786 12.0711 2.5 10 2.5M10 17.5C7.92893 17.5 6.25 14.1421 6.25 10C6.25 5.85786 7.92893 2.5 10 2.5M10 2.5C12.8043 2.5 15.2492 4.03912 16.5359 6.31871M10 2.5C7.19567 2.5 4.75083 4.03912 3.4641 6.31871M16.5359 6.31871C14.7831 7.83366 12.4986 8.75 10 8.75C7.50143 8.75 5.21689 7.83366 3.4641 6.31871M16.5359 6.31871C17.1497 7.40619 17.5 8.66219 17.5 10C17.5 10.6483 17.4177 11.2774 17.2631 11.8775M17.2631 11.8775C15.1111 13.0706 12.6349 13.75 10 13.75C7.36509 13.75 4.88885 13.0706 2.73692 11.8775M2.73692 11.8775C2.58226 11.2774 2.5 10.6483 2.5 10C2.5 8.66219 2.85027 7.40619 3.4641 6.31871"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const GlobeAsiaAustraliaIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.75 3.03081V3.59808C12.75 3.93196 12.8983 4.24858 13.1548 4.46233L14.2234 5.35284C14.6651 5.7209 14.7582 6.36275 14.4393 6.84112L13.9282 7.60766C13.6507 8.02398 13.2423 8.3359 12.7676 8.49413L12.6254 8.54154C11.9327 8.77243 11.6492 9.59877 12.0542 10.2063C12.4237 10.7605 12.2238 11.5131 11.6281 11.811L9 13.125L9.42339 14.1835C9.608 14.645 9.40803 15.171 8.96343 15.3933C8.5503 15.5999 8.04855 15.4814 7.77142 15.1119L7.09217 14.2062C6.59039 13.5372 5.55995 13.6301 5.18594 14.3781L4.5 15.75L3.88804 15.903M12.75 3.03081C12.5027 3.0104 12.2526 3 12 3C7.02944 3 3 7.02944 3 12C3 13.3984 3.31894 14.7223 3.88804 15.903M12.75 3.03081C17.3696 3.41192 21 7.282 21 12C21 13.8792 20.4241 15.6239 19.4391 17.0672M19.4391 17.0672L19.2628 16.5385C18.9566 15.6197 18.0968 15 17.1283 15H16.5L16.1756 14.6756C15.9031 14.4031 15.5335 14.25 15.1481 14.25C14.5977 14.25 14.0945 14.561 13.8484 15.0533L13.8119 15.1263C13.6131 15.5237 13.2567 15.8195 12.8295 15.9416L11.8408 16.2241C11.2906 16.3813 10.9461 16.9263 11.0401 17.4907L11.1131 17.9285C11.1921 18.4026 11.6022 18.75 12.0828 18.75C12.9291 18.75 13.6805 19.2916 13.9482 20.0945L14.1628 20.7384M19.4391 17.0672C18.2095 18.8688 16.3425 20.2007 14.1628 20.7384M14.1628 20.7384C13.47 20.9093 12.7456 21 12 21C8.42785 21 5.34177 18.9189 3.88804 15.903M15.7498 9C15.7498 9.89602 15.3569 10.7003 14.7341 11.25"
      stroke="#0F172A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const LinkIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5847 3.41529C15.3643 2.1949 13.3857 2.1949 12.1653 3.41529L8.41529 7.16529C7.1949 8.38568 7.1949 10.3643 8.41529 11.5847C8.67435 11.8438 8.96648 12.0471 9.27752 12.1957C9.58899 12.3445 9.72086 12.7176 9.57207 13.0291C9.42328 13.3405 9.05018 13.4724 8.73871 13.3236C8.30141 13.1147 7.89219 12.8294 7.53141 12.4686C5.82286 10.76 5.82286 7.98995 7.53141 6.28141L11.2814 2.53141C12.99 0.822864 15.76 0.822864 17.4686 2.53141C19.1771 4.23995 19.1771 7.01005 17.4686 8.71859L16.0044 10.1827C15.7604 10.4268 15.3646 10.4268 15.1206 10.1827C14.8765 9.93866 14.8765 9.54293 15.1206 9.29885L16.5847 7.83471C17.8051 6.61432 17.8051 4.63568 16.5847 3.41529ZM10.4279 6.97094C10.5767 6.65948 10.9498 6.52761 11.2613 6.67639C11.6986 6.8853 12.1078 7.17062 12.4686 7.53141C14.1771 9.23995 14.1771 12.01 12.4686 13.7186L8.71859 17.4686C7.01005 19.1771 4.23995 19.1771 2.53141 17.4686C0.822864 15.76 0.822864 12.99 2.53141 11.2814L3.99555 9.81727C4.23963 9.57319 4.63536 9.57319 4.87943 9.81727C5.12351 10.0613 5.12351 10.4571 4.87943 10.7011L3.41529 12.1653C2.1949 13.3857 2.1949 15.3643 3.41529 16.5847C4.63568 17.8051 6.61432 17.8051 7.83471 16.5847L11.5847 12.8347C12.8051 11.6143 12.8051 9.63568 11.5847 8.41529C11.3257 8.15623 11.0335 7.95289 10.7225 7.80431C10.411 7.65552 10.2791 7.28241 10.4279 6.97094Z"
    />
  </Icon>
);

export const PlusAddIcon = (props: IconProps) => (
  <Icon
    width="12px"
    height="12px"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.25 5.25H0.75C0.335786 5.25 0 5.58579 0 6C0 6.41421 0.335786 6.75 0.75 6.75H11.25C11.6642 6.75 12 6.41421 12 6C12 5.58579 11.6642 5.25 11.25 5.25Z"
      fill="#00C707"
    />
    <path
      d="M6.75 11.25L6.75 0.75C6.75 0.335786 6.41421 0 6 0C5.58579 0 5.25 0.335786 5.25 0.75L5.25 11.25C5.25 11.6642 5.58579 12 6 12C6.41421 12 6.75 11.6642 6.75 11.25Z"
      fill="#00C707"
    />
  </Icon>
);

export const ShieldCheckIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 10.6248L9.375 12.4998L12.5 8.12483M10 2.26172C8.20792 3.9589 5.78802 4.99984 3.125 4.99984C3.08269 4.99984 3.04043 4.99958 2.99825 4.99906C2.67491 5.98248 2.5 7.03325 2.5 8.12488C2.5 12.7845 5.68693 16.6997 10 17.8098C14.3131 16.6997 17.5 12.7845 17.5 8.12488C17.5 7.03325 17.3251 5.98248 17.0018 4.99906C16.9596 4.99958 16.9173 4.99984 16.875 4.99984C14.212 4.99984 11.7921 3.9589 10 2.26172Z"
      stroke={String(props.stroke ?? '#1A1C1F')}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const SquaresPlusIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.25 14.0625H14.0625M14.0625 14.0625H16.875M14.0625 14.0625V11.25M14.0625 14.0625V16.875M5 8.75H6.875C7.91053 8.75 8.75 7.91053 8.75 6.875V5C8.75 3.96447 7.91053 3.125 6.875 3.125H5C3.96447 3.125 3.125 3.96447 3.125 5V6.875C3.125 7.91053 3.96447 8.75 5 8.75ZM5 16.875H6.875C7.91053 16.875 8.75 16.0355 8.75 15V13.125C8.75 12.0895 7.91053 11.25 6.875 11.25H5C3.96447 11.25 3.125 12.0895 3.125 13.125V15C3.125 16.0355 3.96447 16.875 5 16.875ZM13.125 8.75H15C16.0355 8.75 16.875 7.91053 16.875 6.875V5C16.875 3.96447 16.0355 3.125 15 3.125H13.125C12.0895 3.125 11.25 3.96447 11.25 5V6.875C11.25 7.91053 12.0895 8.75 13.125 8.75Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const MobilePhoneIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.75 1.25H6.875C5.83947 1.25 5 2.08947 5 3.125V16.875C5 17.9105 5.83947 18.75 6.875 18.75H13.125C14.1605 18.75 15 17.9105 15 16.875V3.125C15 2.08947 14.1605 1.25 13.125 1.25H11.25M8.75 1.25V2.5H11.25V1.25M8.75 1.25H11.25M8.75 16.875H11.25"
      stroke="#1A1C1F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const TicketIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.75 5V5.625M13.75 8.125V8.75M13.75 11.25V11.875M13.75 14.375V15M6.25 10.625H10.625M6.25 12.5H8.75M2.8125 4.375C2.29473 4.375 1.875 4.79473 1.875 5.3125V7.83446C2.62225 8.26672 3.125 9.07465 3.125 10C3.125 10.9254 2.62225 11.7333 1.875 12.1655V14.6875C1.875 15.2053 2.29473 15.625 2.8125 15.625H17.1875C17.7053 15.625 18.125 15.2053 18.125 14.6875V12.1655C17.3777 11.7333 16.875 10.9254 16.875 10C16.875 9.07465 17.3777 8.26672 18.125 7.83446V5.3125C18.125 4.79473 17.7053 4.375 17.1875 4.375H2.8125Z"
      stroke="#1A1C1F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const OutletIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="22px"
    viewBox="0 0 20 22"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.5 19V11.5C12.5 11.0858 12.8358 10.75 13.25 10.75H16.25C16.6642 10.75 17 11.0858 17 11.5V19M12.5 19H1.36088M12.5 19H17M17 19H20.6391M19.25 19V7.34879M2.75 19V7.34903M2.75 7.34903C3.89729 8.01217 5.38977 7.85296 6.37132 6.87142C6.41594 6.8268 6.45886 6.78112 6.50008 6.73447C7.04979 7.35723 7.85402 7.75001 8.75 7.75001C9.64602 7.75001 10.4503 7.3572 11 6.73438C11.5497 7.3572 12.354 7.75001 13.25 7.75001C14.1459 7.75001 14.9501 7.35728 15.4998 6.73459C15.541 6.78117 15.5838 6.82678 15.6284 6.87133C16.61 7.85296 18.1027 8.01211 19.25 7.34879M2.75 7.34903C2.52788 7.22065 2.31871 7.06145 2.12868 6.87142C0.957107 5.69985 0.957107 3.80035 2.12868 2.62878L3.31797 1.43949C3.59927 1.15819 3.9808 1.00015 4.37863 1.00015H17.6212C18.019 1.00015 18.4005 1.15819 18.6818 1.43949L19.871 2.62869C21.0426 3.80027 21.0426 5.69976 19.871 6.87133C19.6811 7.06128 19.472 7.22043 19.25 7.34879M5.75 16H9.5C9.91421 16 10.25 15.6642 10.25 15.25V11.5C10.25 11.0858 9.91421 10.75 9.5 10.75H5.75C5.33579 10.75 5 11.0858 5 11.5V15.25C5 15.6642 5.33579 16 5.75 16Z"
      // stroke={String(props.stroke ?? '#1A1C1F')}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const BellIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25001 8.9998C5.25012 5.27197 8.27215 2.25 12 2.25C15.7279 2.25 18.75 5.27208 18.75 9L18.7498 9.04919V9.75C18.7498 11.8731 19.5508 13.8074 20.8684 15.2699C21.0349 15.4547 21.0989 15.71 21.0393 15.9516C20.9797 16.1931 20.8042 16.3893 20.5709 16.4755C19.0269 17.0455 17.4105 17.4659 15.7396 17.7192C15.7465 17.812 15.75 17.9056 15.75 18C15.75 20.0711 14.0711 21.75 12 21.75C9.92894 21.75 8.25001 20.0711 8.25001 18C8.25001 17.9056 8.25351 17.812 8.2604 17.7192C6.58934 17.4659 4.97287 17.0455 3.42875 16.4755C3.19539 16.3893 3.01992 16.1931 2.96033 15.9516C2.90073 15.71 2.96476 15.4547 3.13126 15.2699C4.44879 13.8074 5.24981 11.8731 5.24981 9.75L5.25001 8.9998ZM9.75221 17.8993C9.75075 17.9326 9.75001 17.9662 9.75001 18C9.75001 19.2426 10.7574 20.25 12 20.25C13.2427 20.25 14.25 19.2426 14.25 18C14.25 17.9662 14.2493 17.9326 14.2478 17.8992C13.5072 17.9659 12.7574 18 11.9998 18C11.2424 18 10.4927 17.966 9.75221 17.8993Z"
      fill="#0F172A"
    />
  </Icon>
);

export const BarsIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 6.75C3 6.33579 3.33579 6 3.75 6H20.25C20.6642 6 21 6.33579 21 6.75C21 7.16421 20.6642 7.5 20.25 7.5H3.75C3.33579 7.5 3 7.16421 3 6.75ZM3 12C3 11.5858 3.33579 11.25 3.75 11.25H20.25C20.6642 11.25 21 11.5858 21 12C21 12.4142 20.6642 12.75 20.25 12.75H3.75C3.33579 12.75 3 12.4142 3 12ZM3 17.25C3 16.8358 3.33579 16.5 3.75 16.5H20.25C20.6642 16.5 21 16.8358 21 17.25C21 17.6642 20.6642 18 20.25 18H3.75C3.33579 18 3 17.6642 3 17.25Z"
      fill="#0F172A"
    />
  </Icon>
);

export const ChevronDownIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.23017 7.20938C5.52875 6.92228 6.00353 6.93159 6.29063 7.23017L10 11.1679L13.7094 7.23017C13.9965 6.93159 14.4713 6.92228 14.7698 7.20938C15.0684 7.49647 15.0777 7.97125 14.7906 8.26983L10.5406 12.7698C10.3992 12.9169 10.204 13 10 13C9.79599 13 9.60078 12.9169 9.45938 12.7698L5.20938 8.26983C4.92228 7.97125 4.93159 7.49647 5.23017 7.20938Z"
      fill="#0F172A"
    />
  </Icon>
);

export const ChevronRightIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.20938 14.7698C6.92228 14.4713 6.93159 13.9965 7.23017 13.7094L11.1679 10L7.23017 6.29062C6.93159 6.00353 6.92228 5.52875 7.20938 5.23017C7.49647 4.93159 7.97125 4.92228 8.26983 5.20937L12.7698 9.45937C12.9169 9.60078 13 9.79599 13 10C13 10.204 12.9169 10.3992 12.7698 10.5406L8.26983 14.7906C7.97125 15.0777 7.49647 15.0684 7.20938 14.7698Z"
      fill={(props.fill as string) ?? '#009F06'}
    />
  </Icon>
);

export const ChevronUpIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.55806 6.43306C9.80214 6.18898 10.1979 6.18898 10.4419 6.43306L16.6919 12.6831C16.936 12.9271 16.936 13.3229 16.6919 13.5669C16.4479 13.811 16.0521 13.811 15.8081 13.5669L10 7.75888L4.19194 13.5669C3.94786 13.811 3.55214 13.811 3.30806 13.5669C3.06398 13.3229 3.06398 12.9271 3.30806 12.6831L9.55806 6.43306Z"
      fill="white"
    />
  </Icon>
);

export const BusinessInformationIcon = (props: IconProps) => (
  <Icon
    width="64px"
    height="64px"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="64" height="64" rx="32" fill="#1A1C1F" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26 23C26 20.7909 27.7909 19 30 19H34C36.2091 19 38 20.7909 38 23V23.2733C39.2433 23.3871 40.4765 23.536 41.6987 23.7188C43.6375 24.0089 45 25.6955 45 27.6076V31.6519C45 33.2667 44.0218 34.7883 42.4183 35.3214C39.1421 36.4107 35.6389 37 32 37C28.3612 37 24.8579 36.4106 21.5817 35.3214C19.9782 34.7883 19 33.2667 19 31.6518V27.6076C19 25.6955 20.3625 24.0089 22.3013 23.7188C23.5235 23.536 24.7567 23.3871 26 23.2733V23ZM36 23V23.1211C34.6769 23.0408 33.3431 23 32 23C30.6569 23 29.3231 23.0408 28 23.1211V23C28 21.8954 28.8954 21 30 21H34C35.1046 21 36 21.8954 36 23ZM32 34C32.5523 34 33 33.5523 33 33C33 32.4477 32.5523 32 32 32C31.4477 32 31 32.4477 31 33C31 33.5523 31.4477 34 32 34Z"
      fill="white"
    />
    <path
      d="M20 40.5333V36.8052C20.2974 36.9683 20.6146 37.1075 20.9507 37.2193C24.4278 38.3753 28.144 39 32 39C35.856 39 39.5722 38.3753 43.0493 37.2193C43.3854 37.1076 43.7026 36.9684 44 36.8053V40.5333C44 42.4692 42.6037 44.17 40.6358 44.4313C37.81 44.8064 34.9274 45 32 45C29.0726 45 26.19 44.8064 23.3642 44.4313C21.3963 44.17 20 42.4692 20 40.5333Z"
      fill="white"
    />
  </Icon>
);

export const DocumentVerificationIcon = (props: IconProps) => (
  <Icon
    width="64px"
    height="64px"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="64" height="64" rx="32" fill="#E6E8E8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.0024 24H30.9969L31 24H35.5065C37.9887 24.0036 39.9999 26.0169 39.9999 28.5V41C42.209 41 43.9999 39.2091 43.9999 37V24.1443C43.9999 22.1371 42.5002 20.3955 40.4478 20.2251C40.1494 20.2004 39.8505 20.1776 39.551 20.1569C38.8844 18.8753 37.5444 18 36 18H34C32.4556 18 31.1156 18.8753 30.449 20.1569C30.1494 20.1776 29.8504 20.2003 29.5519 20.2251C27.5489 20.3914 26.0723 22.0543 26.0024 24ZM34 20C32.8954 20 32 20.8954 32 22H38C38 20.8954 37.1046 20 36 20H34Z"
      fill="#0F172A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 28.5C20 27.1193 21.1193 26 22.5 26H35.5C36.8807 26 38 27.1193 38 28.5V43.5C38 44.8807 36.8807 46 35.5 46H22.5C21.1193 46 20 44.8807 20 43.5V28.5ZM24 32C24 31.4477 24.4477 31 25 31H25.01C25.5623 31 26.01 31.4477 26.01 32V32.01C26.01 32.5623 25.5623 33.01 25.01 33.01H25C24.4477 33.01 24 32.5623 24 32.01V32ZM27 32C27 31.4477 27.4477 31 28 31H33C33.5523 31 34 31.4477 34 32C34 32.5523 33.5523 33 33 33H28C27.4477 33 27 32.5523 27 32ZM24 36C24 35.4477 24.4477 35 25 35H25.01C25.5623 35 26.01 35.4477 26.01 36V36.01C26.01 36.5623 25.5623 37.01 25.01 37.01H25C24.4477 37.01 24 36.5623 24 36.01V36ZM27 36C27 35.4477 27.4477 35 28 35H33C33.5523 35 34 35.4477 34 36C34 36.5523 33.5523 37 33 37H28C27.4477 37 27 36.5523 27 36ZM24 40C24 39.4477 24.4477 39 25 39H25.01C25.5623 39 26.01 39.4477 26.01 40V40.01C26.01 40.5623 25.5623 41.01 25.01 41.01H25C24.4477 41.01 24 40.5623 24 40.01V40ZM27 40C27 39.4477 27.4477 39 28 39H33C33.5523 39 34 39.4477 34 40C34 40.5523 33.5523 41 33 41H28C27.4477 41 27 40.5523 27 40Z"
      fill="#0F172A"
    />
  </Icon>
);

export const OwnerInformationIcon = (props: IconProps) => (
  <Icon
    width="64px"
    height="64px"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="64" height="64" rx="32" fill="#E6E8E8" />
    <path
      d="M27.1998 28.8C29.8508 28.8 31.9998 26.6509 31.9998 24C31.9998 21.349 29.8508 19.2 27.1998 19.2C24.5488 19.2 22.3998 21.349 22.3998 24C22.3998 26.6509 24.5488 28.8 27.1998 28.8Z"
      fill="#0F172A"
    />
    <path
      d="M39.1998 30.4C41.4089 30.4 43.1998 28.6091 43.1998 26.4C43.1998 24.1908 41.4089 22.4 39.1998 22.4C36.9907 22.4 35.1998 24.1908 35.1998 26.4C35.1998 28.6091 36.9907 30.4 39.1998 30.4Z"
      fill="#0F172A"
    />
    <path
      d="M18.5843 42.2847C17.9486 41.8777 17.5804 41.1536 17.6735 40.4046C18.2625 35.6672 22.3029 32 27.1996 32C32.0964 32 36.1368 35.6662 36.7258 40.4034C36.8189 41.1524 36.4507 41.8765 35.8151 42.2836C33.3282 43.876 30.3717 44.7999 27.1996 44.7999C24.0276 44.7999 21.0711 43.8769 18.5843 42.2847Z"
      fill="#0F172A"
    />
    <path
      d="M39.1999 41.5999C39.1434 41.5999 39.087 41.5996 39.0307 41.5988C39.1408 41.1239 39.1713 40.6216 39.1074 40.1073C38.8267 37.8499 37.92 35.7872 36.5662 34.0986C37.3831 33.7767 38.2731 33.6 39.2043 33.6C42.3079 33.6 44.9528 35.5637 45.9645 38.3164C46.1819 38.908 45.927 39.5585 45.3872 39.8839C43.5805 40.9733 41.4634 41.5999 39.1999 41.5999Z"
      fill="#0F172A"
    />
  </Icon>
);

export const XFilledIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="32" height="32" rx="16" fill="#F9FAFA" />
    <path
      d="M22.8574 9.14282L9.14307 22.8571M9.14307 9.14282L22.8574 22.8571"
      stroke="#C9CFD4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowLeftIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="32" height="32" rx="16" fill="#F0FFF0" />
    <path
      d="M24 16H8M8 16L16 24M8 16L16 8"
      stroke="#009F06"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const StepSeparatorIcon = (props: IconProps) => (
  <Icon
    width="131px"
    height="4px"
    viewBox="0 0 131 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 2L131 2"
      stroke="url(#paint0_linear_553_8938)"
      strokeWidth="4"
    />
    <defs>
      <linearGradient
        id="paint0_linear_553_8938"
        x1="0"
        y1="1.5"
        x2="131"
        y2="1.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00C707" />
        <stop offset="0.789266" stopColor="white" />
      </linearGradient>
    </defs>
  </Icon>
);

export const AddIcon = (props: IconProps) => (
  <Icon
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.25 8.25H3.75C3.33579 8.25 3 8.58579 3 9C3 9.41421 3.33579 9.75 3.75 9.75H14.25C14.6642 9.75 15 9.41421 15 9C15 8.58579 14.6642 8.25 14.25 8.25Z"
      fill="white"
    />
    <path
      d="M9.75 14.25L9.75 3.75C9.75 3.33579 9.41421 3 9 3C8.58579 3 8.25 3.33579 8.25 3.75L8.25 14.25C8.25 14.6642 8.58579 15 9 15C9.41421 15 9.75 14.6642 9.75 14.25Z"
      fill="white"
    />
  </Icon>
);

export const AddNewIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 6V26M26 16L6 16"
      stroke="#0F172A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const SearchIcon = (props: IconProps) => (
  <Icon
    width="15px"
    height="14px"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <ellipse
      cx="6.79614"
      cy="6.33333"
      rx="5.55102"
      ry="5.33333"
      stroke="#656B76"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.7347 12.9996L10.7163 10.0996"
      stroke="#656B76"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const EllipsesVerticalIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 8C14 6.89543 14.8954 6 16 6C17.1046 6 18 6.89543 18 8C18 9.10457 17.1046 10 16 10C14.8954 10 14 9.10457 14 8ZM14 16C14 14.8954 14.8954 14 16 14C17.1046 14 18 14.8954 18 16C18 17.1046 17.1046 18 16 18C14.8954 18 14 17.1046 14 16ZM14 24C14 22.8954 14.8954 22 16 22C17.1046 22 18 22.8954 18 24C18 25.1046 17.1046 26 16 26C14.8954 26 14 25.1046 14 24Z"
      fill="#0F172A"
    />
  </Icon>
);

export const PencilSquareMiniIcon = (props: IconProps) => (
  <Icon
    width="10px"
    height="10px"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.71653 6.95814L3.34742 5.38091C3.44802 5.12943 3.59864 4.901 3.79016 4.70948L7.24976 1.25011C7.66397 0.835899 8.33554 0.8359 8.74976 1.25011C9.16397 1.66433 9.16397 2.3359 8.74976 2.75011L5.29016 6.20948C5.09864 6.401 4.87021 6.55163 4.61873 6.65222L3.0415 7.2831C2.83742 7.36474 2.6349 7.16222 2.71653 6.95814Z"
      fill="#1A1C1F"
    />
    <path
      d="M1.75 2.87476C1.75 2.52958 2.02982 2.24976 2.375 2.24976H5C5.20711 2.24976 5.375 2.08186 5.375 1.87476C5.375 1.66765 5.20711 1.49976 5 1.49976H2.375C1.61561 1.49976 1 2.11536 1 2.87476V7.62476C1 8.38415 1.61561 8.99976 2.375 8.99976H7.125C7.88439 8.99976 8.5 8.38415 8.5 7.62476V4.99976C8.5 4.79265 8.33211 4.62476 8.125 4.62476C7.91789 4.62476 7.75 4.79265 7.75 4.99976V7.62476C7.75 7.96993 7.47018 8.24976 7.125 8.24976H2.375C2.02982 8.24976 1.75 7.96993 1.75 7.62476V2.87476Z"
      fill="#1A1C1F"
    />
  </Icon>
);

export const PencilSquareIcon = (props: IconProps) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M11.2411 2.99111L12.3661 1.86612C12.8543 1.37796 13.6457 1.37796 14.1339 1.86612C14.622 2.35427 14.622 3.14573 14.1339 3.63388L7.05479 10.713C6.70234 11.0654 6.26762 11.3245 5.78993 11.4668L4 12L4.53319 10.2101C4.67548 9.73239 4.93456 9.29767 5.28701 8.94522L11.2411 2.99111ZM11.2411 2.99111L13 4.74999M12 9.33333V12.5C12 13.3284 11.3284 14 10.5 14L3.5 14C2.67157 14 2 13.3284 2 12.5L2 5.49999C2 4.67157 2.67157 3.99999 3.5 3.99999L6.66667 3.99999"
      stroke="#656B76"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const TrashMiniIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75 1C7.23122 1 6 2.23122 6 3.75V4.1927C5.20472 4.26972 4.41602 4.36947 3.63458 4.49129C3.22531 4.5551 2.94525 4.9386 3.00906 5.34787C3.07286 5.75714 3.45637 6.0372 3.86564 5.97339L4.01355 5.95062L4.85504 16.4693C4.96938 17.8985 6.16254 19 7.59629 19H12.4035C13.8372 19 15.0304 17.8985 15.1447 16.4693L15.9862 5.95055L16.1346 5.97339C16.5438 6.0372 16.9274 5.75714 16.9912 5.34787C17.055 4.9386 16.7749 4.5551 16.3656 4.49129C15.5841 4.36946 14.7954 4.2697 14 4.19268V3.75C14 2.23122 12.7688 1 11.25 1H8.75ZM10.0001 4C10.8395 4 11.673 4.02523 12.5 4.07499V3.75C12.5 3.05964 11.9404 2.5 11.25 2.5H8.75C8.05964 2.5 7.5 3.05964 7.5 3.75V4.075C8.32707 4.02524 9.16068 4 10.0001 4ZM8.57948 7.72002C8.56292 7.30614 8.21398 6.98404 7.8001 7.0006C7.38622 7.01716 7.06412 7.36609 7.08068 7.77998L7.38069 15.28C7.39725 15.6939 7.74619 16.016 8.16007 15.9994C8.57395 15.9828 8.89605 15.6339 8.87949 15.22L8.57948 7.72002ZM12.9195 7.77998C12.936 7.36609 12.614 7.01715 12.2001 7.0006C11.7862 6.98404 11.4372 7.30614 11.4207 7.72002L11.1207 15.22C11.1041 15.6339 11.4262 15.9828 11.8401 15.9994C12.254 16.016 12.6029 15.6939 12.6195 15.28L12.9195 7.77998Z"
      fill="#0F172A"
    />
  </Icon>
);

export const TrashMiniRedIcon = (props: IconProps) => (
  <Icon
    width="10px"
    height="10px"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.375 0.5C3.61561 0.5 3 1.11561 3 1.875V2.09635C2.60236 2.13486 2.20801 2.18473 1.81729 2.24565C1.61265 2.27755 1.47263 2.4693 1.50453 2.67394C1.53643 2.87857 1.72818 3.0186 1.93282 2.9867L2.00677 2.97531L2.42752 8.23465C2.48469 8.94924 3.08127 9.5 3.79814 9.5H6.20175C6.91862 9.5 7.51521 8.94924 7.57237 8.23465L7.99312 2.97528L8.06729 2.9867C8.27192 3.0186 8.46368 2.87857 8.49558 2.67394C8.52748 2.4693 8.38745 2.27755 8.18282 2.24565C7.79206 2.18473 7.39768 2.13485 7 2.09634V1.875C7 1.11561 6.38439 0.5 5.625 0.5H4.375ZM5.00005 2C5.41973 2 5.8365 2.01262 6.25 2.03749V1.875C6.25 1.52982 5.97018 1.25 5.625 1.25H4.375C4.02982 1.25 3.75 1.52982 3.75 1.875V2.0375C4.16353 2.01262 4.58034 2 5.00005 2ZM4.16484 3.86501C4.15932 3.72705 4.04301 3.61968 3.90505 3.6252C3.76709 3.63072 3.65972 3.74703 3.66524 3.88499L3.81525 7.63499C3.82076 7.77295 3.93708 7.88032 4.07504 7.8748C4.213 7.86928 4.32036 7.75297 4.31485 7.61501L4.16484 3.86501ZM6.33485 3.88499C6.34036 3.74703 6.233 3.63072 6.09504 3.6252C5.95708 3.61968 5.84076 3.72705 5.83525 3.86501L5.68525 7.61501C5.67973 7.75297 5.78709 7.86928 5.92505 7.8748C6.06301 7.88032 6.17933 7.77295 6.18485 7.63499L6.33485 3.88499Z"
      fill="#E54839"
    />
  </Icon>
);

export const TrashOutlineIcon = ({ stroke = '#DB4343' }) => (
  <Icon
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.82692 6L9.59615 12M6.40385 12L6.17308 6M12.8184 3.86038C13.0464 3.89481 13.2736 3.93165 13.5 3.97086M12.8184 3.86038L12.1065 13.115C12.0464 13.8965 11.3948 14.5 10.611 14.5L5.38905 14.5C4.60524 14.5 3.95358 13.8965 3.89346 13.115L3.18157 3.86038M12.8184 3.86038C12.0542 3.74496 11.281 3.65657 10.5 3.59622M2.5 3.97086C2.72638 3.93165 2.95358 3.89481 3.18157 3.86038M3.18157 3.86038C3.94585 3.74496 4.719 3.65657 5.5 3.59622M10.5 3.59622V2.98546C10.5 2.19922 9.8929 1.54282 9.10706 1.51768C8.73948 1.50592 8.37043 1.5 8 1.5C7.62957 1.5 7.26052 1.50592 6.89294 1.51768C6.1071 1.54282 5.5 2.19922 5.5 2.98546V3.59622M10.5 3.59622C9.67504 3.53247 8.84131 3.5 8 3.5C7.15869 3.5 6.32496 3.53247 5.5 3.59622"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const UserPlusIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 5C10 6.65685 8.65685 8 7 8C5.34315 8 4 6.65685 4 5C4 3.34315 5.34315 2 7 2C8.65685 2 10 3.34315 10 5Z"
      fill="#009F06"
    />
    <path
      d="M1.61528 16.428C1.21798 16.1736 0.987847 15.721 1.04605 15.2529C1.41416 12.292 3.93944 10 6.9999 10C10.0604 10 12.5856 12.2914 12.9537 15.2522C13.012 15.7203 12.7818 16.1729 12.3845 16.4273C10.8302 17.4225 8.98243 18 6.9999 18C5.01737 18 3.16959 17.4231 1.61528 16.428Z"
      fill="#009F06"
    />
    <path
      d="M16.25 5.75C16.25 5.33579 15.9142 5 15.5 5C15.0858 5 14.75 5.33579 14.75 5.75V7.75H12.75C12.3358 7.75 12 8.08579 12 8.5C12 8.91421 12.3358 9.25 12.75 9.25H14.75V11.25C14.75 11.6642 15.0858 12 15.5 12C15.9142 12 16.25 11.6642 16.25 11.25V9.25H18.25C18.6642 9.25 19 8.91421 19 8.5C19 8.08579 18.6642 7.75 18.25 7.75H16.25V5.75Z"
      fill="#009F06"
    />
  </Icon>
);

export const ReceiptTwoToneIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 6V8.42C22 10 21 11 19.42 11H16V4.01C16 2.9 16.91 2 18.02 2C19.11 2.01 20.11 2.45 20.83 3.17C21.55 3.9 22 4.9 22 6Z"
      stroke="#C06C00"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 7V21C2 21.83 2.94 22.3 3.6 21.8L5.31 20.52C5.71 20.22 6.27 20.26 6.63 20.62L8.29 22.29C8.68 22.68 9.32 22.68 9.71 22.29L11.39 20.61C11.74 20.26 12.3 20.22 12.69 20.52L14.4 21.8C15.06 22.29 16 21.82 16 21V4C16 2.9 16.9 2 18 2H7H6C3 2 2 3.79 2 6V7Z"
      stroke="#C06C00"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M9 13.0098H12"
      stroke="#C06C00"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M9 9.00977H12"
      stroke="#C06C00"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M5.99561 13H6.00459"
      stroke="#C06C00"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M5.99548 9H6.00447"
      stroke="#C06C00"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ErrorIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.51 3.85L11.57 0.42C10.6 -0.14 9.40004 -0.14 8.42004 0.42L2.49004 3.85C1.52004 4.41 0.920044 5.45 0.920044 6.58V13.42C0.920044 14.54 1.52004 15.58 2.49004 16.15L8.43004 19.58C9.40004 20.14 10.6 20.14 11.58 19.58L17.52 16.15C18.49 15.59 19.09 14.55 19.09 13.42V6.58C19.08 5.45 18.48 4.42 17.51 3.85ZM9.25004 5.75C9.25004 5.34 9.59004 5 10 5C10.41 5 10.75 5.34 10.75 5.75V11C10.75 11.41 10.41 11.75 10 11.75C9.59004 11.75 9.25004 11.41 9.25004 11V5.75ZM10.92 14.63C10.87 14.75 10.8 14.86 10.71 14.96C10.52 15.15 10.27 15.25 10 15.25C9.87004 15.25 9.74004 15.22 9.62004 15.17C9.49004 15.12 9.39004 15.05 9.29004 14.96C9.20004 14.86 9.13004 14.75 9.07004 14.63C9.02004 14.51 9.00004 14.38 9.00004 14.25C9.00004 13.99 9.10004 13.73 9.29004 13.54C9.39004 13.45 9.49004 13.38 9.62004 13.33C9.99004 13.17 10.43 13.26 10.71 13.54C10.8 13.64 10.87 13.74 10.92 13.87C10.97 13.99 11 14.12 11 14.25C11 14.38 10.97 14.51 10.92 14.63Z"
      fill="#DB4343"
    />
  </Icon>
);

export const EllipsisHorizontalIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 13.5C5.17157 13.5 4.5 12.8284 4.5 12C4.5 11.1716 5.17157 10.5 6 10.5C6.82843 10.5 7.5 11.1716 7.5 12C7.5 12.8284 6.82843 13.5 6 13.5ZM12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12C13.5 12.8284 12.8284 13.5 12 13.5ZM18 13.5C17.1716 13.5 16.5 12.8284 16.5 12C16.5 11.1716 17.1716 10.5 18 10.5C18.8284 10.5 19.5 11.1716 19.5 12C19.5 12.8284 18.8284 13.5 18 13.5Z"
      fill="#0F172A"
    />
  </Icon>
);

export const AgencyAccountIcon = (props?: IconProps) => (
  <Icon
    width="32px"
    height="40px"
    viewBox="0 0 32 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.74987 9C7.74987 4.44365 11.4435 0.75 15.9999 0.75C20.5562 0.75 24.2499 4.44365 24.2499 9C24.2499 13.5563 20.5562 17.25 15.9999 17.25C11.4435 17.25 7.74987 13.5563 7.74987 9Z"
      fill="#0F172A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.877158 34.8598C1.01895 26.6285 7.73518 20 15.9999 20C24.2648 20 30.9811 26.6289 31.1226 34.8604C31.132 35.4063 30.8175 35.906 30.3212 36.1337C25.9599 38.135 21.1085 39.25 16.0005 39.25C10.892 39.25 6.04017 38.1348 1.67846 36.1331C1.18224 35.9054 0.867755 35.4057 0.877158 34.8598Z"
      fill="#0F172A"
    />
  </Icon>
);

export const WalletIconWithGreenBg = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#A8EEAA"
    />
    <path
      d="M28 16C28 14.3431 26.6569 13 25 13H20C20 15.2091 18.2091 17 16 17C13.7909 17 12 15.2091 12 13H7C5.34315 13 4 14.3431 4 16M28 16V24C28 25.6568 26.6569 27 25 27H7C5.34315 27 4 25.6568 4 24V16M28 16V12M4 16V12M28 12C28 10.3431 26.6569 8.99998 25 8.99998H7C5.34315 8.99998 4 10.3431 4 12M28 12V7.99998C28 6.34313 26.6569 4.99998 25 4.99998H7C5.34315 4.99998 4 6.34313 4 7.99998V12"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const WalletIconWithTealBg = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28 16C28 14.3431 26.6569 13 25 13H20C20 15.2091 18.2091 17 16 17C13.7909 17 12 15.2091 12 13H7C5.34315 13 4 14.3431 4 16M28 16V24C28 25.6568 26.6569 27 25 27H7C5.34315 27 4 25.6568 4 24V16M28 16V12M4 16V12M28 12C28 10.3431 26.6569 8.99999 25 8.99999H7C5.34315 8.99999 4 10.3431 4 12M28 12V7.99999C28 6.34313 26.6569 4.99999 25 4.99999H7C5.34315 4.99999 4 6.34313 4 7.99999V12"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const WalletIconWithPurpleBg = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#CDBEFA"
    />
    <path
      d="M28 16C28 14.3431 26.6569 13 25 13H20C20 15.2091 18.2092 17 16 17C13.7909 17 12 15.2091 12 13H7.00002C5.34317 13 4.00002 14.3431 4.00002 16M28 16V24C28 25.6569 26.6569 27 25 27H7.00002C5.34317 27 4.00002 25.6569 4.00002 24V16M28 16V12M4.00002 16V12M28 12C28 10.3431 26.6569 9 25 9H7.00002C5.34317 9 4.00002 10.3431 4.00002 12M28 12V8C28 6.34315 26.6569 5 25 5H7.00002C5.34317 5 4.00002 6.34315 4.00002 8V12"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowUpRightIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.75 16.25L16.25 3.75M16.25 3.75L6.875 3.75M16.25 3.75V13.125"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowDownRightIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.28033 5.21967C5.98744 4.92678 5.51256 4.92678 5.21967 5.21967C4.92678 5.51256 4.92678 5.98744 5.21967 6.28033L12.4393 13.5H6.75C6.33579 13.5 6 13.8358 6 14.25C6 14.6642 6.33579 15 6.75 15H14.25C14.3517 15 14.4487 14.9798 14.5371 14.9431C14.6235 14.9073 14.7047 14.8547 14.7754 14.7852C14.7787 14.782 14.782 14.7787 14.7852 14.7754C14.8547 14.7047 14.9073 14.6235 14.9431 14.5371C14.9798 14.4487 15 14.3517 15 14.25V6.75C15 6.33579 14.6642 6 14.25 6C13.8358 6 13.5 6.33579 13.5 6.75V12.4393L6.28033 5.21967Z"
      fill="white"
    />
  </Icon>
);

export const PlusIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 3.75V16.25M16.25 10L3.75 10"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const PlusDarkIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3.125C10.3452 3.125 10.625 3.40482 10.625 3.75V9.375H16.25C16.5952 9.375 16.875 9.65482 16.875 10C16.875 10.3452 16.5952 10.625 16.25 10.625H10.625V16.25C10.625 16.5952 10.3452 16.875 10 16.875C9.65482 16.875 9.375 16.5952 9.375 16.25V10.625H3.75C3.40482 10.625 3.125 10.3452 3.125 10C3.125 9.65482 3.40482 9.375 3.75 9.375H9.375V3.75C9.375 3.40482 9.65482 3.125 10 3.125Z"
      fill="#0F172A"
    />
  </Icon>
);

export const GreenPlusIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.75 4.75C10.75 4.33579 10.4142 4 10 4C9.58579 4 9.25 4.33579 9.25 4.75V9.25H4.75C4.33579 9.25 4 9.58579 4 10C4 10.4142 4.33579 10.75 4.75 10.75L9.25 10.75V15.25C9.25 15.6642 9.58579 16 10 16C10.4142 16 10.75 15.6642 10.75 15.25V10.75L15.25 10.75C15.6642 10.75 16 10.4142 16 10C16 9.58579 15.6642 9.25 15.25 9.25H10.75V4.75Z"
      fill="#009F06"
    />
  </Icon>
);

export const EyeOpenMiniIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.9533 9.20415C18.2067 9.55942 18.3334 9.73705 18.3334 10C18.3334 10.2629 18.2067 10.4406 17.9533 10.7958C16.8149 12.3921 13.9077 15.8333 10 15.8333C6.09234 15.8333 3.1851 12.3921 2.04672 10.7958C1.79337 10.4406 1.66669 10.2629 1.66669 10C1.66669 9.73705 1.79336 9.55942 2.04672 9.20415C3.1851 7.60787 6.09234 4.16666 10 4.16666C13.9077 4.16666 16.8149 7.60786 17.9533 9.20415Z"
      stroke="#334448"
      strokeWidth="1.5"
    />
    <path
      d="M12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5C11.3807 12.5 12.5 11.3807 12.5 10Z"
      stroke="#334448"
      strokeWidth="1.5"
    />
  </Icon>
);

export const ArrowTrendingUpWithBgIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#E0E3E6"
    />
    <path
      d="M3 24L12 15L17.7419 20.7419C19.3468 17.5841 22.0056 14.9364 25.4937 13.3834L29.1479 11.7564M29.1479 11.7564L21.2262 8.71556M29.1479 11.7564L26.107 19.6781"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const HumansIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#E0E3E6"
    />
    <path
      d="M20 25.5034C21.1106 25.8267 22.285 26 23.4999 26C25.4716 26 27.3367 25.5435 28.9952 24.7304C28.9983 24.654 28.9999 24.5772 28.9999 24.5C28.9999 21.4624 26.5375 19 23.4999 19C21.6092 19 19.9414 19.954 18.9514 21.4069M20 25.5034V25.5C20 24.0161 19.6198 22.6211 18.9514 21.4069M20 25.5034C20 25.5509 19.9996 25.5984 19.9988 25.6458C17.5165 27.1403 14.6086 28 11.5 28C8.39137 28 5.48352 27.1403 3.00123 25.6458C3.00041 25.5973 3 25.5487 3 25.5C3 20.8056 6.80558 17 11.5 17C14.7106 17 17.5054 18.78 18.9514 21.4069M16 8.5C16 10.9853 13.9853 13 11.5 13C9.01472 13 7 10.9853 7 8.5C7 6.01472 9.01472 4 11.5 4C13.9853 4 16 6.01472 16 8.5ZM27 11.5C27 13.433 25.433 15 23.5 15C21.567 15 20 13.433 20 11.5C20 9.567 21.567 8 23.5 8C25.433 8 27 9.567 27 11.5Z"
      stroke="#0F172A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowUpGreenIcon = (props: IconProps) => (
  <Icon
    width="17px"
    height="16px"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.49999 13.6C8.16862 13.6 7.89999 13.3314 7.89999 13L7.89999 4.48966L4.73249 7.81586C4.50281 8.05473 4.12298 8.06218 3.88412 7.8325C3.64526 7.60282 3.63781 7.223 3.86749 6.98413L8.06749 2.58413C8.18061 2.46649 8.33678 2.4 8.49999 2.4C8.6632 2.4 8.81936 2.46649 8.93249 2.58413L13.1325 6.98413C13.3622 7.223 13.3547 7.60282 13.1159 7.8325C12.877 8.06217 12.4972 8.05473 12.2675 7.81586L9.09999 4.48966L9.09999 13C9.09999 13.3314 8.83136 13.6 8.49999 13.6Z"
      fill="#2C974A"
    />
  </Icon>
);

export const ArrowDownRedIcon = (props: IconProps) => (
  <Icon
    width="17px"
    height="16px"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.50001 2.4C8.83138 2.4 9.10001 2.66863 9.10001 3L9.10001 11.5103L12.2675 8.18414C12.4972 7.94527 12.877 7.93783 13.1159 8.1675C13.3547 8.39718 13.3622 8.777 13.1325 9.01587L8.93251 13.4159C8.81939 13.5335 8.66322 13.6 8.50001 13.6C8.3368 13.6 8.18064 13.5335 8.06751 13.4159L3.86751 9.01587C3.63784 8.777 3.64528 8.39718 3.88415 8.1675C4.12301 7.93783 4.50284 7.94527 4.73251 8.18414L7.90001 11.5103L7.90001 3C7.90001 2.66863 8.16864 2.4 8.50001 2.4Z"
      fill="#911D11"
    />
  </Icon>
);

export const ArrowRightIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="18px"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9697 0.96967C11.2626 0.676777 11.7374 0.676777 12.0303 0.96967L19.5303 8.46967C19.671 8.61032 19.75 8.80109 19.75 9C19.75 9.19891 19.671 9.38968 19.5303 9.53033L12.0303 17.0303C11.7374 17.3232 11.2626 17.3232 10.9697 17.0303C10.6768 16.7374 10.6768 16.2626 10.9697 15.9697L17.1893 9.75H1C0.585786 9.75 0.25 9.41421 0.25 9C0.25 8.58579 0.585786 8.25 1 8.25H17.1893L10.9697 2.03033C10.6768 1.73744 10.6768 1.26256 10.9697 0.96967Z"
      fill="#0F172A"
    />
  </Icon>
);

export const RectangleGroupWithBgIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#E0E3E6"
    />
    <path
      d="M3 9.49998C3 8.67156 3.67157 7.99998 4.5 7.99998H12.5C13.3284 7.99998 14 8.67156 14 9.49998V14.5C14 15.3284 13.3284 16 12.5 16H4.5C3.67157 16 3 15.3284 3 14.5V9.49998Z"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 11.5C19 10.6716 19.6716 9.99998 20.5 9.99998H27.5C28.3284 9.99998 29 10.6716 29 11.5V22.5C29 23.3284 28.3284 24 27.5 24H20.5C19.6716 24 19 23.3284 19 22.5V11.5Z"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 21.5C5 20.6716 5.67157 20 6.5 20H13.5C14.3284 20 15 20.6716 15 21.5V24.5C15 25.3284 14.3284 26 13.5 26H6.5C5.67157 26 5 25.3284 5 24.5V21.5Z"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const InformationCircleOutlineIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.375 9.375L9.40957 9.35771C9.88717 9.11891 10.4249 9.55029 10.2954 10.0683L9.70458 12.4317C9.57507 12.9497 10.1128 13.3811 10.5904 13.1423L10.625 13.125M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 6.875H10.0063V6.88125H10V6.875Z"
      stroke="#656B76"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const InformationCircleIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM11 6C11 6.55228 10.5523 7 10 7C9.44771 7 9 6.55228 9 6C9 5.44772 9.44771 5 10 5C10.5523 5 11 5.44772 11 6ZM9 9C8.58579 9 8.25 9.33579 8.25 9.75C8.25 10.1642 8.58579 10.5 9 10.5H9.25338C9.41332 10.5 9.53213 10.6481 9.49743 10.8042L9.03829 12.8704C8.79542 13.9633 9.62706 15 10.7466 15H11C11.4142 15 11.75 14.6642 11.75 14.25C11.75 13.8358 11.4142 13.5 11 13.5H10.7466C10.5867 13.5 10.4679 13.3519 10.5026 13.1958L10.9617 11.1296C11.2046 10.0367 10.3729 9 9.25338 9H9Z"
    />
  </Icon>
);

export const PresentationChartWithBgIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#E0E3E6"
    />
    <path
      d="M5 4V19C5 20.6569 6.34315 22 8 22H11M5 4H3M5 4H27M27 4H29M27 4V19C27 20.6569 25.6569 22 24 22H21M11 22H21M11 22L9.66667 26M21 22L22.3333 26M22.3333 26L23 28M22.3333 26H9.66667M9.66667 26L9 28M10 16L14 12L16.8635 14.8635C18.2056 12.9373 19.9605 11.3203 22 10.1405"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ChartPieWithBgIcon = (props: IconProps) => (
  <Icon
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#E0E3E6"
    />
    <path
      d="M14 8C8.47718 8 4.00003 12.4772 4.00003 18C4.00003 23.5228 8.47718 28 14 28C19.5229 28 24 23.5228 24 18H14V8Z"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 14H28C28 8.47715 23.5229 4 18 4V14Z"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const QueueListWithBgIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#E0E3E6"
    />
    <path
      d="M5 16H27M5 21H27M5 26H27M7.5 6H24.5C25.8807 6 27 7.11929 27 8.5C27 9.88071 25.8807 11 24.5 11H7.5C6.11929 11 5 9.88071 5 8.5C5 7.11929 6.11929 6 7.5 6Z"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const AngleRightGreenIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.83 11.29L10.59 7.05001C10.497 6.95628 10.3864 6.88189 10.2646 6.83112C10.1427 6.78035 10.012 6.75421 9.88 6.75421C9.74799 6.75421 9.61729 6.78035 9.49543 6.83112C9.37357 6.88189 9.26297 6.95628 9.17 7.05001C8.98375 7.23737 8.87921 7.49082 8.87921 7.75501C8.87921 8.0192 8.98375 8.27265 9.17 8.46001L12.71 12L9.17 15.54C8.98375 15.7274 8.87921 15.9808 8.87921 16.245C8.87921 16.5092 8.98375 16.7626 9.17 16.95C9.26344 17.0427 9.37426 17.116 9.4961 17.1658C9.61794 17.2155 9.7484 17.2408 9.88 17.24C10.0116 17.2408 10.1421 17.2155 10.2639 17.1658C10.3857 17.116 10.4966 17.0427 10.59 16.95L14.83 12.71C14.9237 12.617 14.9981 12.5064 15.0489 12.3846C15.0997 12.2627 15.1258 12.132 15.1258 12C15.1258 11.868 15.0997 11.7373 15.0489 11.6154C14.9981 11.4936 14.9237 11.383 14.83 11.29Z"
      fill="#009F06"
    />
  </Icon>
);

export const InflowIcon = (props: IconProps) => (
  <Icon
    width="36px"
    height="36px"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="1" y="1" width="34" height="34" rx="17" fill="#EBFFF0" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.6919 11.3081C24.936 11.5521 24.936 11.9479 24.6919 12.1919L13.2589 23.625L21.125 23.625C21.4702 23.625 21.75 23.9048 21.75 24.25C21.75 24.5952 21.4702 24.875 21.125 24.875L11.75 24.875C11.4048 24.875 11.125 24.5952 11.125 24.25L11.125 14.875C11.125 14.5298 11.4048 14.25 11.75 14.25C12.0952 14.25 12.375 14.5298 12.375 14.875L12.375 22.7411L23.8081 11.3081C24.0521 11.064 24.4479 11.064 24.6919 11.3081Z"
      fill="#149138"
    />
    <rect
      x="1"
      y="1"
      width="34"
      height="34"
      rx="17"
      stroke="white"
      strokeWidth="2"
    />
  </Icon>
);

export const OutflowIcon = (props: IconProps) => (
  <Icon
    width="36px"
    height="36px"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="1" y="1" width="34" height="34" rx="17" fill="#F0EBFF" />
    <path
      d="M11.75 24.25L24.25 11.75M24.25 11.75L14.875 11.75M24.25 11.75V21.125"
      stroke="#351691"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="1"
      y="1"
      width="34"
      height="34"
      rx="17"
      stroke="white"
      strokeWidth="2"
    />
  </Icon>
);

export const RectangleStackWithBgIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#E0E3E6"
    />
    <path
      d="M8 9.17071V8C8 6.34315 9.34315 5 11 5H21C22.6569 5 24 6.34315 24 8V9.17071M8 9.17071C8.31278 9.06015 8.64936 9 9 9H23C23.3506 9 23.6872 9.06015 24 9.17071M8 9.17071C6.83481 9.58254 6 10.6938 6 12V13.1707M24 9.17071C25.1652 9.58254 26 10.6938 26 12V13.1707M26 13.1707C25.6872 13.0602 25.3506 13 25 13H7C6.64936 13 6.31278 13.0602 6 13.1707M26 13.1707C27.1652 13.5825 28 14.6938 28 16V24C28 25.6569 26.6569 27 25 27H7C5.34315 27 4 25.6569 4 24V16C4 14.6938 4.83481 13.5825 6 13.1707"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ClockOutlineIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 6V12H16.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="#F3F7FF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const BoltWithBgIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#E0E3E6"
    />
    <path
      d="M5 18L19 3L16 14H27L13 29L16 18H5Z"
      stroke="#0F172A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const BoltWithOrangeBgIcon = (props: IconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#EFC9B6"
    />
    <path
      d="M5 18L19 3L16 14H27L13 29L16 18H5Z"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowRightOnRectangleWithBgIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#E0E3E6"
    />
    <path
      d="M21 12V7C21 5.34315 19.6569 4 18 4L10 4C8.34315 4 7 5.34315 7 7L7 25C7 26.6569 8.34315 28 10 28H18C19.6569 28 21 26.6569 21 25V20M25 20L29 16M29 16L25 12M29 16L12 16"
      stroke="#0F172A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const PlusOutlineIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 6V26M26 16L6 16"
      stroke="#0F172A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const LineStrokeIcon = (props: IconProps) => (
  <Icon
    width="2px"
    height="26px"
    viewBox="0 0 2 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M1 1V25" stroke="#1A1C1F" strokeLinecap="round" />
  </Icon>
);

export const GreyEllipseIcon = (props: IconProps) => (
  <Icon
    width="26px"
    height="26px"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="13" cy="13" r="13" fill="#EBEDEF" />
  </Icon>
);

export const MiniDocumentTextIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.20005 3.19995C5.87457 3.19995 4.80005 4.27447 4.80005 5.59995V26.4C4.80005 27.7254 5.87457 28.7999 7.20005 28.7999H24.8001C26.1255 28.7999 27.2001 27.7254 27.2001 26.4V12.1941C27.2001 11.5575 26.9472 10.9471 26.4971 10.497L19.903 3.90289C19.4529 3.45281 18.8425 3.19995 18.2059 3.19995H7.20005ZM10.8 16.8C10.1373 16.8 9.60005 17.3372 9.60005 18C9.60005 18.6627 10.1373 19.2 10.8 19.2H21.2001C21.8628 19.2 22.4001 18.6627 22.4001 18C22.4001 17.3372 21.8628 16.8 21.2001 16.8H10.8ZM10.8 21.6C10.1373 21.6 9.60005 22.1372 9.60005 22.7999C9.60005 23.4627 10.1373 24 10.8 24H21.2001C21.8628 24 22.4001 23.4627 22.4001 22.7999C22.4001 22.1372 21.8628 21.6 21.2001 21.6H10.8Z"
      fill="#0F172A"
    />
  </Icon>
);

export const CloudArrowUpIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 16.5L12 9.75M12 9.75L15 12.75M12 9.75L9 12.75M6.75 19.5C4.26472 19.5 2.25 17.4853 2.25 15C2.25 13.0071 3.54555 11.3167 5.3404 10.7252C5.28105 10.4092 5.25 10.0832 5.25 9.75C5.25 6.85051 7.60051 4.5 10.5 4.5C12.9312 4.5 14.9765 6.1526 15.5737 8.39575C15.8654 8.30113 16.1767 8.25 16.5 8.25C18.1569 8.25 19.5 9.59315 19.5 11.25C19.5 11.5981 19.4407 11.9324 19.3316 12.2433C20.7453 12.7805 21.75 14.1479 21.75 15.75C21.75 17.8211 20.0711 19.5 18 19.5H6.75Z"
      stroke="#656B76"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const GreenBarDashIcon = (props: IconProps) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="260px"
    height="8px"
    viewBox="0 0 260 8"
    fill="none"
    {...props}
  >
    <path d="M0 4H260" stroke="#14CC52" strokeWidth="8" />
  </Icon>
);

export const UserGroup = (props: IconProps) => (
  <Icon
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="40" height="40" rx="20" fill="#1A1C1F" />
    <path
      d="M19.9998 19.1999C21.3253 19.1999 22.3998 18.1254 22.3998 16.7999C22.3998 15.4744 21.3253 14.3999 19.9998 14.3999C18.6743 14.3999 17.5998 15.4744 17.5998 16.7999C17.5998 18.1254 18.6743 19.1999 19.9998 19.1999Z"
      fill="white"
    />
    <path
      d="M16.7998 18.3999C16.7998 19.2836 16.0835 19.9999 15.1998 19.9999C14.3161 19.9999 13.5998 19.2836 13.5998 18.3999C13.5998 17.5162 14.3161 16.7999 15.1998 16.7999C16.0835 16.7999 16.7998 17.5162 16.7998 18.3999Z"
      fill="white"
    />
    <path
      d="M13.1923 24.2604C13.0567 24.1816 12.952 24.0573 12.9058 23.9074C12.8369 23.6837 12.7998 23.4461 12.7998 23.1999C12.7998 21.8744 13.8743 20.7999 15.1998 20.7999C15.6174 20.7999 16.0101 20.9066 16.3521 21.0941C15.5144 21.919 14.9551 23.0259 14.8276 24.2613C14.8092 24.4394 14.8169 24.6152 14.8478 24.7846C14.2483 24.7324 13.6867 24.5478 13.1923 24.2604Z"
      fill="white"
    />
    <path
      d="M25.1522 24.7846C25.7515 24.7323 26.313 24.5478 26.8073 24.2604C26.943 24.1816 27.0476 24.0573 27.0938 23.9074C27.1627 23.6837 27.1998 23.4461 27.1998 23.1999C27.1998 21.8744 26.1253 20.7999 24.7998 20.7999C24.3823 20.7999 23.9897 20.9065 23.6477 21.094C24.4855 21.9189 25.0448 23.0259 25.1723 24.2613C25.1907 24.4394 25.183 24.6152 25.1522 24.7846Z"
      fill="white"
    />
    <path
      d="M26.3998 18.3999C26.3998 19.2836 25.6835 19.9999 24.7998 19.9999C23.9161 19.9999 23.1998 19.2836 23.1998 18.3999C23.1998 17.5162 23.9161 16.7999 24.7998 16.7999C25.6835 16.7999 26.3998 17.5162 26.3998 18.3999Z"
      fill="white"
    />
    <path
      d="M16.2429 24.9526C16.0836 24.8084 15.9992 24.5982 16.0212 24.3844C16.2291 22.3705 17.9311 20.7999 19.9999 20.7999C22.0688 20.7999 23.7708 22.3705 23.9786 24.3845C24.0007 24.5982 23.9163 24.8084 23.757 24.9526C22.7634 25.852 21.4457 26.3999 19.9999 26.3999C18.5542 26.3999 17.2364 25.852 16.2429 24.9526Z"
      fill="white"
    />
  </Icon>
);

export const SettingsIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0779 2.25C10.1613 2.25 9.37909 2.91265 9.22841 3.81675L9.04974 4.88873C9.02959 5.00964 8.93542 5.1498 8.75311 5.23747C8.40905 5.40292 8.07967 5.5938 7.7674 5.8076C7.60091 5.92159 7.43259 5.9332 7.31769 5.89015L6.29851 5.50833C5.44019 5.18678 4.4752 5.53289 4.01692 6.32666L3.09493 7.92358C2.63665 8.71736 2.8194 9.72611 3.52704 10.3087L4.36756 11.0006C4.46219 11.0785 4.53629 11.2298 4.52119 11.4307C4.50706 11.6188 4.49988 11.8086 4.49988 12C4.49988 12.1915 4.50707 12.3814 4.52121 12.5695C4.53632 12.7704 4.46221 12.9217 4.36758 12.9996L3.52704 13.6916C2.8194 14.2741 2.63665 15.2829 3.09493 16.0767L4.01692 17.6736C4.4752 18.4674 5.44019 18.8135 6.29851 18.4919L7.31791 18.11C7.43281 18.067 7.60113 18.0786 7.76761 18.1925C8.07982 18.4063 8.40913 18.5971 8.75311 18.7625C8.93542 18.8502 9.02959 18.9904 9.04974 19.1113L9.22841 20.1832C9.37909 21.0874 10.1613 21.75 11.0779 21.75H12.9219C13.8384 21.75 14.6207 21.0874 14.7713 20.1832L14.95 19.1113C14.9702 18.9904 15.0643 18.8502 15.2466 18.7625C15.5907 18.5971 15.9201 18.4062 16.2324 18.1924C16.3988 18.0784 16.5672 18.0668 16.6821 18.1098L17.7012 18.4917C18.5596 18.8132 19.5246 18.4671 19.9828 17.6733L20.9048 16.0764C21.3631 15.2826 21.1804 14.2739 20.4727 13.6913L19.6322 12.9994C19.5376 12.9215 19.4635 12.7702 19.4786 12.5693C19.4927 12.3812 19.4999 12.1914 19.4999 12C19.4999 11.8085 19.4927 11.6186 19.4785 11.4305C19.4634 11.2296 19.5375 11.0783 19.6322 11.0004L20.4727 10.3084C21.1804 9.72587 21.3631 8.71711 20.9048 7.92334L19.9828 6.32642C19.5246 5.53264 18.5596 5.18654 17.7012 5.50809L16.6818 5.89C16.5669 5.93304 16.3986 5.92144 16.2321 5.80746C15.9199 5.59371 15.5906 5.40289 15.2466 5.23747C15.0643 5.1498 14.9702 5.00964 14.95 4.88873L14.7713 3.81675C14.6207 2.91265 13.8384 2.25 12.9219 2.25H11.0779ZM12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75Z"
      fill="#0F172A"
    />
  </Icon>
);

export const CheckCircleIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM13.8566 8.19113C14.1002 7.85614 14.0261 7.38708 13.6911 7.14345C13.3561 6.89982 12.8871 6.97388 12.6434 7.30887L9.15969 12.099L7.28033 10.2197C6.98744 9.92678 6.51256 9.92678 6.21967 10.2197C5.92678 10.5126 5.92678 10.9874 6.21967 11.2803L8.71967 13.7803C8.87477 13.9354 9.08999 14.0149 9.30867 13.9977C9.52734 13.9805 9.72754 13.8685 9.85655 13.6911L13.8566 8.19113Z"
      fill="#14CC52"
    />
  </Icon>
);

export const ArrowRightCircleRedIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.625 12.5L13.125 10M13.125 10L10.625 7.5M13.125 10L6.875 10M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
      stroke="#E54839"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowDownTray = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 16.5V18.75C3 19.9926 4.00736 21 5.25 21H18.75C19.9926 21 21 19.9926 21 18.75V16.5M16.5 12L12 16.5M12 16.5L7.5 12M12 16.5V3"
      stroke="#fff"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowUpTray = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 13.75V15.625C2.5 16.6605 3.33947 17.5 4.375 17.5H15.625C16.6605 17.5 17.5 16.6605 17.5 15.625V13.75M6.25 6.25L10 2.5M10 2.5L13.75 6.25M10 2.5L10 13.75"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const DropdownArrow = (props: IconProps) => (
  <Icon
    width="14px"
    height="8px"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 1.00005C13 1.00005 8.58107 6.99999 6.99995 7C5.41884 7.00001 1 1 1 1"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const NotificationDotIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="8" stroke="white" strokeWidth="4" />
  </Icon>
);

export const InputFieldInfoIcon = (props: IconProps) => (
  <Icon
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4001 8.0001C14.4001 11.5347 11.5347 14.4001 8.0001 14.4001C4.46548 14.4001 1.6001 11.5347 1.6001 8.0001C1.6001 4.46548 4.46548 1.6001 8.0001 1.6001C11.5347 1.6001 14.4001 4.46548 14.4001 8.0001ZM8.8001 4.8001C8.8001 5.24193 8.44192 5.6001 8.0001 5.6001C7.55827 5.6001 7.2001 5.24193 7.2001 4.8001C7.2001 4.35827 7.55827 4.0001 8.0001 4.0001C8.44192 4.0001 8.8001 4.35827 8.8001 4.8001ZM7.2001 7.2001C6.86873 7.2001 6.6001 7.46873 6.6001 7.8001C6.6001 8.13147 6.86873 8.4001 7.2001 8.4001H7.4028C7.53075 8.4001 7.6258 8.51858 7.59804 8.64348L7.23073 10.2964C7.03644 11.1707 7.70174 12.0001 8.59739 12.0001H8.8001C9.13147 12.0001 9.4001 11.7315 9.4001 11.4001C9.4001 11.0687 9.13147 10.8001 8.8001 10.8001H8.59739C8.46944 10.8001 8.3744 10.6816 8.40215 10.5567L8.76947 8.9038C8.96376 8.02948 8.29845 7.2001 7.4028 7.2001H7.2001Z"
      fill="#7B828E"
    />
  </Icon>
);

export const UserCircleIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12.5 7.5C12.5 8.88071 11.3807 10 10 10C8.61929 10 7.5 8.88071 7.5 7.5C7.5 6.11929 8.61929 5 10 5C11.3807 5 12.5 6.11929 12.5 7.5ZM10 12C8.04133 12 6.30187 12.9385 5.20679 14.3904C6.39509 15.687 8.1026 16.5 10 16.5C11.8974 16.5 13.6049 15.687 14.7932 14.3904C13.6981 12.9385 11.9587 12 10 12Z"
      fill="#1A1C1F"
    />
  </Icon>
);

export const GreenPlusCircle = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10.75 6.75C10.75 6.33579 10.4142 6 10 6C9.58579 6 9.25 6.33579 9.25 6.75V9.25H6.75C6.33579 9.25 6 9.58579 6 10C6 10.4142 6.33579 10.75 6.75 10.75H9.25V13.25C9.25 13.6642 9.58579 14 10 14C10.4142 14 10.75 13.6642 10.75 13.25V10.75H13.25C13.6642 10.75 14 10.4142 14 10C14 9.58579 13.6642 9.25 13.25 9.25H10.75V6.75Z"
      fill="#009F06"
    />
  </Icon>
);

export const GreyXCircleIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8.28033 7.21967C7.98744 6.92678 7.51256 6.92678 7.21967 7.21967C6.92678 7.51256 6.92678 7.98744 7.21967 8.28033L8.93934 10L7.21967 11.7197C6.92678 12.0126 6.92678 12.4874 7.21967 12.7803C7.51256 13.0732 7.98744 13.0732 8.28033 12.7803L10 11.0607L11.7197 12.7803C12.0126 13.0732 12.4874 13.0732 12.7803 12.7803C13.0732 12.4874 13.0732 12.0126 12.7803 11.7197L11.0607 10L12.7803 8.28033C13.0732 7.98744 13.0732 7.51256 12.7803 7.21967C12.4874 6.92678 12.0126 6.92678 11.7197 7.21967L10 8.93934L8.28033 7.21967Z"
      fill="#C9CFD4"
    />
  </Icon>
);

export const UTurnWithBgIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#F2B230"
    />
    <path
      d="M20 20L28 12M28 12L20 4M28 12H12C7.58172 12 4 15.5817 4 20C4 24.4183 7.58172 28 12 28H16"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const UTurnRightIcon = (props: IconProps) => (
  <Icon
    width="36px"
    height="36px"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="1" y="1" width="34" height="34" rx="17" fill="#FFF8EB" />
    <path
      d="M20.5 20.5L25.5 15.5M25.5 15.5L20.5 10.5M25.5 15.5H15.5C12.7386 15.5 10.5 17.7386 10.5 20.5C10.5 23.2614 12.7386 25.5 15.5 25.5H18"
      stroke="#996B0F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="1"
      y="1"
      width="34"
      height="34"
      rx="17"
      stroke="white"
      strokeWidth="2"
    />
  </Icon>
);

export const UTurnRightWithYellowBgIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#F2B230"
    />
    <path
      d="M20 20L28 12M28 12L20 4M28 12H12C7.58172 12 4 15.5817 4 20C4 24.4183 7.58172 28 12 28H16"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const BettingDepositIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.7503 15.625H6.25034M13.7503 15.625C15.131 15.625 16.2503 16.7443 16.2503 18.125H3.75034C3.75034 16.7443 4.86962 15.625 6.25034 15.625M13.7503 15.625V12.8125C13.7503 12.2947 13.3306 11.875 12.8128 11.875H12.0865M6.25034 15.625V12.8125C6.25034 12.2947 6.67007 11.875 7.18784 11.875H7.9142M12.0865 11.875H7.9142M12.0865 11.875C11.6304 11.0865 11.3416 10.1892 11.2686 9.23144M7.9142 11.875C8.37031 11.0865 8.65911 10.1892 8.73207 9.23144M4.37534 3.5303C3.55675 3.64933 2.74647 3.79396 1.94531 3.96334C2.32057 6.18624 4.16278 7.91068 6.44171 8.10646M4.37534 3.5303V3.75C4.37534 5.50648 5.18042 7.07493 6.44171 8.10646M4.37534 3.5303V2.26741C6.21319 2.00876 8.09114 1.875 10.0003 1.875C11.9095 1.875 13.7875 2.00876 15.6253 2.26741V3.5303M6.44171 8.10646C7.09802 8.64321 7.87786 9.03459 8.73207 9.23144M15.6253 3.5303V3.75C15.6253 5.50648 14.8203 7.07493 13.559 8.10646M15.6253 3.5303C16.4439 3.64933 17.2542 3.79396 18.0554 3.96334C17.6801 6.18624 15.8379 7.91068 13.559 8.10646M13.559 8.10646C12.9026 8.64321 12.1228 9.03459 11.2686 9.23144M11.2686 9.23144C10.861 9.32537 10.4365 9.375 10.0003 9.375C9.56421 9.375 9.13967 9.32537 8.73207 9.23144"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const LoansIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.875 5.3125C16.875 7.21098 13.797 8.75 10 8.75C6.20304 8.75 3.125 7.21098 3.125 5.3125M16.875 5.3125C16.875 3.41402 13.797 1.875 10 1.875C6.20304 1.875 3.125 3.41402 3.125 5.3125M16.875 5.3125V14.6875C16.875 16.586 13.797 18.125 10 18.125C6.20304 18.125 3.125 16.586 3.125 14.6875V5.3125M16.875 5.3125V8.4375M3.125 5.3125V8.4375M16.875 8.4375V11.5625C16.875 13.461 13.797 15 10 15C6.20304 15 3.125 13.461 3.125 11.5625V8.4375M16.875 8.4375C16.875 10.336 13.797 11.875 10 11.875C6.20304 11.875 3.125 10.336 3.125 8.4375"
      stroke="#1A1C1F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ReceiptPercentIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 14.25L15 8.25M19.5 4.75699V21.75L15.75 20.25L12 21.75L8.25 20.25L4.5 21.75V4.75699C4.5 3.649 5.30608 2.70014 6.40668 2.57241C8.24156 2.35947 10.108 2.25 12 2.25C13.892 2.25 15.7584 2.35947 17.5933 2.57241C18.6939 2.70014 19.5 3.649 19.5 4.75699ZM9.75 9H9.7575V9.0075H9.75V9ZM10.125 9C10.125 9.20711 9.95711 9.375 9.75 9.375C9.54289 9.375 9.375 9.20711 9.375 9C9.375 8.79289 9.54289 8.625 9.75 8.625C9.95711 8.625 10.125 8.79289 10.125 9ZM14.25 13.5H14.2575V13.5075H14.25V13.5ZM14.625 13.5C14.625 13.7071 14.4571 13.875 14.25 13.875C14.0429 13.875 13.875 13.7071 13.875 13.5C13.875 13.2929 14.0429 13.125 14.25 13.125C14.4571 13.125 14.625 13.2929 14.625 13.5Z"
      stroke="#0F172A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const SingleTransferIcon = () => (
  <Icon
    width="44px"
    height="44px"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0277 3.15273C21.5647 2.61576 22.4353 2.61576 22.9723 3.15273L28.4723 8.65273C29.0092 9.1897 29.0092 10.0603 28.4723 10.5973C27.9353 11.1342 27.0647 11.1342 26.5277 10.5973L23.375 7.44454L23.375 13.75H20.625V7.44454L17.4723 10.5973C16.9353 11.1342 16.0647 11.1342 15.5277 10.5973C14.9908 10.0603 14.9908 9.1897 15.5277 8.65273L21.0277 3.15273Z"
      fill="#0F172A"
    />
    <path
      d="M20.625 13.75L20.625 27.5C20.625 28.2594 21.2406 28.875 22 28.875C22.7594 28.875 23.375 28.2594 23.375 27.5V13.75H30.25C33.2876 13.75 35.75 16.2124 35.75 19.25V35.75C35.75 38.7876 33.2876 41.25 30.25 41.25H13.75C10.7124 41.25 8.25 38.7876 8.25 35.75V19.25C8.25 16.2124 10.7124 13.75 13.75 13.75H20.625Z"
      fill="#0F172A"
    />
  </Icon>
);

export const MultipleTransfersIcon = () => (
  <Icon
    width="44px"
    height="44px"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.2777 1.77773C18.8147 1.24076 19.6853 1.24076 20.2223 1.77773L25.7223 7.27773C26.2592 7.8147 26.2592 8.6853 25.7223 9.22227C25.1853 9.75924 24.3147 9.75924 23.7777 9.22227L20.625 6.06954V12.375H17.875V6.06954L14.7223 9.22227C14.1853 9.75924 13.3147 9.75924 12.7777 9.22227C12.2408 8.6853 12.2408 7.8147 12.7777 7.27773L18.2777 1.77773Z"
      fill="#0F172A"
    />
    <path
      d="M17.875 12.375V23.375C17.875 24.1344 18.4906 24.75 19.25 24.75C20.0094 24.75 20.625 24.1344 20.625 23.375V12.375H26.125C29.1626 12.375 31.625 14.8374 31.625 17.875V31.625C31.625 34.6626 29.1626 37.125 26.125 37.125H12.375C9.33743 37.125 6.875 34.6626 6.875 31.625V17.875C6.875 14.8374 9.33743 12.375 12.375 12.375H17.875Z"
      fill="#0F172A"
    />
    <path
      d="M13.1108 39.875C14.0618 41.519 15.8393 42.625 17.875 42.625H31.625C34.6626 42.625 37.125 40.1626 37.125 37.125V23.375C37.125 21.3393 36.019 19.5618 34.375 18.6108V31.625C34.375 36.1814 30.6814 39.875 26.125 39.875H13.1108Z"
      fill="#0F172A"
    />
  </Icon>
);

export const CheckIcon = () => (
  <Icon
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.375 9.5625L7.875 14.0625L14.625 3.9375"
      stroke="#009F06"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ExclamationCircleIcon = ({ fill = '#FFAA08' }) => (
  <Icon
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1998 8.99999C16.1998 12.9764 12.9763 16.2 8.9998 16.2C5.02335 16.2 1.7998 12.9764 1.7998 8.99999C1.7998 5.02354 5.02335 1.79999 8.9998 1.79999C12.9763 1.79999 16.1998 5.02354 16.1998 8.99999ZM8.9998 4.49999C9.3726 4.49999 9.67481 4.8022 9.67481 5.17499V9.22499C9.67481 9.59778 9.3726 9.89999 8.9998 9.89999C8.62701 9.89999 8.3248 9.59778 8.3248 9.22499V5.17499C8.3248 4.8022 8.62701 4.49999 8.9998 4.49999ZM8.9998 13.5C9.49686 13.5 9.89981 13.097 9.89981 12.6C9.89981 12.1029 9.49686 11.7 8.9998 11.7C8.50275 11.7 8.0998 12.1029 8.0998 12.6C8.0998 13.097 8.50275 13.5 8.9998 13.5Z"
      fill={fill}
    />
  </Icon>
);

export const ExclamationCircleOutlineIcon = ({ stroke = '#DB4343' }) => (
  <Icon
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 6V8.5M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM8 10.5H8.005V10.505H8V10.5Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const LimitInformationIcon = () => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.6 12C21.6 17.302 17.3019 21.6 12 21.6C6.69806 21.6 2.39999 17.302 2.39999 12C2.39999 6.69809 6.69806 2.40002 12 2.40002C17.3019 2.40002 21.6 6.69809 21.6 12ZM13.2 7.20002C13.2 7.86277 12.6627 8.40002 12 8.40002C11.3373 8.40002 10.8 7.86277 10.8 7.20002C10.8 6.53728 11.3373 6.00002 12 6.00002C12.6627 6.00002 13.2 6.53728 13.2 7.20002ZM10.8 10.8C10.3029 10.8 9.89999 11.203 9.89999 11.7C9.89999 12.1971 10.3029 12.6 10.8 12.6H11.1041C11.296 12.6 11.4385 12.7778 11.3969 12.9651L10.8459 15.4445C10.5545 16.7559 11.5525 18 12.8959 18H13.2C13.6971 18 14.1 17.5971 14.1 17.1C14.1 16.603 13.6971 16.2 13.2 16.2H12.8959C12.704 16.2 12.5614 16.0223 12.6031 15.8349L13.154 13.3556C13.4455 12.0441 12.4475 10.8 11.1041 10.8H10.8Z"
      fill="#200769"
    />
  </Icon>
);

export const DropdownIcon = () => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5303 16.2803C12.2374 16.5732 11.7626 16.5732 11.4697 16.2803L3.96967 8.78033C3.67678 8.48744 3.67678 8.01256 3.96967 7.71967C4.26256 7.42678 4.73744 7.42678 5.03033 7.71967L12 14.6893L18.9697 7.71967C19.2626 7.42678 19.7374 7.42678 20.0303 7.71967C20.3232 8.01256 20.3232 8.48744 20.0303 8.78033L12.5303 16.2803Z"
      fill="#0F172A"
    />
  </Icon>
);

export const EditIcon = () => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.03685 1.94272C7.40945 1.53904 7.59575 1.3372 7.7937 1.21946C8.27135 0.93538 8.85955 0.926545 9.3452 1.19616C9.54645 1.3079 9.73845 1.50406 10.1225 1.89638C10.5066 2.2887 10.6986 2.48486 10.808 2.69046C11.0719 3.18656 11.0633 3.7874 10.7852 4.27535C10.6699 4.47758 10.4723 4.66789 10.0772 5.0485L5.3753 9.57715C4.62644 10.2985 4.252 10.6591 3.78403 10.8419C3.31606 11.0247 2.8016 11.0112 1.77268 10.9843L1.63269 10.9806C1.31946 10.9724 1.16284 10.9683 1.0718 10.865C0.980751 10.7617 0.993181 10.6022 1.01804 10.2831L1.03154 10.1098C1.10151 9.21175 1.13649 8.76275 1.31186 8.3591C1.48722 7.95545 1.78972 7.62775 2.39472 6.97225L7.03685 1.94272Z"
      stroke="#1A1C1F"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 2L10 5.5"
      stroke="#1A1C1F"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M7 11H11"
      stroke="#1A1C1F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CumulativeLimitInfoIcon = () => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.375 9.375L9.40957 9.35771C9.88717 9.11891 10.4249 9.55029 10.2954 10.0683L9.70458 12.4317C9.57507 12.9497 10.1128 13.3811 10.5904 13.1423L10.625 13.125M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 6.875H10.0063V6.88125H10V6.875Z"
      stroke="#1A1C1F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const UserDarkIcon = (props: IconProps) => (
  <Icon
    width="44px"
    height="44px"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="44" height="44" rx="22" fill="#1A1C1F" />
    <path
      d="M22 20C23.6569 20 25 18.6569 25 17C25 15.3431 23.6569 14 22 14C20.3431 14 19 15.3431 19 17C19 18.6569 20.3431 20 22 20Z"
      fill="white"
    />
    <path
      d="M15.4652 26.4935C15.2703 27.0016 15.4443 27.571 15.8742 27.9046C17.5666 29.218 19.692 30 22.0001 30C24.3106 30 26.438 29.2164 28.1312 27.9006C28.5608 27.5667 28.7345 26.9971 28.5393 26.4892C27.5301 23.8635 24.9842 22 22.0031 22C19.0203 22 16.4733 23.8656 15.4652 26.4935Z"
      fill="white"
    />
  </Icon>
);

export const CubeIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.3779 1.60217C12.1444 1.46594 11.8556 1.46594 11.6221 1.60217L3 6.63172L12 11.8817L21 6.63172L12.3779 1.60217Z"
      fill="currentColor"
    />
    <path
      d="M21.75 7.93078L12.75 13.1808V22.1808L21.3779 17.1478C21.6083 17.0134 21.75 16.7668 21.75 16.5V7.93078Z"
      fill="currentColor"
    />
    <path
      d="M11.25 22.1808V13.1808L2.25 7.93078V16.5C2.25 16.7668 2.39168 17.0134 2.6221 17.1478L11.25 22.1808Z"
      fill="currentColor"
    />
  </Icon>
);

export const PaperAirplaneIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_10762_50810)">
      <path
        d="M15.0714 26.0002L6.00098 17.5723C14.9206 15.3811 24.0345 14.7839 32.9526 15.6761C29.2663 23.8454 24.1922 31.4398 17.8349 38.0689L15.0714 26.0002ZM15.0714 26.0002L23.7319 21"
        stroke="#0F172A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_10762_50810">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(0.143555 16.1436) rotate(-30)"
        />
      </clipPath>
    </defs>
  </Icon>
);

export const DarkCheckIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 17L14 25L26 7"
      stroke="#0F172A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const DarkBankNotes = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 25C10.2896 25 17.3515 25.975 24.0623 27.8016C25.0317 28.0655 26 27.3448 26 26.3402V25M5 6V7C5 7.55228 4.55228 8 4 8H3M3 8V7.5C3 6.67157 3.67157 6 4.5 6H27M3 8V20M27 6V7C27 7.55228 27.4477 8 28 8H29M27 6H27.5C28.3284 6 29 6.67157 29 7.5V20.5C29 21.3284 28.3284 22 27.5 22H27M29 20H28C27.4477 20 27 20.4477 27 21V22M27 22H5M5 22H4.5C3.67157 22 3 21.3284 3 20.5V20M5 22V21C5 20.4477 4.55228 20 4 20H3M20 14C20 16.2091 18.2091 18 16 18C13.7909 18 12 16.2091 12 14C12 11.7909 13.7909 10 16 10C18.2091 10 20 11.7909 20 14ZM24 14H24.01V14.01H24V14ZM8 14H8.01V14.01H8V14Z"
      stroke="#0F172A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const LinkedInDarkIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_10601_50855)">
      <path
        d="M19.875 2.625H4.125C3.72718 2.625 3.34564 2.78304 3.06434 3.06434C2.78304 3.34564 2.625 3.72718 2.625 4.125V19.875C2.625 20.2728 2.78304 20.6544 3.06434 20.9357C3.34564 21.217 3.72718 21.375 4.125 21.375H19.875C20.2728 21.375 20.6544 21.217 20.9357 20.9357C21.217 20.6544 21.375 20.2728 21.375 19.875V4.125C21.375 3.72718 21.217 3.34564 20.9357 3.06434C20.6544 2.78304 20.2728 2.625 19.875 2.625ZM9 16.5C9 16.6989 8.92098 16.8897 8.78033 17.0303C8.63968 17.171 8.44891 17.25 8.25 17.25C8.05109 17.25 7.86032 17.171 7.71967 17.0303C7.57902 16.8897 7.5 16.6989 7.5 16.5V10.5C7.5 10.3011 7.57902 10.1103 7.71967 9.96967C7.86032 9.82902 8.05109 9.75 8.25 9.75C8.44891 9.75 8.63968 9.82902 8.78033 9.96967C8.92098 10.1103 9 10.3011 9 10.5V16.5ZM8.25 8.625C8.0275 8.625 7.80999 8.55902 7.62498 8.4354C7.43998 8.31179 7.29578 8.13609 7.21064 7.93052C7.12549 7.72495 7.10321 7.49875 7.14662 7.28052C7.19002 7.06229 7.29717 6.86184 7.4545 6.7045C7.61184 6.54717 7.81229 6.44002 8.03052 6.39662C8.24875 6.35321 8.47495 6.37549 8.68052 6.46064C8.88609 6.54578 9.06179 6.68998 9.1854 6.87498C9.30902 7.05999 9.375 7.2775 9.375 7.5C9.375 7.79837 9.25647 8.08452 9.0455 8.2955C8.83452 8.50647 8.54837 8.625 8.25 8.625ZM17.25 16.5C17.25 16.6989 17.171 16.8897 17.0303 17.0303C16.8897 17.171 16.6989 17.25 16.5 17.25C16.3011 17.25 16.1103 17.171 15.9697 17.0303C15.829 16.8897 15.75 16.6989 15.75 16.5V13.125C15.75 12.6277 15.5525 12.1508 15.2008 11.7992C14.8492 11.4475 14.3723 11.25 13.875 11.25C13.3777 11.25 12.9008 11.4475 12.5492 11.7992C12.1975 12.1508 12 12.6277 12 13.125V16.5C12 16.6989 11.921 16.8897 11.7803 17.0303C11.6397 17.171 11.4489 17.25 11.25 17.25C11.0511 17.25 10.8603 17.171 10.7197 17.0303C10.579 16.8897 10.5 16.6989 10.5 16.5V10.5C10.4995 10.3154 10.567 10.1371 10.6898 9.99926C10.8125 9.86139 10.9817 9.7736 11.1651 9.75271C11.3485 9.73182 11.5331 9.77928 11.6837 9.88603C11.8343 9.99277 11.9402 10.1513 11.9813 10.3312C12.4887 9.98723 13.0803 9.78795 13.6925 9.75481C14.3047 9.72166 14.9144 9.85591 15.4561 10.1431C15.9977 10.4303 16.4509 10.8597 16.767 11.385C17.083 11.9104 17.25 12.5119 17.25 13.125V16.5Z"
        fill="#1A1C1F"
      />
    </g>
    <defs>
      <clipPath id="clip0_10601_50855">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export const InstagramDarkIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_10601_50859)">
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        fill="#1A1C1F"
      />
      <path
        d="M16.125 2.625H7.875C6.48261 2.625 5.14726 3.17812 4.16269 4.16269C3.17812 5.14726 2.625 6.48261 2.625 7.875V16.125C2.625 17.5174 3.17812 18.8527 4.16269 19.8373C5.14726 20.8219 6.48261 21.375 7.875 21.375H16.125C17.5174 21.375 18.8527 20.8219 19.8373 19.8373C20.8219 18.8527 21.375 17.5174 21.375 16.125V7.875C21.375 6.48261 20.8219 5.14726 19.8373 4.16269C18.8527 3.17812 17.5174 2.625 16.125 2.625ZM12 16.5C11.11 16.5 10.24 16.2361 9.49993 15.7416C8.75991 15.2471 8.18314 14.5443 7.84254 13.7221C7.50195 12.8998 7.41283 11.995 7.58647 11.1221C7.7601 10.2492 8.18868 9.44736 8.81802 8.81802C9.44736 8.18868 10.2492 7.7601 11.1221 7.58647C11.995 7.41283 12.8998 7.50195 13.7221 7.84254C14.5443 8.18314 15.2471 8.75991 15.7416 9.49993C16.2361 10.24 16.5 11.11 16.5 12C16.5 13.1935 16.0259 14.3381 15.182 15.182C14.3381 16.0259 13.1935 16.5 12 16.5ZM16.875 8.25C16.6525 8.25 16.435 8.18402 16.25 8.0604C16.065 7.93679 15.9208 7.76109 15.8356 7.55552C15.7505 7.34995 15.7282 7.12375 15.7716 6.90552C15.815 6.68729 15.9222 6.48684 16.0795 6.3295C16.2368 6.17217 16.4373 6.06502 16.6555 6.02162C16.8738 5.97821 17.1 6.00049 17.3055 6.08564C17.5111 6.17078 17.6868 6.31498 17.8104 6.49998C17.934 6.68499 18 6.9025 18 7.125C18 7.42337 17.8815 7.70952 17.6705 7.9205C17.4595 8.13147 17.1734 8.25 16.875 8.25Z"
        fill="#1A1C1F"
      />
    </g>
    <defs>
      <clipPath id="clip0_10601_50859">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export const FacebookDarkIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_10601_50864)">
      <path
        d="M21.7498 12.0007C21.745 14.3828 20.8708 16.6812 19.2913 18.4643C17.7119 20.2475 15.5358 21.3927 13.1717 21.6851C13.119 21.6903 13.0657 21.6845 13.0153 21.6681C12.9649 21.6517 12.9184 21.625 12.8788 21.5898C12.8392 21.5546 12.8073 21.5116 12.7851 21.4634C12.7629 21.4153 12.7509 21.3631 12.7498 21.3101V14.2507H14.9998C15.1024 14.2509 15.2039 14.2301 15.2981 14.1895C15.3923 14.1489 15.4772 14.0894 15.5475 14.0147C15.6178 13.94 15.672 13.8517 15.7068 13.7552C15.7416 13.6588 15.7563 13.5562 15.7498 13.4538C15.7333 13.2599 15.6437 13.0795 15.4993 12.949C15.3549 12.8185 15.1663 12.7476 14.9717 12.7507H12.7498V10.5007C12.7498 10.1029 12.9079 9.72134 13.1892 9.44003C13.4705 9.15873 13.852 9.00069 14.2498 9.00069H15.7498C15.8524 9.00089 15.9539 8.98006 16.0481 8.93947C16.1423 8.89888 16.2272 8.83941 16.2975 8.76472C16.3678 8.69003 16.422 8.60172 16.4568 8.50525C16.4916 8.40877 16.5063 8.30618 16.4998 8.20382C16.4833 8.00988 16.3937 7.82946 16.2493 7.69897C16.1049 7.56847 15.9163 7.49761 15.7217 7.50069H14.2498C13.4542 7.50069 12.6911 7.81676 12.1285 8.37937C11.5659 8.94198 11.2498 9.70504 11.2498 10.5007V12.7507H8.99985C8.89729 12.7505 8.79577 12.7713 8.70158 12.8119C8.60739 12.8525 8.52253 12.912 8.45223 12.9867C8.38194 13.0614 8.32771 13.1497 8.2929 13.2461C8.25809 13.3426 8.24344 13.4452 8.24985 13.5476C8.26644 13.7415 8.35598 13.9219 8.5004 14.0524C8.64481 14.1829 8.83336 14.2538 9.02797 14.2507H11.2498V21.3101C11.2501 21.3626 11.2393 21.4147 11.2182 21.4628C11.197 21.5109 11.166 21.5541 11.1271 21.5894C11.0882 21.6248 11.0423 21.6516 10.9924 21.6681C10.9425 21.6845 10.8897 21.6903 10.8373 21.6851C5.88735 21.0851 2.06235 16.7819 2.25922 11.6351C2.36974 9.0933 3.4694 6.69541 5.32347 4.95323C7.17755 3.21105 9.63917 2.26259 12.1829 2.31031C14.7266 2.35803 17.1509 3.39814 18.9384 5.20863C20.7258 7.01912 21.7347 9.45657 21.7498 12.0007Z"
        fill="#1A1C1F"
      />
    </g>
    <defs>
      <clipPath id="clip0_10601_50864">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export const XDarkIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.8002 3.19995C3.9162 3.19995 3.2002 3.91595 3.2002 4.79995V19.2C3.2002 20.084 3.9162 20.8 4.8002 20.8H19.2002C20.0842 20.8 20.8002 20.084 20.8002 19.2V4.79995C20.8002 3.91595 20.0842 3.19995 19.2002 3.19995H4.8002ZM6.91895 7.19995H10.608L12.7611 10.2781L15.4252 7.19995H16.5861L13.283 11.025L17.3236 16.8H13.6346L11.2455 13.3843L8.29551 16.8H7.11582L10.7205 12.6359L6.91895 7.19995ZM8.70332 8.14683L14.1064 15.8484H15.5377L10.133 8.14683H8.70332Z"
      fill="#1A1C1F"
    />
  </Icon>
);

export const WhatsAppDarkIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.8003 5.7C14.4003 2 9.50027 0.9 5.70027 3.2C2.00027 5.5 0.800268 10.5 3.20027 14.2L3.40027 14.5L2.60027 17.5L5.60027 16.7L5.90027 16.9C7.20027 17.6 8.60027 18 10.0003 18C11.5003 18 13.0003 17.6 14.3003 16.8C18.0003 14.4 19.1003 9.5 16.8003 5.7ZM14.7003 13.4C14.3003 14 13.8003 14.4 13.1003 14.5C12.7003 14.5 12.2003 14.7 10.2003 13.9C8.50027 13.1 7.10027 11.8 6.10027 10.3C5.50027 9.6 5.20027 8.7 5.10027 7.8C5.10027 7 5.40027 6.3 5.90027 5.8C6.10027 5.6 6.30027 5.5 6.50027 5.5H7.00027C7.20027 5.5 7.40027 5.5 7.50027 5.9C7.70027 6.4 8.20027 7.6 8.20027 7.7C8.30027 7.8 8.30027 8 8.20027 8.1C8.30027 8.3 8.20027 8.5 8.10027 8.6C8.00027 8.7 7.90027 8.9 7.80027 9C7.60027 9.1 7.50027 9.3 7.60027 9.5C8.00027 10.1 8.50027 10.7 9.00027 11.2C9.60027 11.7 10.2003 12.1 10.9003 12.4C11.1003 12.5 11.3003 12.5 11.4003 12.3C11.5003 12.1 12.0003 11.6 12.2003 11.4C12.4003 11.2 12.5003 11.2 12.7003 11.3L14.3003 12.1C14.5003 12.2 14.7003 12.3 14.8003 12.4C14.9003 12.7 14.9003 13.1 14.7003 13.4Z"
      fill="black"
    />
  </Icon>
);

export const BulletListIcon = () => (
  <Icon
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00016 12.6668C6.70016 12.6668 5.59738 12.2141 4.69183 11.3085C3.78627 10.4029 3.3335 9.30016 3.3335 8.00016C3.3335 6.70016 3.78627 5.59738 4.69183 4.69183C5.59738 3.78627 6.70016 3.3335 8.00016 3.3335C9.30016 3.3335 10.4029 3.78627 11.3085 4.69183C12.2141 5.59738 12.6668 6.70016 12.6668 8.00016C12.6668 9.30016 12.2141 10.4029 11.3085 11.3085C10.4029 12.2141 9.30016 12.6668 8.00016 12.6668Z"
      fill="#A8EEAA"
    />
  </Icon>
);

export const TrashIcon = () => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7404 9L14.3942 18M9.60577 18L9.25962 9M19.2276 5.79057C19.5696 5.84221 19.9104 5.89747 20.25 5.95629M19.2276 5.79057L18.1598 19.6726C18.0696 20.8448 17.0921 21.75 15.9164 21.75H8.08357C6.90786 21.75 5.93037 20.8448 5.8402 19.6726L4.77235 5.79057M19.2276 5.79057C18.0812 5.61744 16.9215 5.48485 15.75 5.39432M3.75 5.95629C4.08957 5.89747 4.43037 5.84221 4.77235 5.79057M4.77235 5.79057C5.91878 5.61744 7.07849 5.48485 8.25 5.39432M15.75 5.39432V4.47819C15.75 3.29882 14.8393 2.31423 13.6606 2.27652C13.1092 2.25889 12.5556 2.25 12 2.25C11.4444 2.25 10.8908 2.25889 10.3394 2.27652C9.16065 2.31423 8.25 3.29882 8.25 4.47819V5.39432M15.75 5.39432C14.5126 5.2987 13.262 5.25 12 5.25C10.738 5.25 9.48744 5.2987 8.25 5.39432"
      stroke="#E54839"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const VerticalBarIcon = ({ stroke }: { stroke: string }) => (
  <Icon
    width="2px"
    height="66px"
    viewBox="0 0 2 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 1V65" stroke={stroke} strokeWidth="2" strokeLinecap="round" />
  </Icon>
);

export const BriefcaseIcon = () => (
  <Icon
    width="64px"
    height="64px"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.1999 12C19.1999 7.13989 23.1398 3.2 27.9999 3.2H35.9999C40.86 3.2 44.7999 7.13989 44.7999 12V13.4166C46.6304 13.5939 48.4501 13.8088 50.258 14.0605C54.5683 14.6608 57.5999 18.3968 57.5999 22.6247V33.7234C57.5999 37.329 55.3783 40.7364 51.7455 41.8516C45.4991 43.769 38.8677 44.8 31.9999 44.8C25.1321 44.8 18.5007 43.769 12.2543 41.8516C8.62145 40.7364 6.3999 37.329 6.3999 33.7234V22.6247C6.3999 18.3968 9.43149 14.6608 13.7418 14.0605C15.5497 13.8088 17.3694 13.5939 19.1999 13.4166V12ZM39.9999 12V13.04C37.3534 12.8807 34.6859 12.8 31.9999 12.8C29.3139 12.8 26.6464 12.8807 23.9999 13.04V12C23.9999 9.79086 25.7908 8 27.9999 8H35.9999C38.209 8 39.9999 9.79086 39.9999 12ZM31.9999 32C30.2326 32 28.7999 33.4327 28.7999 35.2V35.232C28.7999 36.9993 30.2326 38.432 31.9999 38.432H32.0319C33.7992 38.432 35.2319 36.9993 35.2319 35.232V35.2C35.2319 33.4327 33.7992 32 32.0319 32H31.9999Z"
      fill="#EBEDEF"
    />
    <path
      d="M9.5999 48.1767V45.9885C10.0018 46.1576 10.4172 46.3087 10.8458 46.4402C17.5434 48.4962 24.6494 49.6 31.9999 49.6C39.3504 49.6 46.4564 48.4962 53.154 46.4402C53.5826 46.3087 53.998 46.1576 54.3999 45.9885V48.1767C54.3999 52.4878 51.2491 56.2732 46.838 56.7698C41.9668 57.3182 37.0158 57.5998 31.9999 57.5998C26.984 57.5998 22.033 57.3182 17.1618 56.7698C12.7507 56.2732 9.5999 52.4878 9.5999 48.1767Z"
      fill="#EBEDEF"
    />
  </Icon>
);

export const HeartIcon = (props: IconProps) => (
  <Icon
    {...props}
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.65298 16.9149L9.6476 16.9121L9.62912 16.9024C9.61341 16.8941 9.59102 16.8822 9.56238 16.8667C9.50511 16.8358 9.42281 16.7907 9.31906 16.732C9.11164 16.6146 8.81794 16.4425 8.46663 16.2206C7.76556 15.7777 6.82731 15.1314 5.88539 14.3197C4.04447 12.7332 2 10.3523 2 7.5C2 5.01472 4.01472 3 6.5 3C7.9144 3 9.17542 3.65238 10 4.67158C10.8246 3.65238 12.0856 3 13.5 3C15.9853 3 18 5.01472 18 7.5C18 10.3523 15.9555 12.7332 14.1146 14.3197C13.1727 15.1314 12.2344 15.7777 11.5334 16.2206C11.1821 16.4425 10.8884 16.6146 10.6809 16.732C10.5772 16.7907 10.4949 16.8358 10.4376 16.8667C10.409 16.8822 10.3866 16.8941 10.3709 16.9024L10.3524 16.9121L10.347 16.9149L10.3453 16.9158C10.13 17.03 9.87 17.03 9.65529 16.9161L9.65298 16.9149Z"
      stroke="#1A1C1F"
    />
  </Icon>
);

export const BoltIcon = (props: IconProps) => (
  <Icon
    {...props}
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.74348 1.0633C9.94431 1.17526 10.0429 1.40975 9.98239 1.63158L8.65464 6.50002H13.5C13.6991 6.50002 13.8792 6.61814 13.9586 6.80074C14.0379 6.98335 14.0014 7.19562 13.8655 7.34118L6.86554 14.8412C6.70866 15.0093 6.45736 15.0487 6.25654 14.9367C6.05571 14.8248 5.95713 14.5903 6.01763 14.3685L7.34539 9.50002H2.50001C2.30091 9.50002 2.12079 9.38189 2.04144 9.19929C1.96209 9.01669 1.99863 8.80441 2.13448 8.65886L9.13448 1.15886C9.29137 0.990769 9.54266 0.951339 9.74348 1.0633Z"
      // fill="white"
    />
  </Icon>
);

export const ArrowLeftGreyIcon = (props: IconProps) => (
  <Icon
    width="52px"
    height="52px"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26 0C11.6406 0 0 11.6406 0 26C0 40.3594 11.6406 52 26 52C40.3594 52 52 40.3594 52 26C52 11.6406 40.3594 0 26 0ZM14.5858 24.5858C14.2107 24.9609 14 25.4696 14 26C14 26.5304 14.2107 27.0391 14.5858 27.4142L22.5858 35.4142C23.3668 36.1953 24.6332 36.1953 25.4142 35.4142C26.1953 34.6332 26.1953 33.3668 25.4142 32.5858L20.8284 28H36C37.1046 28 38 27.1046 38 26C38 24.8954 37.1046 24 36 24L20.8284 24L25.4142 19.4142C26.1953 18.6332 26.1953 17.3668 25.4142 16.5858C24.6332 15.8047 23.3668 15.8047 22.5858 16.5858L14.5858 24.5858Z"
      fill="#E0E3E6"
    />
  </Icon>
);

export const TrophyGreyIcon = (props: IconProps) => (
  <Icon
    width="56px"
    height="56px"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.77636 2.9903V5.27626C7.01669 5.67105 4.28575 6.15529 1.58658 6.72595C0.537188 6.94781 -0.150361 7.95799 0.0281838 9.01562C1.38939 17.0788 8.10706 23.3196 16.3977 23.9479C18.4928 25.6588 20.9828 26.9085 23.7109 27.5385C23.4473 30.6538 22.3907 33.5403 20.7435 36H18.7757C16.0142 36 13.7757 38.2386 13.7757 41V48H11.7754C8.46168 48 5.77539 50.6863 5.77539 54C5.77539 55.1046 6.67082 56 7.77539 56H47.7754C48.88 56 49.7754 55.1046 49.7754 54C49.7754 50.6863 47.0891 48 43.7754 48H41.7757V41C41.7757 38.2386 39.5371 36 36.7757 36H34.8065C33.1599 33.5406 32.1039 30.6541 31.8404 27.5389C34.5691 26.9089 37.0596 25.6591 39.155 23.9479C47.4457 23.3196 54.1633 17.0788 55.5245 9.01562C55.7031 7.95799 55.0155 6.94781 53.9661 6.72595C51.267 6.15529 48.536 5.67105 45.7764 5.27626V2.9903C45.7764 1.98143 45.025 1.13051 44.0238 1.00567C38.7004 0.341851 33.2779 0 27.7764 0C22.2749 0 16.8523 0.341851 11.5289 1.00567C10.5278 1.13051 9.77636 1.98143 9.77636 2.9903ZM9.77636 10C9.77636 13.1898 10.607 16.1865 12.0623 18.7846C8.44335 17.1645 5.6367 14.0527 4.42674 10.2317C6.19654 9.88868 7.98005 9.58394 9.77636 9.31834V10ZM45.7764 10V9.31834C47.5727 9.58394 49.3562 9.88868 51.126 10.2317C49.916 14.0527 47.1094 17.1645 43.4904 18.7846C44.9457 16.1865 45.7764 13.1898 45.7764 10Z"
      fill="#E0E3E6"
    />
  </Icon>
);

export const GiftGreyIcon = (props: IconProps) => (
  <Icon
    width="58px"
    height="54px"
    viewBox="0 0 58 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 4C18.2386 4 16 6.23858 16 9C16 11.7614 18.2386 14 21 14H26V26H5C2.23858 26 0 23.7614 0 21V19C0 16.2386 2.23858 14 5 14H13.5155C12.5583 12.5699 12 10.8501 12 9C12 4.02944 16.0294 0 21 0C23.8273 0 26.35 1.30367 28 3.34267C29.65 1.30367 32.1727 0 35 0C39.9706 0 44 4.02944 44 9C44 10.8501 43.4417 12.5699 42.4845 14H53C55.7614 14 58 16.2386 58 19V21C58 23.7614 55.7614 26 53 26H30V14H35C37.7614 14 40 11.7614 40 9C40 6.23858 37.7614 4 35 4C32.2386 4 30 6.23858 30 9V14H26V9C26 6.23858 23.7614 4 21 4Z"
      fill="#E0E3E6"
    />
    <path d="M26 30H4V48C4 51.3137 6.68629 54 10 54H26V30Z" fill="#E0E3E6" />
    <path d="M30 30V54H48C51.3137 54 54 51.3137 54 48V30H30Z" fill="#E0E3E6" />
  </Icon>
);

export const UserMinusGreyIcon = (props: IconProps) => (
  <Icon
    width="64px"
    height="64px"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.6667 6C21.5916 6 16.6667 10.9249 16.6667 17C16.6667 23.0751 21.5916 28 27.6667 28C33.7418 28 38.6667 23.0751 38.6667 17C38.6667 10.9249 33.7418 6 27.6667 6Z"
      fill="#E0E3E6"
    />
    <path
      d="M27.6667 32C17.1733 32 8.66669 40.5066 8.66669 51C8.66669 51.1087 8.66761 51.217 8.66942 51.3251C8.68101 52.0145 9.04685 52.6493 9.63752 53.0049C14.9048 56.1763 21.0758 58 27.6667 58C34.2575 58 40.4286 56.1763 45.6959 53.0049C46.2865 52.6493 46.6524 52.0145 46.6639 51.3252C46.6657 51.2196 46.6666 51.113 46.6667 51.0068V51C46.6667 40.5066 38.1601 32 27.6667 32Z"
      fill="#E0E3E6"
    />
    <path
      d="M42.6667 26C41.5621 26 40.6667 26.8954 40.6667 28C40.6667 29.1046 41.5621 30 42.6667 30H58.6667C59.7713 30 60.6667 29.1046 60.6667 28C60.6667 26.8954 59.7713 26 58.6667 26H42.6667Z"
      fill="#E0E3E6"
    />
  </Icon>
);

export const HeartGreyIcon = (props: IconProps) => (
  <Icon
    width="52px"
    height="48px"
    viewBox="0 0 52 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.0533 47.7617L25.0358 47.7524L24.9754 47.7197C24.924 47.6917 24.8504 47.6514 24.7562 47.5988C24.5678 47.4937 24.2966 47.3398 23.9546 47.1385C23.2707 46.7362 22.3018 46.1437 21.1428 45.3733C18.8286 43.8349 15.7366 41.5736 12.6363 38.6835C6.50083 32.9641 0 24.4669 0 14C0 6.19185 6.5696 0 14.5 0C19.1637 0 23.3395 2.1309 26 5.47092C28.6605 2.1309 32.8363 0 37.5 0C45.4304 0 52 6.19185 52 14C52 24.4669 45.4992 32.9641 39.3637 38.6835C36.2634 41.5736 33.1714 43.8349 30.8572 45.3733C29.6982 46.1437 28.7293 46.7362 28.0454 47.1385C27.7034 47.3398 27.4322 47.4937 27.2438 47.5988C27.1496 47.6514 27.076 47.6917 27.0246 47.7197L26.9642 47.7524L26.9467 47.7617L26.9394 47.7657C26.3528 48.0772 25.6472 48.0772 25.0606 47.7657L25.0533 47.7617Z"
      fill="#E0E3E6"
    />
  </Icon>
);

export const UsersGreyIcon = (props: IconProps) => (
  <Icon
    width="56px"
    height="52px"
    viewBox="0 0 56 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 11C8 4.92487 12.9249 0 19 0C25.0751 0 30 4.92487 30 11C30 17.0751 25.0751 22 19 22C12.9249 22 8 17.0751 8 11Z"
      fill="#E0E3E6"
    />
    <path
      d="M34 17C34 12.0294 38.0294 8 43 8C47.9706 8 52 12.0294 52 17C52 21.9706 47.9706 26 43 26C38.0294 26 34 21.9706 34 17Z"
      fill="#E0E3E6"
    />
    <path
      d="M0 45C0 34.5066 8.50659 26 19 26C29.4934 26 38 34.5066 38 45V45.0068C38 45.113 37.999 45.2196 37.9973 45.3252C37.9857 46.0145 37.6198 46.6493 37.0292 47.0049C31.7619 50.1763 25.5909 52 19 52C12.4091 52 6.23812 50.1763 0.970828 47.0049C0.380167 46.6493 0.0143278 46.0145 0.00273705 45.3251C0.000919342 45.217 0 45.1087 0 45Z"
      fill="#E0E3E6"
    />
    <path
      d="M41.9996 45.0084C41.9995 45.1365 41.9984 45.265 41.9963 45.3924C41.9811 46.2955 41.7633 47.1673 41.3751 47.9519C41.9126 47.9838 42.4542 48 42.9996 48C47.2548 48 51.2855 47.0142 54.8705 45.2567C55.5292 44.9338 55.9582 44.2762 55.9884 43.5432C55.9958 43.363 55.9996 43.1819 55.9996 43C55.9996 35.8203 50.1793 30 42.9996 30C41.0091 30 39.123 30.4474 37.4365 31.2471C40.3026 35.083 41.9996 39.8433 41.9996 45V45.0084Z"
      fill="#E0E3E6"
    />
  </Icon>
);

export const ApprovalBoltIcon = (props: IconProps) => (
  <Icon
    width="200px"
    height="200px"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10910_157977)">
      <path
        d="M134.21 160.9C135.56 160.9 136.65 161.99 136.65 163.34C136.65 164.69 135.56 165.78 134.21 165.78C132.86 165.78 131.77 164.69 131.77 163.34C131.77 161.99 132.86 160.9 134.21 160.9Z"
        stroke="#001419"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M70.57 24L70.55 40.48"
        stroke="#001419"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M78.81 32.26L62.31 32.24"
        stroke="#001419"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M154.987 49.16L156.948 53.1056L161.29 53.7476L158.139 56.8176L158.886 61.16L154.975 59.1056L151.088 61.16L151.812 56.8176L148.66 53.7476L153.026 53.1056L154.964 49.16H154.987Z"
        fill="#6D45E5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.563 34.1012C118.471 35.1649 119.407 37.3925 118.833 39.4998L106.219 85.75H152.25C154.141 85.75 155.853 86.8722 156.606 88.6069C157.36 90.3417 157.013 92.3583 155.723 93.7411L89.2225 164.991C87.7321 166.588 85.3448 166.962 83.437 165.899C81.5292 164.835 80.5926 162.608 81.1674 160.5L93.781 114.25H47.75C45.8585 114.25 44.1474 113.128 43.3935 111.393C42.6397 109.658 42.9869 107.642 44.2775 106.259L110.777 35.009C112.268 33.4122 114.655 33.0376 116.563 34.1012Z"
        fill="#00C707"
      />
      <path
        d="M41.75 115.5L108.25 44.25L94 96.5H146.25L79.75 167.75L94 115.5H41.75Z"
        stroke="#556266"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_10910_157977">
        <rect width="200" height="200" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export const BlackStarIcon = () => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0414 3.4605C12.6561 2.53408 11.3438 2.53408 10.9584 3.4605L8.76148 8.74262L3.05899 9.19979C2.05884 9.27997 1.65329 10.5281 2.4153 11.1808L6.76 14.9025L5.43262 20.4672C5.19982 21.4432 6.26155 22.2146 7.11781 21.6916L11.9999 18.7096L16.8821 21.6916C17.7383 22.2146 18.8001 21.4432 18.5673 20.4672L17.2399 14.9025L21.5846 11.1808C22.3466 10.5281 21.941 9.27997 20.9409 9.19979L15.2384 8.74262L13.0414 3.4605Z"
      fill="#1A1C1F"
    />
  </Icon>
);

export const SparklesIcon = () => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.1769 2.16466C19.0647 1.60375 18.5722 1.2 18.0002 1.2C17.4282 1.2 16.9357 1.60375 16.8235 2.16466L16.5373 3.59573C16.4423 4.07076 16.071 4.44208 15.5959 4.53709L14.1649 4.8233C13.6039 4.93548 13.2002 5.42798 13.2002 6C13.2002 6.57201 13.6039 7.06451 14.1649 7.17669L15.5959 7.46291C16.071 7.55791 16.4423 7.92923 16.5373 8.40426L16.8235 9.83534C16.9357 10.3962 17.4282 10.8 18.0002 10.8C18.5722 10.8 19.0647 10.3962 19.1769 9.83534L19.4631 8.40426C19.5581 7.92923 19.9294 7.55791 20.4045 7.46291L21.8355 7.17669C22.3964 7.06451 22.8002 6.57201 22.8002 6C22.8002 5.42798 22.3964 4.93548 21.8355 4.8233L20.4045 4.53709C19.9294 4.44208 19.5581 4.07076 19.4631 3.59573L19.1769 2.16466Z"
      fill="#1A1C1F"
    />
    <path
      d="M8.33861 6.82052C8.17528 6.33051 7.71671 6 7.20019 6C6.68368 6 6.22511 6.33051 6.06178 6.82052L5.24125 9.2821C5.12181 9.64043 4.84063 9.92161 4.4823 10.041L2.02072 10.8616C1.53071 11.0249 1.2002 11.4835 1.2002 12C1.2002 12.5165 1.53071 12.9751 2.02072 13.1384L4.4823 13.9589C4.84063 14.0784 5.12181 14.3596 5.24125 14.7179L6.06178 17.1795C6.22511 17.6695 6.68368 18 7.20019 18C7.71671 18 8.17528 17.6695 8.33861 17.1795L9.15914 14.7179C9.27858 14.3596 9.55976 14.0784 9.91809 13.9589L12.3797 13.1384C12.8697 12.9751 13.2002 12.5165 13.2002 12C13.2002 11.4835 12.8697 11.0249 12.3797 10.8616L9.91809 10.041C9.55976 9.92161 9.27858 9.64043 9.15914 9.2821L8.33861 6.82052Z"
      fill="#1A1C1F"
    />
    <path
      d="M16.7386 16.4205C16.5753 15.9305 16.1167 15.6 15.6002 15.6C15.0837 15.6 14.6251 15.9305 14.4618 16.4205L14.2412 17.0821C14.1218 17.4404 13.8406 17.7216 13.4823 17.841L12.8207 18.0616C12.3307 18.2249 12.0002 18.6835 12.0002 19.2C12.0002 19.7165 12.3307 20.1751 12.8207 20.3384L13.4823 20.5589C13.8406 20.6784 14.1218 20.9596 14.2412 21.3179L14.4618 21.9795C14.6251 22.4695 15.0837 22.8 15.6002 22.8C16.1167 22.8 16.5753 22.4695 16.7386 21.9795L16.9591 21.3179C17.0786 20.9596 17.3598 20.6784 17.7181 20.5589L18.3797 20.3384C18.8697 20.1751 19.2002 19.7165 19.2002 19.2C19.2002 18.6835 18.8697 18.2249 18.3797 18.0616L17.7181 17.841C17.3598 17.7216 17.0786 17.4404 16.9591 17.0821L16.7386 16.4205Z"
      fill="#1A1C1F"
    />
  </Icon>
);

export const IdentificationWithBgIcon = () => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 12H25M20 16H25M20 20H25M6 26H26C27.6569 26 29 24.6569 29 23V9C29 7.34315 27.6569 6 26 6H6C4.34315 6 3 7.34315 3 9V23C3 24.6569 4.34315 26 6 26ZM14 12.5C14 13.8807 12.8807 15 11.5 15C10.1193 15 9 13.8807 9 12.5C9 11.1193 10.1193 10 11.5 10C12.8807 10 14 11.1193 14 12.5ZM15.7252 20.9485C14.4653 21.6196 13.0269 22 11.4998 22C9.97264 22 8.53432 21.6196 7.27441 20.9485C7.90648 19.2277 9.55977 18 11.4998 18C13.4398 18 15.0931 19.2277 15.7252 20.9485Z"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowLeftWithBgIcon = () => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="16" fill="#EBEDEF" />
    <path
      d="M24 16H8M8 16L16 24M8 16L16 8"
      stroke="#656B76"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const UserGroupWithBgIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 14.4C18.6509 14.4 20.8 12.251 20.8 9.60005C20.8 6.94908 18.6509 4.80005 16 4.80005C13.349 4.80005 11.2 6.94908 11.2 9.60005C11.2 12.251 13.349 14.4 16 14.4Z"
      fill="#0F172A"
    />
    <path
      d="M9.59998 12.8C9.59998 14.5674 8.16729 16 6.39998 16C4.63266 16 3.19998 14.5674 3.19998 12.8C3.19998 11.0327 4.63266 9.60005 6.39998 9.60005C8.16729 9.60005 9.59998 11.0327 9.59998 12.8Z"
      fill="#0F172A"
    />
    <path
      d="M2.38501 24.5211C2.11368 24.3634 1.90432 24.1149 1.81192 23.815C1.67415 23.3677 1.59998 22.8925 1.59998 22.4C1.59998 19.7491 3.74901 17.6 6.39998 17.6C7.23518 17.6 8.02056 17.8134 8.70461 18.1885C7.02924 19.8382 5.91059 22.0521 5.65563 24.5228C5.61886 24.8791 5.63421 25.2307 5.69591 25.5695C4.49695 25.4649 3.37376 25.0959 2.38501 24.5211Z"
      fill="#0F172A"
    />
    <path
      d="M26.3047 25.5694C27.5034 25.4648 28.6264 25.0958 29.6149 24.5211C29.8863 24.3634 30.0956 24.1149 30.188 23.815C30.3258 23.3677 30.4 22.8925 30.4 22.4C30.4 19.7491 28.2509 17.6 25.6 17.6C24.7649 17.6 23.9797 17.8133 23.2958 18.1882C24.9713 19.838 26.09 22.052 26.345 24.5228C26.3818 24.8791 26.3664 25.2307 26.3047 25.5694Z"
      fill="#0F172A"
    />
    <path
      d="M28.8 12.8C28.8 14.5674 27.3673 16 25.6 16C23.8327 16 22.4 14.5674 22.4 12.8C22.4 11.0327 23.8327 9.60005 25.6 9.60005C27.3673 9.60005 28.8 11.0327 28.8 12.8Z"
      fill="#0F172A"
    />
    <path
      d="M8.48611 25.9055C8.16754 25.6171 7.99873 25.1966 8.04284 24.7691C8.45849 20.7413 11.8625 17.6 16.0002 17.6C20.1379 17.6 23.5419 20.7413 23.9576 24.7692C24.0017 25.1966 23.8329 25.6171 23.5143 25.9055C21.5272 27.7043 18.8917 28.8 16.0002 28.8C13.1087 28.8 10.4732 27.7043 8.48611 25.9055Z"
      fill="#0F172A"
    />
  </Icon>
);

export const ProfileIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.6 11.9999C21.6 17.3018 17.3019 21.5999 12 21.5999C6.69806 21.5999 2.39999 17.3018 2.39999 11.9999C2.39999 6.69797 6.69806 2.3999 12 2.3999C17.3019 2.3999 21.6 6.69797 21.6 11.9999ZM15 8.9999C15 10.6568 13.6568 11.9999 12 11.9999C10.3431 11.9999 8.99999 10.6568 8.99999 8.9999C8.99999 7.34305 10.3431 5.9999 12 5.9999C13.6568 5.9999 15 7.34305 15 8.9999ZM12 14.3999C9.64959 14.3999 7.56224 15.5261 6.24814 17.2684C7.6741 18.8243 9.72312 19.7999 12 19.7999C14.2769 19.7999 16.3259 18.8243 17.7518 17.2684C16.4377 15.5261 14.3504 14.3999 12 14.3999Z"
      fill="#0F172A"
    />
  </Icon>
);

export const MiniBriefcaseIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="21px"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 4.25C6 2.73122 7.23122 1.5 8.75 1.5H11.25C12.7688 1.5 14 2.73122 14 4.25V4.69269C14.572 4.74808 15.1407 4.81524 15.7057 4.89392C17.0526 5.08149 18 6.24901 18 7.57023V11.0386C18 12.1653 17.3058 13.2301 16.1705 13.5786C14.2185 14.1778 12.1462 14.5 10 14.5C7.8538 14.5 5.78149 14.1778 3.82951 13.5786C2.69423 13.2301 2 12.1653 2 11.0386V7.57023C2 6.24901 2.94737 5.08149 4.29435 4.89392C4.85933 4.81524 5.42796 4.74808 6 4.69269V4.25ZM12.5 4.25V4.57499C11.673 4.52523 10.8394 4.5 10 4.5C9.16061 4.5 8.32704 4.52523 7.5 4.57499V4.25C7.5 3.55964 8.05964 3 8.75 3H11.25C11.9404 3 12.5 3.55964 12.5 4.25ZM10 10.5C9.44772 10.5 9 10.9477 9 11.5V11.51C9 12.0623 9.44772 12.51 10 12.51H10.01C10.5623 12.51 11.01 12.0623 11.01 11.51V11.5C11.01 10.9477 10.5623 10.5 10.01 10.5H10Z"
      fill="#0F172A"
    />
    <path
      d="M3 15.5552V14.8714C3.1256 14.9243 3.25542 14.9715 3.38933 15.0126C5.48234 15.6551 7.70295 16 10 16C12.297 16 14.5177 15.6551 16.6107 15.0126C16.7446 14.9715 16.8744 14.9243 17 14.8714V15.5552C17 16.9024 16.0154 18.0854 14.6369 18.2406C13.1147 18.4119 11.5675 18.4999 10 18.4999C8.43253 18.4999 6.88533 18.4119 5.36311 18.2406C3.98461 18.0854 3 16.9024 3 15.5552Z"
      fill="#0F172A"
    />
  </Icon>
);

export const TagIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#50555E"
    />
    <ellipse
      cx="2"
      cy="2"
      rx="2"
      ry="2"
      transform="matrix(1 0 0 -1 21.3333 10.667)"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.69896 14.8586C2.36144 16.3524 2.33266 18.6061 3.56021 20.1916C5.99614 23.3377 8.66231 26.0038 11.8084 28.4398C13.3939 29.6673 15.6476 29.6385 17.1414 28.301C21.1972 24.6696 24.9114 20.8745 28.4958 16.7039C28.8502 16.2916 29.0719 15.7862 29.1216 15.2448C29.3416 12.8506 29.7936 5.95289 27.9203 4.07965C26.0471 2.2064 19.1493 2.65835 16.7552 2.87834C16.2137 2.92809 15.7084 3.14976 15.2961 3.50414C11.1255 7.0886 7.3304 10.8028 3.69896 14.8586Z"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M9.33334 18.667L13.3333 22.667"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const InputCheckIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="24" height="24" rx="12" fill="#1A1C1F" />
    <path
      d="M7.01103 12.2945L10.1409 15.4241L16.989 8.57593"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const Airplane02Icon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.33332 7.91668L4.39608 3.7297C4.04753 3.35374 4.10335 3.07912 4.5144 2.84136C5.2871 2.3944 5.88907 2.38227 6.70356 2.82925L10.7908 5.07228C11.0818 5.23196 11.3671 5.39382 11.6667 5.48212"
      stroke={String(props.stroke ?? '#1A1C1F')}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4167 11.386L12.1752 17.058C12.3188 17.5213 12.5717 17.6052 12.9634 17.3806C13.6997 16.9584 13.9965 16.4708 14.0164 15.5922L14.1162 11.1832C14.1295 10.5943 14.1271 10.0179 14.5833 9.58334"
      stroke={String(props.stroke ?? '#1A1C1F')}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.94037 9.15355L8.51279 8.00463L12.1971 5.31851L12.2007 5.31587L12.2083 5.31029C12.3017 5.24197 13.5932 4.30109 14.3265 3.97984C15.2304 3.58388 16.0724 3.76796 16.9783 4.02095C17.4468 4.15181 17.6811 4.21723 17.8501 4.3393C18.1183 4.53297 18.2927 4.83106 18.3286 5.15709C18.3512 5.36258 18.2915 5.59549 18.1721 6.06131C17.9412 6.96192 17.6818 7.77348 16.8823 8.34792C16.2336 8.81405 14.7618 9.44736 14.6555 9.49286L14.6468 9.49656L14.6427 9.49833L10.4431 11.3037L8.64852 12.073C7.99783 12.3519 7.67249 12.4914 7.45115 12.7502C6.93276 13.3563 6.85956 14.4531 6.66608 15.2078C6.55916 15.6249 5.97289 16.3475 5.45048 16.2391C5.12795 16.1721 5.12176 15.7683 5.08162 15.5109L4.69516 13.0324C4.60274 12.4397 4.59565 12.4275 4.12165 12.0522L2.13963 10.4827C1.93376 10.3197 1.58251 10.1125 1.68499 9.80341C1.85098 9.30274 2.77839 9.16308 3.19788 9.28024C3.95694 9.49223 4.95621 9.97812 5.74736 9.83818C6.08515 9.77843 6.37022 9.57013 6.94036 9.15355L6.94037 9.15355Z"
      stroke={String(props.stroke ?? '#1A1C1F')}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const FlightPassengersIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.9999 15.5993C15.2062 15.6163 15.4148 15.625 15.6255 15.625C16.4991 15.625 17.3378 15.4756 18.1175 15.201C18.1228 15.1347 18.1255 15.0677 18.1255 15C18.1255 13.6193 17.0062 12.5 15.6255 12.5C15.1025 12.5 14.617 12.6606 14.2156 12.9352M14.9999 15.5993C15 15.6079 15 15.6164 15 15.625C15 15.8125 14.9897 15.9976 14.9696 16.1797C13.5056 17.0197 11.8089 17.5 10 17.5C8.19111 17.5 6.49439 17.0197 5.03042 16.1797C5.01032 15.9976 5 15.8125 5 15.625C5 15.6165 5.00002 15.6079 5.00006 15.5994M14.9999 15.5993C14.995 14.6188 14.7079 13.7051 14.2156 12.9352M14.2156 12.9352C13.3273 11.546 11.7712 10.625 10 10.625C8.22899 10.625 6.67304 11.5458 5.78474 12.9347M5.78474 12.9347C5.38352 12.6604 4.8983 12.5 4.37561 12.5C2.9949 12.5 1.87561 13.6193 1.87561 15C1.87561 15.0677 1.8783 15.1347 1.88358 15.201C2.66327 15.4756 3.502 15.625 4.37561 15.625C4.5859 15.625 4.79416 15.6163 5.00006 15.5994M5.78474 12.9347C5.29225 13.7047 5.00499 14.6187 5.00006 15.5994M12.5 5.625C12.5 7.00571 11.3807 8.125 10 8.125C8.61929 8.125 7.5 7.00571 7.5 5.625C7.5 4.24429 8.61929 3.125 10 3.125C11.3807 3.125 12.5 4.24429 12.5 5.625ZM17.5 8.125C17.5 9.16053 16.6605 10 15.625 10C14.5895 10 13.75 9.16053 13.75 8.125C13.75 7.08947 14.5895 6.25 15.625 6.25C16.6605 6.25 17.5 7.08947 17.5 8.125ZM6.25 8.125C6.25 9.16053 5.41053 10 4.375 10C3.33947 10 2.5 9.16053 2.5 8.125C2.5 7.08947 3.33947 6.25 4.375 6.25C5.41053 6.25 6.25 7.08947 6.25 8.125Z"
      stroke="#1A1C1F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const FlightTagIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="1.25"
      cy="1.25"
      r="1.25"
      transform="matrix(1 0 0 -1 13.3333 6.66685)"
      stroke="#141B34"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.31186 9.28661C1.47591 10.2202 1.45792 11.6288 2.22514 12.6197C3.7476 14.5861 5.41395 16.2524 7.38027 17.7749C8.37117 18.5421 9.77976 18.5241 10.7134 17.6881C13.2482 15.4185 15.5696 13.0466 17.8099 10.44C18.0314 10.1823 18.1699 9.86641 18.201 9.52803C18.3385 8.03166 18.621 3.72057 17.4502 2.54979C16.2794 1.37901 11.9683 1.66148 10.472 1.79898C10.1336 1.83007 9.81774 1.96861 9.56004 2.1901C6.95344 4.43039 4.58151 6.75176 2.31186 9.28661Z"
      stroke="#141B34"
      strokeWidth="1.5"
    />
    <path
      d="M5.83335 11.6669L8.33335 14.1669"
      stroke="#141B34"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const DocumentCheckIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.125 2.25H5.625C5.00368 2.25 4.5 2.75368 4.5 3.375V20.625C4.5 21.2463 5.00368 21.75 5.625 21.75H18.375C18.9963 21.75 19.5 21.2463 19.5 20.625V11.625M10.125 2.25H10.5C15.4706 2.25 19.5 6.27944 19.5 11.25V11.625M10.125 2.25C11.989 2.25 13.5 3.76104 13.5 5.625V7.125C13.5 7.74632 14.0037 8.25 14.625 8.25H16.125C17.989 8.25 19.5 9.76104 19.5 11.625M9 15L11.25 17.25L15 12"
      stroke="#0F172A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const SwitcherIcon = (props: IconProps) => (
  <Icon
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#1A1C1F" />
    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#EBEDEF" />
    <path
      d="M15.5 29L11 24.5M11 24.5L15.5 20M11 24.5H24.5M24.5 11L29 15.5M29 15.5L24.5 20M29 15.5L15.5 15.5"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const SwitcherGhostIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 21L3 16.5M3 16.5L7.5 12M3 16.5H16.5M16.5 3L21 7.5M21 7.5L16.5 12M21 7.5L7.5 7.5"
      stroke="#7B828E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CalendarDaysIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.75 3V5.25M17.25 3V5.25M3 18.75V7.5C3 6.25736 4.00736 5.25 5.25 5.25H18.75C19.9926 5.25 21 6.25736 21 7.5V18.75M3 18.75C3 19.9926 4.00736 21 5.25 21H18.75C19.9926 21 21 19.9926 21 18.75M3 18.75V11.25C3 10.0074 4.00736 9 5.25 9H18.75C19.9926 9 21 10.0074 21 11.25V18.75M12 12.75H12.0075V12.7575H12V12.75ZM12 15H12.0075V15.0075H12V15ZM12 17.25H12.0075V17.2575H12V17.25ZM9.75 15H9.7575V15.0075H9.75V15ZM9.75 17.25H9.7575V17.2575H9.75V17.25ZM7.5 15H7.5075V15.0075H7.5V15ZM7.5 17.25H7.5075V17.2575H7.5V17.25ZM14.25 12.75H14.2575V12.7575H14.25V12.75ZM14.25 15H14.2575V15.0075H14.25V15ZM14.25 17.25H14.2575V17.2575H14.25V17.25ZM16.5 12.75H16.5075V12.7575H16.5V12.75ZM16.5 15H16.5075V15.0075H16.5V15Z"
      stroke="#0F172A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const GiftTopIcon = (props: IconProps) => (
  <Icon
    width="22px"
    height="18px"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 0.75V17.25M1.25 9H20.75M5.375 14.25C8.06739 14.25 10.25 12.0674 10.25 9.375V9M16.625 14.25C13.9326 14.25 11.75 12.0674 11.75 9.375V9M2.75 17.25H19.25C20.0784 17.25 20.75 16.5784 20.75 15.75V2.25C20.75 1.42157 20.0784 0.75 19.25 0.75H2.75C1.92157 0.75 1.25 1.42157 1.25 2.25V15.75C1.25 16.5784 1.92157 17.25 2.75 17.25ZM15.3713 7.81069C13.9623 9.2197 11.1286 8.87135 11.1286 8.87135C11.1286 8.87135 10.7803 6.03772 12.1893 4.62871C13.068 3.75003 14.4926 3.75003 15.3713 4.62871C16.2499 5.50739 16.2499 6.93201 15.3713 7.81069ZM9.77297 4.62874C11.182 6.03775 10.8336 8.87138 10.8336 8.87138C10.8336 8.87138 8 9.21973 6.59099 7.81072C5.71231 6.93204 5.71231 5.50742 6.59099 4.62874C7.46967 3.75006 8.89429 3.75006 9.77297 4.62874Z"
      stroke="#0F172A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const SearchWhiteIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 3.75C6.77208 3.75 3.75 6.77208 3.75 10.5C3.75 14.2279 6.77208 17.25 10.5 17.25C12.3642 17.25 14.0506 16.4953 15.273 15.273C16.4953 14.0506 17.25 12.3642 17.25 10.5C17.25 6.77208 14.2279 3.75 10.5 3.75ZM2.25 10.5C2.25 5.94365 5.94365 2.25 10.5 2.25C15.0563 2.25 18.75 5.94365 18.75 10.5C18.75 12.5078 18.032 14.3491 16.8399 15.7793L21.5303 20.4697C21.8232 20.7626 21.8232 21.2374 21.5303 21.5303C21.2374 21.8232 20.7626 21.8232 20.4697 21.5303L15.7793 16.8399C14.3491 18.032 12.5078 18.75 10.5 18.75C5.94365 18.75 2.25 15.0563 2.25 10.5Z"
      fill="white"
    />
  </Icon>
);

export const FlightTimelineIcon = (props: IconProps) => (
  <Icon
    width="404"
    height="16"
    viewBox="0 0 404 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.333333 8C0.333333 9.47276 1.52724 10.6667 3 10.6667C4.47276 10.6667 5.66667 9.47276 5.66667 8C5.66667 6.52724 4.47276 5.33333 3 5.33333C1.52724 5.33333 0.333333 6.52724 0.333333 8ZM186 8.5C186.276 8.5 186.5 8.27614 186.5 8C186.5 7.72386 186.276 7.5 186 7.5V8.5ZM3 8.5H186V7.5H3V8.5Z"
      fill="#D4D9DD"
    />
    <path
      d="M202.913 13.3667L204.253 10.2533L204.547 9.56C204.6 9.45334 204.74 9.36 204.86 9.36H206.9C207.54 9.36 208.3 8.88667 208.593 8.31334C208.693 8.11334 208.693 7.87334 208.593 7.67334C208.3 7.10667 207.533 6.63334 206.893 6.63334H204.853C204.733 6.63334 204.593 6.54 204.54 6.43334L202.907 2.63334C202.733 2.21334 202.207 1.87334 201.753 1.87334H200.873C200.307 1.87334 200.027 2.3 200.253 2.82667L201.693 6.16667C201.807 6.42667 201.667 6.64 201.38 6.64H200.64H199.44C199.287 6.64 199.067 6.55334 198.96 6.44667L197.407 4.9C197.247 4.74 196.933 4.66667 196.707 4.74L195.8 5.04C195.407 5.16 195.22 5.60667 195.407 5.97334L196.74 7.56C196.947 7.8 196.947 8.19334 196.74 8.43334L195.407 10.02C195.227 10.3867 195.407 10.8333 195.8 10.9667L196.707 11.2667C196.927 11.34 197.247 11.2667 197.407 11.1067L198.96 9.56C199.067 9.44667 199.287 9.36 199.44 9.36H201.38C201.667 9.36 201.8 9.56667 201.693 9.83334L200.253 13.1733C200.027 13.7 200.307 14.1267 200.873 14.1267H201.753C202.207 14.1267 202.733 13.7867 202.913 13.3667Z"
      fill="#1A1C1F"
    />
    <path
      d="M218 7.5C217.724 7.5 217.5 7.72386 217.5 8C217.5 8.27614 217.724 8.5 218 8.5V7.5ZM398.333 8C398.333 9.47276 399.527 10.6667 401 10.6667C402.473 10.6667 403.667 9.47276 403.667 8C403.667 6.52724 402.473 5.33333 401 5.33333C399.527 5.33333 398.333 6.52724 398.333 8ZM218 8.5H401V7.5H218V8.5Z"
      fill="#D4D9DD"
    />
  </Icon>
);

export const FlightTimelineMiniIcon = (props: IconProps) => (
  <Icon
    width="110px"
    height="16px"
    viewBox="0 0 110 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.333333 8C0.333333 9.47276 1.52724 10.6667 3 10.6667C4.47276 10.6667 5.66667 9.47276 5.66667 8C5.66667 6.52724 4.47276 5.33333 3 5.33333C1.52724 5.33333 0.333333 6.52724 0.333333 8ZM35 8.5C35.2761 8.5 35.5 8.27614 35.5 8C35.5 7.72386 35.2761 7.5 35 7.5V8.5ZM3 8.5H35V7.5H3V8.5Z"
      fill="#E0E3E6"
    />
    <path
      d="M55.9133 13.3666L57.2533 10.2533L57.5467 9.55996C57.6 9.45329 57.74 9.35996 57.86 9.35996H59.9C60.54 9.35996 61.3 8.88662 61.5933 8.31329C61.6933 8.11329 61.6933 7.87329 61.5933 7.67329C61.3 7.10663 60.5333 6.63329 59.8933 6.63329H57.8533C57.7333 6.63329 57.5933 6.53996 57.54 6.43329L55.9067 2.63329C55.7333 2.21329 55.2067 1.87329 54.7533 1.87329H53.8733C53.3067 1.87329 53.0267 2.29996 53.2533 2.82662L54.6933 6.16662C54.8067 6.42662 54.6667 6.63996 54.38 6.63996H53.64H52.44C52.2867 6.63996 52.0667 6.55329 51.96 6.44662L50.4067 4.89996C50.2467 4.73996 49.9333 4.66662 49.7067 4.73996L48.8 5.03996C48.4067 5.15996 48.22 5.60662 48.4067 5.97329L49.74 7.55996C49.9467 7.79996 49.9467 8.19329 49.74 8.43329L48.4067 10.02C48.2267 10.3866 48.4067 10.8333 48.8 10.9666L49.7067 11.2666C49.9267 11.34 50.2467 11.2666 50.4067 11.1066L51.96 9.55996C52.0667 9.44663 52.2867 9.35996 52.44 9.35996H54.38C54.6667 9.35996 54.8 9.56663 54.6933 9.83329L53.2533 13.1733C53.0267 13.7 53.3067 14.1266 53.8733 14.1266H54.7533C55.2067 14.1266 55.7333 13.7866 55.9133 13.3666Z"
      fill="#1A1C1F"
    />
    <path
      d="M75 7.5C74.7239 7.5 74.5 7.72386 74.5 8C74.5 8.27614 74.7239 8.5 75 8.5V7.5ZM104.333 8C104.333 9.47276 105.527 10.6667 107 10.6667C108.473 10.6667 109.667 9.47276 109.667 8C109.667 6.52724 108.473 5.33333 107 5.33333C105.527 5.33333 104.333 6.52724 104.333 8ZM75 8.5H107V7.5H75V8.5Z"
      fill="#E0E3E6"
    />
  </Icon>
);

export const TimelineTopSolidIcon = (props: IconProps) => (
  <Icon
    width="8"
    height="77"
    viewBox="0 0 8 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 4C0 6.20914 1.79086 8 4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4ZM3.25 76C3.25 76.4142 3.58579 76.75 4 76.75C4.41421 76.75 4.75 76.4142 4.75 76H3.25ZM3.25 4V76H4.75V4H3.25Z"
      fill="#1A1C1F"
    />
  </Icon>
);

export const TimelineTopDashedIcon = (props: IconProps) => (
  <Icon
    width="8"
    height="53"
    viewBox="0 0 8 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4C0 6.20914 1.79086 8 4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4ZM3.25 52C3.25 52.4142 3.58579 52.75 4 52.75C4.41421 52.75 4.75 52.4142 4.75 52H3.25ZM3.25 4V5H4.75V4H3.25ZM3.25 9V11H4.75V9H3.25ZM3.25 15V17H4.75V15H3.25ZM3.25 21V23H4.75V21H3.25ZM3.25 27V29H4.75V27H3.25ZM3.25 33V35H4.75V33H3.25ZM3.25 39V41H4.75V39H3.25ZM3.25 45V47H4.75V45H3.25ZM3.25 51V52H4.75V51H3.25Z"
      fill="#7B828E"
    />
  </Icon>
);

export const TimelineBottomSolidIcon = (props: IconProps) => (
  <Icon
    width="8"
    height="53"
    viewBox="0 0 8 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.75 1C4.75 0.585786 4.41421 0.25 4 0.25C3.58579 0.25 3.25 0.585786 3.25 1H4.75ZM0 49C0 51.2091 1.79086 53 4 53C6.20914 53 8 51.2091 8 49C8 46.7909 6.20914 45 4 45C1.79086 45 0 46.7909 0 49ZM3.25 1V49H4.75V1H3.25Z"
      fill="#1A1C1F"
    />
  </Icon>
);

export const TimelineBottomDashedIcon = (props: IconProps) => (
  <Icon
    width="8"
    height="77"
    viewBox="0 0 8 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.75 1C4.75 0.585786 4.41421 0.25 4 0.25C3.58579 0.25 3.25 0.585786 3.25 1H4.75ZM0 73C0 75.2091 1.79086 77 4 77C6.20914 77 8 75.2091 8 73C8 70.7909 6.20914 69 4 69C1.79086 69 0 70.7909 0 73ZM3.25 2C3.25 2.41421 3.58579 2.75 4 2.75C4.41421 2.75 4.75 2.41421 4.75 2H3.25ZM4.75 6C4.75 5.58579 4.41421 5.25 4 5.25C3.58579 5.25 3.25 5.58579 3.25 6H4.75ZM3.25 8C3.25 8.41421 3.58579 8.75 4 8.75C4.41421 8.75 4.75 8.41421 4.75 8H3.25ZM4.75 12C4.75 11.5858 4.41421 11.25 4 11.25C3.58579 11.25 3.25 11.5858 3.25 12H4.75ZM3.25 14C3.25 14.4142 3.58579 14.75 4 14.75C4.41421 14.75 4.75 14.4142 4.75 14H3.25ZM4.75 18C4.75 17.5858 4.41421 17.25 4 17.25C3.58579 17.25 3.25 17.5858 3.25 18H4.75ZM3.25 20C3.25 20.4142 3.58579 20.75 4 20.75C4.41421 20.75 4.75 20.4142 4.75 20H3.25ZM4.75 24C4.75 23.5858 4.41421 23.25 4 23.25C3.58579 23.25 3.25 23.5858 3.25 24H4.75ZM3.25 26C3.25 26.4142 3.58579 26.75 4 26.75C4.41421 26.75 4.75 26.4142 4.75 26H3.25ZM4.75 30C4.75 29.5858 4.41421 29.25 4 29.25C3.58579 29.25 3.25 29.5858 3.25 30H4.75ZM3.25 32C3.25 32.4142 3.58579 32.75 4 32.75C4.41421 32.75 4.75 32.4142 4.75 32H3.25ZM4.75 36C4.75 35.5858 4.41421 35.25 4 35.25C3.58579 35.25 3.25 35.5858 3.25 36H4.75ZM3.25 38C3.25 38.4142 3.58579 38.75 4 38.75C4.41421 38.75 4.75 38.4142 4.75 38H3.25ZM4.75 42C4.75 41.5858 4.41421 41.25 4 41.25C3.58579 41.25 3.25 41.5858 3.25 42H4.75ZM3.25 44C3.25 44.4142 3.58579 44.75 4 44.75C4.41421 44.75 4.75 44.4142 4.75 44H3.25ZM4.75 48C4.75 47.5858 4.41421 47.25 4 47.25C3.58579 47.25 3.25 47.5858 3.25 48H4.75ZM3.25 50C3.25 50.4142 3.58579 50.75 4 50.75C4.41421 50.75 4.75 50.4142 4.75 50H3.25ZM4.75 54C4.75 53.5858 4.41421 53.25 4 53.25C3.58579 53.25 3.25 53.5858 3.25 54H4.75ZM3.25 56C3.25 56.4142 3.58579 56.75 4 56.75C4.41421 56.75 4.75 56.4142 4.75 56H3.25ZM4.75 60C4.75 59.5858 4.41421 59.25 4 59.25C3.58579 59.25 3.25 59.5858 3.25 60H4.75ZM3.25 62C3.25 62.4142 3.58579 62.75 4 62.75C4.41421 62.75 4.75 62.4142 4.75 62H3.25ZM4.75 66C4.75 65.5858 4.41421 65.25 4 65.25C3.58579 65.25 3.25 65.5858 3.25 66H4.75ZM3.25 68C3.25 68.4142 3.58579 68.75 4 68.75C4.41421 68.75 4.75 68.4142 4.75 68H3.25ZM4.75 72C4.75 71.5858 4.41421 71.25 4 71.25C3.58579 71.25 3.25 71.5858 3.25 72H4.75ZM3.25 1V2H4.75V1H3.25ZM3.25 6V8H4.75V6H3.25ZM3.25 12V14H4.75V12H3.25ZM3.25 18V20H4.75V18H3.25ZM3.25 24V26H4.75V24H3.25ZM3.25 30V32H4.75V30H3.25ZM3.25 36V38H4.75V36H3.25ZM3.25 42V44H4.75V42H3.25ZM3.25 48V50H4.75V48H3.25ZM3.25 54V56H4.75V54H3.25ZM3.25 60V62H4.75V60H3.25ZM3.25 66V68H4.75V66H3.25ZM3.25 72V73H4.75V72H3.25Z"
      fill="#7B828E"
    />
  </Icon>
);

export const InfoPurpleIcon = (props: IconProps) => (
  <Icon
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="20" cy="20" r="20" fill="#100B70" fillOpacity="0.08" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.8002 20C32.8002 27.0693 27.0694 32.8 20.0002 32.8C12.931 32.8 7.2002 27.0693 7.2002 20C7.2002 12.9308 12.931 7.20001 20.0002 7.20001C27.0694 7.20001 32.8002 12.9308 32.8002 20ZM21.6002 13.6C21.6002 14.4837 20.8838 15.2 20.0002 15.2C19.1165 15.2 18.4002 14.4837 18.4002 13.6C18.4002 12.7164 19.1165 12 20.0002 12C20.8838 12 21.6002 12.7164 21.6002 13.6ZM18.4002 18.4C17.7375 18.4 17.2002 18.9373 17.2002 19.6C17.2002 20.2628 17.7375 20.8 18.4002 20.8H18.8056C19.0615 20.8 19.2516 21.037 19.1961 21.2868L18.4615 24.5926C18.0729 26.3412 19.4035 28 21.1948 28H21.6002C22.2629 28 22.8002 27.4628 22.8002 26.8C22.8002 26.1373 22.2629 25.6 21.6002 25.6H21.1948C20.9389 25.6 20.7488 25.363 20.8043 25.1132L21.5389 21.8074C21.9275 20.0588 20.5969 18.4 18.8056 18.4H18.4002Z"
      fill="#100B70"
    />
  </Icon>
);

export const MinusCircleIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.92 22C17.42 22 21.92 17.5 21.92 12C21.92 6.5 17.42 2 11.92 2C6.41998 2 1.91998 6.5 1.91998 12C1.91998 17.5 6.41998 22 11.92 22Z"
      stroke="#C9CFD4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.91998 12H15.92"
      stroke="#1A1C1F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const PlusCircleIcon = (props: IconProps) => (
  <Icon
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 30C25.5 30 30 25.5 30 20C30 14.5 25.5 10 20 10C14.5 10 10 14.5 10 20C10 25.5 14.5 30 20 30Z"
      stroke="#C9CFD4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 20H24"
      stroke="#1A1C1F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 24V16"
      stroke="#1A1C1F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CalendarIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.75 3V5.25M17.25 3V5.25M3 18.75V7.5C3 6.25736 4.00736 5.25 5.25 5.25H18.75C19.9926 5.25 21 6.25736 21 7.5V18.75M3 18.75C3 19.9926 4.00736 21 5.25 21H18.75C19.9926 21 21 19.9926 21 18.75M3 18.75V11.25C3 10.0074 4.00736 9 5.25 9H18.75C19.9926 9 21 10.0074 21 11.25V18.75M12 12.75H12.0075V12.7575H12V12.75ZM12 15H12.0075V15.0075H12V15ZM12 17.25H12.0075V17.2575H12V17.25ZM9.75 15H9.7575V15.0075H9.75V15ZM9.75 17.25H9.7575V17.2575H9.75V17.25ZM7.5 15H7.5075V15.0075H7.5V15ZM7.5 17.25H7.5075V17.2575H7.5V17.25ZM14.25 12.75H14.2575V12.7575H14.25V12.75ZM14.25 15H14.2575V15.0075H14.25V15ZM14.25 17.25H14.2575V17.2575H14.25V17.25ZM16.5 12.75H16.5075V12.7575H16.5V12.75ZM16.5 15H16.5075V15.0075H16.5V15Z"
      stroke="#7B828E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const PersonPlusIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 7.5V10.5M18 10.5V13.5M18 10.5H21M18 10.5H15M12.75 6.375C12.75 8.23896 11.239 9.75 9.375 9.75C7.51104 9.75 6 8.23896 6 6.375C6 4.51104 7.51104 3 9.375 3C11.239 3 12.75 4.51104 12.75 6.375ZM3.00092 19.2343C3.00031 19.198 3 19.1615 3 19.125C3 15.6042 5.85418 12.75 9.375 12.75C12.8958 12.75 15.75 15.6042 15.75 19.125V19.1276C15.75 19.1632 15.7497 19.1988 15.7491 19.2343C13.8874 20.3552 11.7065 21 9.375 21C7.04353 21 4.86264 20.3552 3.00092 19.2343Z"
      stroke="#7B828E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const TagGreyIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="1.5"
      cy="1.5"
      r="1.5"
      transform="matrix(1 0 0 -1 16 8.00021)"
      stroke="#7B828E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.77423 11.1439C1.77108 12.2643 1.7495 13.9546 2.67016 15.1437C4.49711 17.5033 6.49674 19.5029 8.85633 21.3298C10.0454 22.2505 11.7357 22.2289 12.8561 21.2258C15.8979 18.5022 18.6835 15.6559 21.3719 12.5279C21.6377 12.2187 21.8039 11.8397 21.8412 11.4336C22.0062 9.63798 22.3452 4.46467 20.9403 3.05974C19.5353 1.65481 14.362 1.99377 12.5664 2.15876C12.1603 2.19608 11.7813 2.36233 11.472 2.62811C8.34412 5.31646 5.49781 8.10211 2.77423 11.1439Z"
      stroke="#7B828E"
      strokeWidth="1.5"
    />
    <path
      d="M7 14.0002L10 17.0002"
      stroke="#7B828E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const LuggageIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 6H13V4H11V6ZM12 12C10.7333 12 9.525 11.7375 8.375 11.2125C7.225 10.6875 6.1 10.1 5 9.45V8C5 7.45 5.19583 6.97917 5.5875 6.5875C5.97917 6.19583 6.45 6 7 6H9V3C9 2.71667 9.09583 2.47917 9.2875 2.2875C9.47917 2.09583 9.71667 2 10 2H14C14.2833 2 14.5208 2.09583 14.7125 2.2875C14.9042 2.47917 15 2.71667 15 3V6H17C17.55 6 18.0208 6.19583 18.4125 6.5875C18.8042 6.97917 19 7.45 19 8V9.45C17.9 10.1 16.775 10.6875 15.625 11.2125C14.475 11.7375 13.2667 12 12 12ZM7 22V21C6.45 21 5.97917 20.8042 5.5875 20.4125C5.19583 20.0208 5 19.55 5 19V11.7C5.93333 12.2667 6.89583 12.75 7.8875 13.15C8.87917 13.55 9.91667 13.8167 11 13.95V15H13V13.95C14.0833 13.8167 15.1208 13.55 16.1125 13.15C17.1042 12.75 18.0667 12.2667 19 11.7V19C19 19.55 18.8042 20.0208 18.4125 20.4125C18.0208 20.8042 17.55 21 17 21V22H15V21H9V22H7Z"
      fill="#656B76"
    />
  </Icon>
);

export const GiftCardWithPurpleBgIcon = (props: IconProps) => (
  <Icon
    width="36px"
    height="36px"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="1" y="1" width="34" height="34" rx="17" fill="#F0EBFF" />
    <rect
      x="1"
      y="1"
      width="34"
      height="34"
      rx="17"
      stroke="white"
      strokeWidth="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.25 11H11.5C10.6716 11 10 11.6716 10 12.5V17.25H13.365C12.3619 16.1716 12.3854 14.4838 13.4353 13.4339C14.4848 12.3844 16.1715 12.3605 17.25 13.3621V11ZM10 18.75V23.5C10 24.3284 10.6716 25 11.5 25H17.25V20.1236C16.4704 21.6809 14.86 22.75 13 22.75C12.5858 22.75 12.25 22.4142 12.25 22C12.25 21.5858 12.5858 21.25 13 21.25C14.5368 21.25 15.8245 20.1834 16.163 18.75H10ZM18.75 25H24.5C25.3284 25 26 24.3284 26 23.5V18.75H19.837C20.1755 20.1834 21.4632 21.25 23 21.25C23.4142 21.25 23.75 21.5858 23.75 22C23.75 22.4142 23.4142 22.75 23 22.75C21.14 22.75 19.5296 21.6809 18.75 20.1236V25ZM26 17.25V12.5C26 11.6716 25.3284 11 24.5 11H18.75V13.3621C19.8285 12.3605 21.5152 12.3844 22.5647 13.4339C23.6146 14.4838 23.6381 16.1716 22.635 17.25H26ZM21.504 14.4945C21.0158 14.0064 20.2244 14.0064 19.7362 14.4945C19.3768 14.8539 19.2105 15.4938 19.1772 16.1919C19.1664 16.42 19.1706 16.6346 19.1809 16.8176C19.364 16.8279 19.5785 16.8322 19.8066 16.8213C20.5047 16.7881 21.1446 16.6217 21.504 16.2623C21.9922 15.7741 21.9922 14.9827 21.504 14.4945ZM16.2638 14.4945C15.7756 14.0064 14.9842 14.0064 14.496 14.4945C14.0078 14.9827 14.0078 15.7741 14.496 16.2623C14.8554 16.6217 15.4953 16.7881 16.1934 16.8213C16.4215 16.8322 16.636 16.8279 16.8191 16.8176C16.8294 16.6346 16.8336 16.42 16.8228 16.1919C16.7895 15.4938 16.6232 14.8539 16.2638 14.4945Z"
      fill="#351691"
    />
  </Icon>
);

export const GiftCardIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 3.125V16.875M1.875 10H18.125M5.3125 14.375C7.55616 14.375 9.375 12.5562 9.375 10.3125V10M14.6875 14.375C12.4438 14.375 10.625 12.5562 10.625 10.3125V10M3.125 16.875H16.875C17.5654 16.875 18.125 16.3154 18.125 15.625V4.375C18.125 3.68464 17.5654 3.125 16.875 3.125H3.125C2.43464 3.125 1.875 3.68464 1.875 4.375V15.625C1.875 16.3154 2.43464 16.875 3.125 16.875ZM13.6427 9.00891C12.4685 10.1831 10.1072 9.89279 10.1072 9.89279C10.1072 9.89279 9.81689 7.53143 10.9911 6.35726C11.7233 5.62503 12.9105 5.62503 13.6427 6.35726C14.375 7.08949 14.375 8.27668 13.6427 9.00891ZM8.97748 6.35728C10.1517 7.53146 9.86136 9.89281 9.86136 9.89281C9.86136 9.89281 7.5 10.1831 6.32583 9.00893C5.59359 8.2767 5.59359 7.08951 6.32583 6.35728C7.05806 5.62505 8.24524 5.62505 8.97748 6.35728Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const FormHelperIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM11 6C11 6.55228 10.5523 7 10 7C9.44771 7 9 6.55228 9 6C9 5.44772 9.44771 5 10 5C10.5523 5 11 5.44772 11 6ZM9 9C8.58579 9 8.25 9.33579 8.25 9.75C8.25 10.1642 8.58579 10.5 9 10.5H9.25338C9.41332 10.5 9.53213 10.6481 9.49743 10.8042L9.03829 12.8704C8.79542 13.9633 9.62706 15 10.7466 15H11C11.4142 15 11.75 14.6642 11.75 14.25C11.75 13.8358 11.4142 13.5 11 13.5H10.7466C10.5867 13.5 10.4679 13.3519 10.5026 13.1958L10.9617 11.1296C11.2046 10.0367 10.3729 9 9.25338 9H9Z"
      fill="#50555E"
    />
  </Icon>
);

export const InfoYellowBgIcon = (props: IconProps) => (
  <Icon
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="20" cy="20" r="20" fill="#6B4905" fillOpacity="0.08" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.8002 20C32.8002 27.0693 27.0694 32.8 20.0002 32.8C12.931 32.8 7.2002 27.0693 7.2002 20C7.2002 12.9308 12.931 7.20001 20.0002 7.20001C27.0694 7.20001 32.8002 12.9308 32.8002 20ZM21.6002 13.6C21.6002 14.4837 20.8838 15.2 20.0002 15.2C19.1165 15.2 18.4002 14.4837 18.4002 13.6C18.4002 12.7164 19.1165 12 20.0002 12C20.8838 12 21.6002 12.7164 21.6002 13.6ZM18.4002 18.4C17.7375 18.4 17.2002 18.9373 17.2002 19.6C17.2002 20.2628 17.7375 20.8 18.4002 20.8H18.8056C19.0615 20.8 19.2516 21.037 19.1961 21.2868L18.4615 24.5926C18.0729 26.3412 19.4035 28 21.1948 28H21.6002C22.2629 28 22.8002 27.4628 22.8002 26.8C22.8002 26.1373 22.2629 25.6 21.6002 25.6H21.1948C20.9389 25.6 20.7488 25.363 20.8043 25.1132L21.5389 21.8074C21.9275 20.0588 20.5969 18.4 18.8056 18.4H18.4002Z"
      fill="#6B4905"
    />
  </Icon>
);

export const BellSlashIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="heroicons-outline/bell-slash">
      <path
        id="Vector"
        d="M9.14314 17.0818C10.0799 17.1929 11.0332 17.25 11.9998 17.25C12.3306 17.25 12.6599 17.2433 12.9874 17.2301M9.14314 17.0818C7.24843 16.857 5.4214 16.4116 3.68848 15.7719C5.02539 14.2879 5.87549 12.3567 5.98723 10.2299M9.14314 17.0818C9.05019 17.3712 9 17.6797 9 18C9 19.6569 10.3431 21 12 21C13.2864 21 14.3837 20.1903 14.8101 19.0527M16.7749 16.7749L21 21M16.7749 16.7749C17.9894 16.5298 19.1706 16.1929 20.3111 15.7719C18.8743 14.177 17.9998 12.0656 17.9998 9.75V9.04919L18 9C18 5.68629 15.3137 3 12 3C9.5667 3 7.47171 4.44849 6.53026 6.53026M16.7749 16.7749L6.53026 6.53026M3 3L6.53026 6.53026"
        stroke="#0F172A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </Icon>
);

export const AdjustmentsHorizontalIcon = (props: IconProps) => (
  <Icon
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.0001 2.99999C8.0001 2.11634 7.28375 1.39999 6.4001 1.39999C5.51644 1.39999 4.8001 2.11634 4.8001 2.99999C4.8001 3.88365 5.51644 4.59999 6.4001 4.59999C7.28375 4.59999 8.0001 3.88365 8.0001 2.99999Z"
      fill="#1A1C1F"
    />
    <path
      d="M13.8001 3.59999C14.1315 3.59999 14.4001 3.33136 14.4001 2.99999C14.4001 2.66862 14.1315 2.39999 13.8001 2.39999L9.4001 2.39999C9.06873 2.39999 8.8001 2.66862 8.8001 2.99999C8.8001 3.33136 9.06873 3.59999 9.4001 3.59999L13.8001 3.59999Z"
      fill="#1A1C1F"
    />
    <path
      d="M4.0001 2.99999C4.0001 3.33136 3.73147 3.59999 3.4001 3.59999H2.2001C1.86873 3.59999 1.6001 3.33136 1.6001 2.99999C1.6001 2.66862 1.86873 2.39999 2.2001 2.39999L3.4001 2.39999C3.73147 2.39999 4.0001 2.66862 4.0001 2.99999Z"
      fill="#1A1C1F"
    />
    <path
      d="M3.4001 13.6C3.73147 13.6 4.0001 13.3314 4.0001 13C4.0001 12.6686 3.73147 12.4 3.4001 12.4H2.2001C1.86873 12.4 1.6001 12.6686 1.6001 13C1.6001 13.3314 1.86873 13.6 2.2001 13.6H3.4001Z"
      fill="#1A1C1F"
    />
    <path
      d="M13.8001 13.6C14.1315 13.6 14.4001 13.3314 14.4001 13C14.4001 12.6686 14.1315 12.4 13.8001 12.4H9.4001C9.06873 12.4 8.8001 12.6686 8.8001 13C8.8001 13.3314 9.06873 13.6 9.4001 13.6H13.8001Z"
      fill="#1A1C1F"
    />
    <path
      d="M7.2001 7.99999C7.2001 8.33137 6.93147 8.59999 6.6001 8.59999H2.2001C1.86873 8.59999 1.6001 8.33137 1.6001 7.99999C1.6001 7.66862 1.86873 7.39999 2.2001 7.39999L6.6001 7.39999C6.93147 7.39999 7.2001 7.66862 7.2001 7.99999Z"
      fill="#1A1C1F"
    />
    <path
      d="M13.8001 8.59999C14.1315 8.59999 14.4001 8.33137 14.4001 7.99999C14.4001 7.66862 14.1315 7.39999 13.8001 7.39999H12.6001C12.2687 7.39999 12.0001 7.66862 12.0001 7.99999C12.0001 8.33137 12.2687 8.59999 12.6001 8.59999H13.8001Z"
      fill="#1A1C1F"
    />
    <path
      d="M11.2001 7.99999C11.2001 7.11634 10.4838 6.39999 9.6001 6.39999C8.71644 6.39999 8.0001 7.11634 8.0001 7.99999C8.0001 8.88365 8.71644 9.59999 9.6001 9.59999C10.4838 9.59999 11.2001 8.88365 11.2001 7.99999Z"
      fill="#1A1C1F"
    />
    <path
      d="M8.0001 13C8.0001 12.1163 7.28375 11.4 6.4001 11.4C5.51644 11.4 4.8001 12.1163 4.8001 13C4.8001 13.8837 5.51644 14.6 6.4001 14.6C7.28375 14.6 8.0001 13.8837 8.0001 13Z"
      fill="#1A1C1F"
    />
  </Icon>
);

export const EnvelopeIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M1 4.24973C1.62675 3.77896 2.4058 3.5 3.25 3.5H16.75C17.5942 3.5 18.3733 3.77896 19 4.24973C18.9999 3.00721 17.9926 2 16.75 2H3.25C2.00745 2 1.00015 3.00721 1 4.24973Z" />
    <path d="M1 7.24973C1.62675 6.77896 2.4058 6.5 3.25 6.5H16.75C17.5942 6.5 18.3733 6.77896 19 7.24973C18.9999 6.00721 17.9926 5 16.75 5H3.25C2.00745 5 1.00015 6.00721 1 7.24973Z" />
    <path d="M7 8C7.55228 8 8 8.44772 8 9C8 10.1046 8.89543 11 10 11C11.1046 11 12 10.1046 12 9C12 8.44772 12.4477 8 13 8H16.75C17.9926 8 19 9.00736 19 10.25V15.75C19 16.9926 17.9926 18 16.75 18H3.25C2.00736 18 1 16.9926 1 15.75V10.25C1 9.00736 2.00736 8 3.25 8H7Z" />
  </Icon>
);

export const BadgeCheckIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 10.6248L9.375 12.4998L12.5 8.12483M10 2.26172C8.20792 3.9589 5.78802 4.99984 3.125 4.99984C3.08269 4.99984 3.04043 4.99958 2.99825 4.99906C2.67491 5.98248 2.5 7.03325 2.5 8.12488C2.5 12.7845 5.68693 16.6997 10 17.8098C14.3131 16.6997 17.5 12.7845 17.5 8.12488C17.5 7.03325 17.3251 5.98248 17.0018 4.99906C16.9596 4.99958 16.9173 4.99984 16.875 4.99984C14.212 4.99984 11.7921 3.9589 10 2.26172Z"
      stroke="#1A1C1F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ToggleOffIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="18px"
    viewBox="0 0 32 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width="32"
      height="18"
      fill="white"
      style={{ mixBlendMode: 'multiply' }}
    />
    <rect y="1" width="32" height="16" rx="8" fill="#A3ABAD" />
    <rect x="3" y="4" width="10" height="10" rx="5" fill="white" />
  </Icon>
);

export const DeepGreenCheckIcon = (props: IconProps) => (
  <Icon
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M9.00002 17.9583C4.05247 17.9583 0.041687 13.9475 0.041687 8.99996C0.041687 4.05241 4.05247 0.041626 9.00002 0.041626C13.9476 0.041626 17.9584 4.05241 17.9584 8.99996C17.9584 13.9475 13.9476 17.9583 9.00002 17.9583Z"
      fill="#14CC52"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9477 7.06307C13.2587 6.7238 13.2357 6.19666 12.8965 5.88567C12.5572 5.57468 12.0301 5.59759 11.7191 5.93686L7.72386 10.2953L6.25596 8.82738C5.93053 8.50194 5.40289 8.50194 5.07745 8.82738C4.75201 9.15281 4.75201 9.68045 5.07745 10.0059L7.16079 12.0892C7.32151 12.2499 7.5409 12.338 7.76814 12.3331C7.99538 12.3282 8.21075 12.2306 8.36434 12.0631L12.9477 7.06307Z"
      fill="#0B702D"
    />
  </Icon>
);

export const GreenSquareArrowUpRightIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.7731 9.22687L9 15M14.7731 9.22687C14.2678 8.72156 11.8846 9.21665 11.1649 9.22687M14.7731 9.22687C15.2784 9.73219 14.7834 12.1154 14.7731 12.8351"
      stroke="#12BA4B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
      stroke="#12BA4B"
      strokeWidth="1.5"
    />
  </Icon>
);

export const PurpleChatIcon = (props: IconProps) => (
  <Icon
    width="58px"
    height="58px"
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M30.0519 0.497364C26.7295 0.278569 23.2645 0.279015 19.9489 0.497364C9.45866 1.18821 1.1155 9.58153 0.429193 20.1024C0.301923 22.0534 0.301923 24.0711 0.429193 26.0221C0.685487 29.951 2.41066 33.4786 4.30833 36.3199C4.78099 37.2449 4.56244 38.7214 3.51568 40.6866L3.46155 40.7881C3.11154 41.4447 2.75361 42.1162 2.54483 42.6952C2.32177 43.3137 2.06299 44.3711 2.68637 45.4241C3.25362 46.3823 4.15555 46.722 4.84493 46.8542C5.4089 46.9623 6.09327 46.9784 6.7055 46.9928L6.81755 46.9955C10.1009 47.0746 12.4305 46.1332 14.2772 44.784C14.5606 44.577 14.7697 44.4247 14.9324 44.3103C15.179 44.404 15.5047 44.5365 15.9579 44.7214C17.2162 45.2349 18.6405 45.541 19.9489 45.6271C23.2645 45.8455 26.7295 45.8459 30.0519 45.6271C40.5422 44.9363 48.8853 36.543 49.5716 26.0221C49.6989 24.0711 49.6989 22.0534 49.5716 20.1024C48.8853 9.58153 40.5422 1.18821 30.0519 0.497364Z"
      fill="#8B62DD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.0004 31.0002C15.8959 31.0002 15.0004 30.1047 15.0004 29.0002C15.0004 27.8956 15.8959 27.0002 17.0004 27.0002H33.0004C34.105 27.0002 35.0004 27.8956 35.0004 29.0002C35.0004 30.1047 34.105 31.0002 33.0004 31.0002H17.0004ZM17.0004 20.3335C15.8959 20.3335 15.0004 19.4381 15.0004 18.3335C15.0004 17.2289 15.8959 16.3335 17.0004 16.3335H25.0004C26.105 16.3335 27.0004 17.2289 27.0004 18.3335C27.0004 19.4381 26.105 20.3335 25.0004 20.3335H17.0004Z"
      fill="#8B62DD"
    />
    <path
      d="M53.5624 26.2848C52.7464 38.7938 42.8222 48.7971 30.314 49.6208C26.8164 49.8512 23.1758 49.8507 19.6853 49.6208C18.247 49.5261 17.5278 49.4788 17.2792 49.6945C17.0805 49.867 16.9825 50.1117 17.0072 50.3737C17.038 50.7014 17.5124 51.0979 18.4611 51.8908C21.5183 54.4459 25.3206 56.1029 29.5714 56.3817C32.7032 56.5872 35.9692 56.5868 39.0945 56.3817C40.3367 56.3002 41.6891 56.0109 42.8855 55.5246L43.1446 55.4194C43.3817 55.3233 43.5002 55.2753 43.6295 55.267C43.7255 55.2609 43.8314 55.2739 43.9231 55.303C44.0465 55.3423 44.1507 55.4181 44.359 55.5697C46.1169 56.8489 48.3335 57.7396 51.4489 57.6647L51.557 57.6622C52.1302 57.6488 52.7834 57.6335 53.3236 57.5303C53.9874 57.4036 54.8747 57.0742 55.4339 56.1333C56.0509 55.0952 55.7916 54.0551 55.5774 53.4635C55.3777 52.9116 55.0366 52.2744 54.7091 51.6624L54.6562 51.5635C53.6754 49.7294 53.4996 48.4029 53.9079 47.5975C55.6983 44.926 57.333 41.5989 57.5762 37.8859C57.6964 36.051 57.6964 34.1537 57.5762 32.3189C57.4217 29.9595 56.8577 27.7139 55.9545 25.6526C55.3373 24.2442 55.0288 23.54 54.5391 23.5116C54.4217 23.5048 54.2853 23.5288 54.1772 23.5752C53.7265 23.7688 53.6718 24.6075 53.5624 26.2848Z"
      fill="#8B62DD"
    />
  </Icon>
);

export const PurpleTelevisionChartIcon = (props: IconProps) => (
  <Icon
    width="64px"
    height="64px"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.19482 47.4372C4.66669 44.8744 4.66669 40.7496 4.66669 32.5V20.8333C4.66669 12.5837 4.66669 8.45894 7.19482 5.89613C9.72295 3.33331 13.7919 3.33331 21.9298 3.33331H42.0702C50.2081 3.33331 54.2771 3.33331 56.8052 5.89613C59.3334 8.45894 59.3334 12.5837 59.3334 20.8333V32.5C59.3334 40.7496 59.3334 44.8744 56.8052 47.4372C54.2771 50 50.2081 50 42.0702 50H21.9298C13.7919 50 9.72295 50 7.19482 47.4372Z"
      fill="#8B62DD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.9003 49.9983L11.6676 56.5844C10.5176 57.5044 10.3311 59.1826 11.2511 60.3326C12.1712 61.4826 13.8493 61.6691 14.9993 60.749L28.3326 50.0824C28.3662 50.0555 28.3989 50.0281 28.4308 50H21.9298C21.2232 50 20.5472 50 19.9003 49.9983ZM29.3334 50V58.6666C29.3334 60.1394 30.5273 61.3333 32 61.3333C33.4728 61.3333 34.6667 60.1394 34.6667 58.6666V50H29.3334ZM35.5694 50C35.6013 50.0281 35.6341 50.0555 35.6676 50.0824L49.0009 60.749C50.151 61.6691 51.8291 61.4826 52.7491 60.3326C53.6691 59.1826 53.4827 57.5044 52.3326 56.5844L44.1 49.9983C43.453 50 42.7769 50 42.0702 50H35.5694Z"
      fill="#8B62DD"
    />
    <path
      d="M34.6667 18.6667C34.6667 17.1939 33.4728 16 32 16C30.5273 16 29.3334 17.1939 29.3334 18.6667V34.6667C29.3334 36.1394 30.5273 37.3333 32 37.3333C33.4728 37.3333 34.6667 36.1394 34.6667 34.6667V18.6667Z"
      fill="#8B62DD"
    />
    <path
      d="M24 26.6667C24 25.1939 22.8061 24 21.3334 24C19.8606 24 18.6667 25.1939 18.6667 26.6667V34.6667C18.6667 36.1394 19.8606 37.3333 21.3334 37.3333C22.8061 37.3333 24 36.1394 24 34.6667V26.6667Z"
      fill="#8B62DD"
    />
    <path
      d="M45.3334 29.3333C45.3334 27.8606 44.1394 26.6667 42.6667 26.6667C41.1939 26.6667 40 27.8606 40 29.3333V34.6667C40 36.1394 41.1939 37.3333 42.6667 37.3333C44.1394 37.3333 45.3334 36.1394 45.3334 34.6667V29.3333Z"
      fill="#8B62DD"
    />
  </Icon>
);

export const ArrowLeftRoundedIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33319 9.99976L16.6665 9.99976"
      stroke="#00151A"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.49967 14.1666C7.49967 14.1666 3.33305 11.0979 3.33304 9.99989C3.33303 8.90189 7.49971 5.83325 7.49971 5.83325"
      stroke="#00151A"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ShoppingBagIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.125 8.75V5C13.125 3.27411 11.7259 1.875 10 1.875C8.27411 1.875 6.875 3.27411 6.875 5V8.75M16.3384 7.08936L17.391 17.0894C17.4493 17.6429 17.0152 18.125 16.4586 18.125H3.54136C2.98476 18.125 2.55074 17.6429 2.60901 17.0894L3.66164 7.08936C3.71187 6.61222 4.11422 6.25 4.59399 6.25H15.406C15.8858 6.25 16.2881 6.61222 16.3384 7.08936ZM7.1875 8.75C7.1875 8.92259 7.04759 9.0625 6.875 9.0625C6.70241 9.0625 6.5625 8.92259 6.5625 8.75C6.5625 8.57741 6.70241 8.4375 6.875 8.4375C7.04759 8.4375 7.1875 8.57741 7.1875 8.75ZM13.4375 8.75C13.4375 8.92259 13.2976 9.0625 13.125 9.0625C12.9524 9.0625 12.8125 8.92259 12.8125 8.75C12.8125 8.57741 12.9524 8.4375 13.125 8.4375C13.2976 8.4375 13.4375 8.57741 13.4375 8.75Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const FootballIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M1 4.24973C1.62675 3.77896 2.4058 3.5 3.25 3.5H16.75C17.5942 3.5 18.3733 3.77896 19 4.24973C18.9999 3.00721 17.9926 2 16.75 2H3.25C2.00745 2 1.00015 3.00721 1 4.24973Z" />
    <path d="M1 7.24973C1.62675 6.77896 2.4058 6.5 3.25 6.5H16.75C17.5942 6.5 18.3733 6.77896 19 7.24973C18.9999 6.00721 17.9926 5 16.75 5H3.25C2.00745 5 1.00015 6.00721 1 7.24973Z" />
    <path d="M7 8C7.55228 8 8 8.44772 8 9C8 10.1046 8.89543 11 10 11C11.1046 11 12 10.1046 12 9C12 8.44772 12.4477 8 13 8H16.75C17.9926 8 19 9.00736 19 10.25V15.75C19 16.9926 17.9926 18 16.75 18H3.25C2.00736 18 1 16.9926 1 15.75V10.25C1 9.00736 2.00736 8 3.25 8H7Z" />
  </Icon>
);

export const LoginSquare02Icon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.68801 1.93059C8.03143 1.74998 9.7521 1.74999 11.9428 1.75H12.0572C14.2479 1.74999 15.9685 1.74998 17.312 1.93059C18.6886 2.11568 19.7809 2.50272 20.6391 3.36091C21.4973 4.21911 21.8843 5.31137 22.0694 6.68802C22.25 8.03144 22.25 9.75212 22.25 11.9428V12.0572C22.25 14.2479 22.25 15.9686 22.0694 17.312C21.8843 18.6886 21.4973 19.7809 20.6391 20.6391C19.7809 21.4973 18.6886 21.8843 17.312 22.0694C15.9685 22.25 14.2479 22.25 12.0572 22.25H12.0572H11.9428H11.9428C9.75209 22.25 8.03142 22.25 6.68801 22.0694C5.31135 21.8843 4.2191 21.4973 3.3609 20.6391C2.5027 19.7809 2.11567 18.6886 1.93058 17.312C1.74996 15.9686 1.74997 14.2479 1.74998 12.0572V12.0572V11.9428V11.9428C1.74997 9.75211 1.74996 8.03144 1.93058 6.68802C2.11567 5.31137 2.5027 4.21911 3.3609 3.36091C4.2191 2.50272 5.31135 2.11568 6.68801 1.93059ZM17.75 16L17.75 8.00003C17.75 7.58582 17.4142 7.25003 17 7.25003C16.5858 7.25003 16.25 7.58582 16.25 8.00003L16.25 16C16.25 16.4142 16.5858 16.75 17 16.75C17.4142 16.75 17.75 16.4142 17.75 16ZM6.24999 12C6.24999 12.4142 6.58577 12.75 6.99999 12.75H11.25V13.061C11.2499 13.3347 11.2499 13.6034 11.2736 13.8111C11.2921 13.9739 11.3538 14.4463 11.7721 14.6629C12.1906 14.8795 12.57 14.6345 12.6986 14.5482C12.8632 14.4377 13.057 14.269 13.2545 14.0969L13.2826 14.0725C13.5848 13.8093 13.9202 13.5032 14.184 13.2002C14.3158 13.0489 14.446 12.88 14.5468 12.7015C14.6414 12.5338 14.75 12.2885 14.75 12C14.75 11.7115 14.6414 11.4662 14.5468 11.2986C14.446 11.1201 14.3158 10.9512 14.184 10.7998C13.9202 10.4969 13.5848 10.1907 13.2826 9.9276L13.2545 9.90315C13.057 9.73109 12.8632 9.56234 12.6986 9.45183C12.57 9.36552 12.1906 9.12051 11.7721 9.33719C11.3538 9.55371 11.2921 10.0262 11.2736 10.1889C11.2499 10.3967 11.2499 10.6654 11.25 10.939V11.25H6.99999C6.58577 11.25 6.24999 11.5858 6.24999 12Z"
      fill="#141B34"
    />
  </Icon>
);

//product features Icons

export const TransferIcon = (props: IconProps) => (
  <Icon
    width="49px"
    height="48px"
    viewBox="0 0 49 48"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M36.4388 13.6884C38.7632 13.9363 40.648 14.4534 42.2147 15.6219C42.6838 15.9717 43.1186 16.3581 43.514 16.777C44.8464 18.1883 45.4414 19.899 45.7248 21.9977C46 24.0366 46 26.6166 46 29.873V30.0722C46 33.3286 46 35.9086 45.7248 37.9475C45.4414 40.0462 44.8464 41.7569 43.514 43.1683C43.1186 43.5871 42.6838 43.9735 42.2147 44.3233C40.648 45.4918 38.7632 46.0089 36.4388 46.2569C34.1617 46.4998 31.2731 46.4998 27.5951 46.4998H21.4049C17.7269 46.4998 14.8383 46.4998 12.5612 46.2569C10.2368 46.0089 8.35201 45.4918 6.78525 44.3233C6.31622 43.9735 5.88136 43.5871 5.48596 43.1683C4.15361 41.7569 3.55864 40.0462 3.27525 37.9475C2.99995 35.9086 2.99997 33.3285 3 30.0722V29.873C2.99997 26.6166 2.99995 24.0366 3.27525 21.9977C3.55864 19.899 4.15361 18.1883 5.48596 16.777C5.88136 16.3581 6.31622 15.9717 6.78525 15.6219C8.35201 14.4534 10.2368 13.9363 12.5612 13.6884C13.4562 13.5929 14.4457 13.5349 15.5404 13.4998H18.3C18.8657 13.4998 19.1485 13.4998 19.3243 13.6755C19.5 13.8512 19.5 14.1341 19.5 14.6998V15.4488C19.5 18.2147 21.7386 20.457 24.5 20.457C27.2614 20.457 29.5 18.2147 29.5 15.4488V14.6998C29.5 14.1341 29.5 13.8512 29.6757 13.6755C29.8515 13.4998 30.1343 13.4998 30.7 13.4998H33.4596C34.5543 13.5349 35.5438 13.5929 36.4388 13.6884Z"
    />
    <path
      d="M30.5005 30.9706C30.5005 34.2897 27.8142 36.9804 24.5005 36.9804C21.1868 36.9804 18.5005 34.2897 18.5005 30.9706C18.5005 27.6514 21.1868 24.9607 24.5005 24.9607C27.8142 24.9607 30.5005 27.6514 30.5005 30.9706Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.5156 30.9718C39.5156 29.8654 38.6202 28.9685 37.5156 28.9685H37.4977C36.3931 28.9685 35.4977 29.8654 35.4977 30.9718C35.4977 32.0782 36.3931 32.9751 37.4977 32.9751H37.5156C38.6202 32.9751 39.5156 32.0782 39.5156 30.9718Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 30.9718C13.5 29.8654 12.6046 28.9685 11.5 28.9685H11.482C10.3775 28.9685 9.48204 29.8654 9.48204 30.9718C9.48204 32.0782 10.3775 32.9751 11.482 32.9751H11.5C12.6046 32.9751 13.5 32.0782 13.5 30.9718Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.5117 15.4998C26.5117 16.6044 25.6163 17.4998 24.5117 17.4998C23.4071 17.4998 22.5117 16.6044 22.5117 15.4998L22.5117 10.4997L21.3232 10.4998C20.9719 10.5 20.5406 10.5003 20.1877 10.4562L20.1811 10.4554C19.9282 10.4238 18.7761 10.2802 18.2274 9.14896C17.6774 8.01531 18.2813 7.01503 18.4119 6.79863L18.4168 6.79056C18.6012 6.48452 18.8695 6.14276 19.0902 5.86165L19.1377 5.80116C19.727 5.04951 20.4909 4.08108 21.2518 3.29906C21.6314 2.90884 22.0659 2.50637 22.5278 2.18867C22.9383 1.90627 23.6387 1.49974 24.5 1.49974C25.3613 1.49974 26.0617 1.90627 26.4722 2.18867C26.9341 2.50637 27.3686 2.90884 27.7482 3.29906C28.5091 4.08108 29.273 5.04951 29.8623 5.80116L29.9098 5.86164C30.1305 6.14275 30.3988 6.48451 30.5832 6.79056L30.5881 6.79863C30.7187 7.01504 31.3226 8.01532 30.7726 9.14896C30.2239 10.2802 29.0718 10.4238 28.8189 10.4554L28.8123 10.4562C28.4594 10.5003 28.0281 10.5 27.6768 10.4998L26.5117 10.4997L26.5117 15.4998Z"
      fill="#00151A"
    />
  </Icon>
);

export const BillPaymentIcon = (props: IconProps) => (
  <Icon
    width="49px"
    height="48px"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.5 45.75C23.3954 45.75 22.5 44.8546 22.5 43.75L22.5 35.75C22.5 34.6454 23.3954 33.75 24.5 33.75C25.6046 33.75 26.5 34.6454 26.5 35.75L26.5 43.75C26.5 44.8546 25.6046 45.75 24.5 45.75ZM32.5 41.75C31.3954 41.75 30.5 40.8546 30.5 39.75L30.5 35.75C30.5 34.6454 31.3954 33.75 32.5 33.75C33.6046 33.75 34.5 34.6454 34.5 35.75L34.5 39.75C34.5 40.8546 33.6046 41.75 32.5 41.75ZM16.5 41.75C15.3954 41.75 14.5 40.8546 14.5 39.75L14.5 35.75C14.5 34.6454 15.3954 33.75 16.5 33.75C17.6046 33.75 18.5 34.6454 18.5 35.75L18.5 39.75C18.5 40.8546 17.6046 41.75 16.5 41.75Z"
      fill="#00151A"
    />
    <path
      opacity="0.4"
      d="M37.5 35.7507C37.5 35.7536 37.5 35.7464 37.5 35.7487C37.5028 36.108 37.8421 36.3942 38.1968 36.3363C38.199 36.3359 38.1737 36.3402 38.1838 36.3385C40.2017 35.9928 41.8657 35.3319 43.2091 34.0096C44.71 32.5323 45.3771 30.6567 45.6933 28.3417C46.0001 26.0961 46 23.228 46 19.6131L46 19.3845C46 15.7696 46.0001 12.9015 45.6933 10.6558C45.3771 8.34091 44.71 6.46522 43.2091 4.98795C41.7115 3.51392 39.8155 2.86171 37.475 2.55199C35.1981 2.25069 32.2882 2.25071 28.6113 2.25074L20.3887 2.25074C16.7118 2.25071 13.8019 2.25069 11.5251 2.55199C9.1845 2.86171 7.28855 3.51392 5.79094 4.98794C4.29003 6.46522 3.62291 8.3409 3.3067 10.6558C2.99994 12.9015 2.99997 15.7696 3 19.3845L3 19.6131C2.99997 23.228 2.99994 26.0961 3.30669 28.3417C3.62291 30.6567 4.29002 32.5323 5.79094 34.0096C7.13435 35.3319 8.7983 35.9928 10.8162 36.3385C10.8263 36.3402 10.801 36.3359 10.8032 36.3363C11.1578 36.3942 11.4972 36.108 11.5 35.7487C11.5 35.7464 11.5 35.7536 11.5 35.7507C11.5 32.9893 13.7386 30.7507 16.5 30.7507C17.5616 30.7507 18.5459 31.0816 19.3555 31.6458C19.9929 32.09 20.3115 32.3121 20.5 32.3121C20.6884 32.3121 21.0071 32.09 21.6445 31.6458C22.4541 31.0816 23.4384 30.7507 24.5 30.7507C25.5616 30.7507 26.5459 31.0816 27.3555 31.6458C27.9929 32.09 28.3115 32.3121 28.5 32.3121C28.6884 32.3121 29.0071 32.09 29.6445 31.6458C30.4541 31.0816 31.4384 30.7507 32.5 30.7507C35.2614 30.7507 37.5 32.9893 37.5 35.7507Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 19.5C9.5 20.6046 10.3954 21.5 11.5 21.5L11.518 21.5C12.6225 21.5 13.518 20.6046 13.518 19.5C13.518 18.3954 12.6225 17.5 11.518 17.5L11.5 17.5C10.3954 17.5 9.5 18.3954 9.5 19.5Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.4805 19.5C35.4805 20.6046 36.3759 21.5 37.4805 21.5L37.4984 21.5C38.603 21.5 39.4984 20.6046 39.4984 19.5C39.4984 18.3954 38.603 17.5 37.4984 17.5L37.4805 17.5C36.3759 17.5 35.4805 18.3954 35.4805 19.5Z"
      fill="#00151A"
    />
    <path
      d="M31 19.5C31 23.0899 28.0899 26 24.5 26C20.9101 26 18 23.0899 18 19.5C18 15.9101 20.9101 13 24.5 13C28.0899 13 31 15.9101 31 19.5Z"
      fill="#00151A"
    />
  </Icon>
);

export const GiftCardFeatureIcon = (props: IconProps) => (
  <Icon
    width="49px"
    height="48px"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M32.6098 6.5C35.3449 6.49996 37.5496 6.49993 39.2835 6.73305C41.0837 6.97508 42.5995 7.49287 43.8033 8.6967C45.0071 9.90053 45.5249 11.4163 45.767 13.2165C46.0001 14.9504 46 17.1551 46 19.8903V28.1097C46 30.8449 46.0001 33.0496 45.767 34.7835C45.5249 36.5837 45.0071 38.0995 43.8033 39.3033C42.5995 40.5071 41.0837 41.0249 39.2835 41.267C37.5496 41.5001 35.3449 41.5 32.6097 41.5H16.3903C13.6551 41.5 11.4504 41.5001 9.7165 41.267C7.91628 41.0249 6.40053 40.5071 5.1967 39.3033C3.99287 38.0995 3.47508 36.5837 3.23305 34.7835C2.99993 33.0496 2.99996 30.8449 3 28.1098V28.1098V19.8903V19.8902C2.99996 17.1551 2.99993 14.9504 3.23305 13.2165C3.47508 11.4163 3.99287 9.90053 5.1967 8.6967C6.40053 7.49287 7.91628 6.97508 9.7165 6.73305C11.4504 6.49993 13.6551 6.49996 16.3902 6.5H16.3903H32.6098H32.6098Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 24.5H12.1841C11.3501 23.101 11 21.4158 11 19.8086C11 18.5283 11.208 17.4046 11.6971 16.503C12.2103 15.5571 13.0002 14.9231 13.9695 14.651C15.748 14.1516 17.7343 14.9616 19.312 15.9774C20.6218 16.8207 21.9115 17.9714 23 19.2582L23 6.5H26L26 19.2582C27.0885 17.9714 28.3782 16.8207 29.688 15.9774C31.2657 14.9616 33.2521 14.1516 35.0305 14.651C35.9998 14.9231 36.7897 15.5571 37.3029 16.503C37.792 17.4046 38 18.5283 38 19.8086C38 21.4158 37.6499 23.101 36.8159 24.5H46V27.5L28.1213 27.5L31.5607 30.9393C32.1465 31.5251 32.1465 32.4749 31.5607 33.0607C30.9749 33.6465 30.0251 33.6465 29.4393 33.0607L26 29.6213L26 41.5H23L23 29.6213L19.5607 33.0607C18.9749 33.6465 18.0251 33.6465 17.4393 33.0607C16.8536 32.4749 16.8536 31.5251 17.4393 30.9393L20.8787 27.5L3 27.5V24.5ZM21.405 22.0876C22.0075 22.9299 22.446 23.7522 22.7091 24.5H17.4977C16.2731 24.4994 15.4713 23.9909 14.9231 23.2138C14.3334 22.3778 14 21.1588 14 19.8086C14 18.8166 14.167 18.2416 14.3341 17.9335C14.4772 17.6697 14.6248 17.583 14.7805 17.5393C15.252 17.4069 16.2657 17.5841 17.688 18.4998C19.0196 19.3572 20.3838 20.66 21.405 22.0876ZM26.2909 24.5C26.554 23.7522 26.9925 22.9299 27.595 22.0876C28.6162 20.66 29.9804 19.3572 31.312 18.4998C32.7343 17.5841 33.748 17.4069 34.2195 17.5393C34.3752 17.583 34.5228 17.6697 34.6659 17.9335C34.833 18.2416 35 18.8166 35 19.8086C35 21.1588 34.6666 22.3778 34.0769 23.2138C33.5287 23.9909 32.7269 24.4994 31.5023 24.5H26.2909Z"
      fill="#00151A"
    />
  </Icon>
);

export const PaymentLinkIcon = (props: IconProps) => (
  <Icon
    width="49px"
    height="48px"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.1177 8.38232C30.9413 5.20589 25.7913 5.20589 22.6148 8.38232L16.8823 14.1148C13.7059 17.2913 13.7059 22.4413 16.8823 25.6177C19.9795 28.7149 24.9542 28.7922 28.1439 25.8495C28.9557 25.1005 30.221 25.1515 30.97 25.9633C31.719 26.7752 31.668 28.0405 30.8561 28.7895C26.0952 33.1817 18.675 33.0673 14.0539 28.4461C9.31537 23.7076 9.31537 16.0249 14.0539 11.2864L19.7864 5.55389C24.5249 0.815369 32.2076 0.81537 36.9461 5.55389C41.6846 10.2924 41.6846 17.9751 36.9461 22.7136L36.0174 23.6423C35.2364 24.4233 33.97 24.4233 33.189 23.6423C32.4079 22.8612 32.4079 21.5949 33.189 20.8139L34.1177 19.8852C37.2941 16.7087 37.2941 11.5587 34.1177 8.38232Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.87 25.4742C7.31618 30.2258 7.37747 37.7697 12.0539 42.4461C16.7924 47.1846 24.4751 47.1846 29.2136 42.4461L34.9461 36.7136C39.6846 31.9751 39.6846 24.2924 34.9461 19.5539C30.325 14.9327 22.9048 14.8183 18.1439 19.2105C17.332 19.9595 17.281 21.2248 18.03 22.0367C18.779 22.8485 20.0443 22.8995 20.8561 22.1505C24.0458 19.2078 29.0205 19.2851 32.1177 22.3823C35.2941 25.5587 35.2941 30.7087 32.1177 33.8852L26.3852 39.6177C23.2087 42.7941 18.0587 42.7941 14.8823 39.6177C11.9001 36.6355 11.7178 31.9137 14.3353 28.7187C14.2404 28.6297 14.1466 28.5388 14.0539 28.4461C13.1557 27.5479 12.4277 26.5439 11.87 25.4742Z"
      fill="#00151A"
    />
  </Icon>
);

export const CreditCardFeatureIcon = (props: IconProps) => (
  <Icon
    width="49px"
    height="48px"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M46.0001 24.1055C46.0001 27.5535 46.0001 30.2855 45.7248 32.4443C45.4414 34.6666 44.8465 36.478 43.5141 37.9724C43.1187 38.4159 42.6838 38.825 42.2148 39.1954C40.6481 40.4328 38.7632 40.9802 36.4389 41.2428C34.1617 41.5 31.2732 41.5 27.5952 41.5H21.405C17.727 41.5 14.8384 41.5 12.5612 41.2428C10.2369 40.9802 8.35207 40.4328 6.78531 39.1954C6.31628 38.825 5.88142 38.4159 5.48603 37.9724C4.15368 36.478 3.55871 34.6666 3.27531 32.4443C3.00001 30.2855 3.00003 27.5535 3.00006 24.1055V23.8945C3.00005 22.743 3.00004 21.6713 3.01029 20.6742C3.01596 20.1228 3.01879 19.8471 3.19415 19.6736C3.3695 19.5 3.64728 19.5 4.20284 19.5H44.7973C45.3528 19.5 45.6306 19.5 45.806 19.6736C45.9813 19.8471 45.9842 20.1228 45.9898 20.6742C46.0001 21.6713 46.0001 22.743 46.0001 23.8945V24.1055Z"
    />
    <path
      d="M27.597 6.5C31.275 6.49998 34.1635 6.49997 36.4407 6.7572C38.7651 7.01976 40.6499 7.56724 42.2166 8.80457C42.6857 9.17498 43.1205 9.5841 43.5159 10.0276C44.8483 11.522 45.4432 13.3334 45.7266 15.5557C45.7592 15.8114 45.7755 15.9393 45.7462 16.0516C45.6994 16.2311 45.5616 16.3875 45.3895 16.4567C45.2818 16.5 45.147 16.5 44.8774 16.5H4.12633C3.85678 16.5 3.722 16.5 3.6143 16.4567C3.44217 16.3875 3.30441 16.2311 3.25755 16.0516C3.22822 15.9393 3.24453 15.8114 3.27714 15.5557C3.56053 13.3334 4.1555 11.522 5.48785 10.0276C5.88324 9.5841 6.3181 9.17499 6.78714 8.80457C8.35389 7.56724 10.2387 7.01976 12.563 6.7572C14.8402 6.49997 17.7288 6.49998 21.4068 6.5H27.597Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.0001 32C21.0001 31.1716 21.6716 30.5 22.5001 30.5H25.5001C26.3285 30.5 27.0001 31.1716 27.0001 32C27.0001 32.8284 26.3285 33.5 25.5001 33.5H22.5001C21.6716 33.5 21.0001 32.8284 21.0001 32Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.0001 32C30.0001 31.1716 30.6716 30.5 31.5001 30.5L38.5001 30.5C39.3285 30.5 40.0001 31.1716 40.0001 32C40.0001 32.8284 39.3285 33.5 38.5001 33.5L31.5001 33.5C30.6716 33.5 30.0001 32.8284 30.0001 32Z"
      fill="#00151A"
    />
  </Icon>
);

export const LoansFeatureIcon = (props: IconProps) => (
  <Icon
    width="49px"
    height="48px"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M34.1706 16.2255C39.0011 20.9011 42.2606 27.1632 43.3674 33.7908C43.9341 37.1835 42.6246 40.1608 40.3741 42.2401C38.1462 44.2986 34.9875 45.5 31.6931 45.5H17.3053C14.0109 45.5 10.8522 44.2986 8.62429 42.2401C6.37386 40.1608 5.06435 37.1835 5.63097 33.7908C6.97118 25.7659 11.1394 19.7948 14.7757 16.2759C14.9606 16.0969 15.1456 15.9216 15.3539 15.7695C15.804 15.4408 16.6086 15.1152 17.1606 15.0383C17.4353 15 17.6328 15 18.0279 15H30.9705C31.3656 15 31.5631 15 31.8378 15.0383C32.3898 15.1152 33.1944 15.4408 33.6445 15.7695C33.8685 15.933 33.9692 16.0305 34.1706 16.2255Z"
    />
    <path
      d="M21.7826 3.81288C22.2751 3.31872 23.2051 2.5 24.4996 2.5C25.7942 2.5 26.7242 3.31872 27.2167 3.81288C27.8137 4.41197 28.2893 5.30742 29.047 5.70822C29.6735 6.03958 30.4813 5.7177 31.1065 5.55488C31.7024 5.39977 32.6106 5.16488 33.573 5.29298C33.9912 5.34864 34.5399 5.48166 34.9651 5.8602C35.4685 6.3085 35.5498 6.8663 35.4762 7.28788C35.3866 7.80079 35.0689 8.22173 34.7571 8.62204L32.9724 10.9198C32.5125 11.5136 32.0572 12.1239 31.446 12.5727C30.9932 12.9052 30.4203 13 29.8586 13H19.1407C18.579 13 18.0061 12.9052 17.5533 12.5727C16.9421 12.1239 16.4868 11.5136 16.0268 10.9198L14.2422 8.62204C13.9303 8.22172 13.6127 7.80079 13.5231 7.28788C13.4495 6.86629 13.5307 6.3085 14.0342 5.8602C14.4594 5.48166 15.0081 5.34864 15.4263 5.29298C16.3887 5.16488 17.2969 5.39977 17.8928 5.55488C18.5179 5.7177 19.3258 6.03958 19.9522 5.70822C20.7099 5.30742 21.1856 4.41197 21.7826 3.81288Z"
      fill="#00151A"
    />
  </Icon>
);

export const ReferralIcon = (props: IconProps) => (
  <Icon
    width="49px"
    height="48px"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M37.5539 12.5C38.4426 12.5 39.1894 12.5 39.7984 12.5441C40.4304 12.5899 41.0442 12.6897 41.629 12.9598C42.2913 13.2657 42.8832 13.7247 43.3144 14.3222C43.7219 14.8868 43.874 15.495 43.9402 16.0792C44.0002 16.6081 44.0001 17.2423 44 17.928V18.072C44.0001 18.7577 44.0002 19.3919 43.9402 19.9208C43.874 20.505 43.7219 21.1132 43.3144 21.6778C42.8832 22.2753 42.2913 22.7343 41.629 23.0402C41.0442 23.3103 40.4304 23.4101 39.7984 23.4559C39.1894 23.5 38.4426 23.5 37.5539 23.5H11.4462C10.5574 23.5 9.81059 23.5 9.20163 23.4559C8.56958 23.4101 7.95586 23.3103 7.37104 23.0402C6.70869 22.7343 6.11682 22.2753 5.68561 21.6778C5.27814 21.1132 5.12597 20.505 5.05979 19.9208C4.99987 19.3919 4.99993 18.7577 5.00001 18.0719V17.9281C4.99993 17.2423 4.99987 16.6081 5.05979 16.0792C5.12597 15.495 5.27814 14.8868 5.68561 14.3222C6.11682 13.7247 6.70869 13.2657 7.37104 12.9598C7.95586 12.6897 8.56958 12.5899 9.20163 12.5441C9.81058 12.5 10.5574 12.5 11.4461 12.5H37.5539Z"
      fill="#00151A"
    />
    <g opacity="0.5">
      <path d="M8.07357 25.8364C7.54682 25.7477 7.28344 25.7033 7.14172 25.8232C7 25.943 7 26.1887 7 26.68V30.1088C6.99997 33.314 6.99994 35.8719 7.26966 37.8781C7.54831 39.9506 8.13932 41.6574 9.4896 43.0077C10.8399 44.358 12.5467 44.949 14.6192 45.2277C16.6254 45.4974 19.1833 45.4973 22.3885 45.4973C22.4501 45.4973 22.5 45.4474 22.5 45.3858L22.5 26.7973C22.5 26.4202 22.5 26.2316 22.3828 26.1145C22.2657 25.9973 22.0771 25.9973 21.7 25.9973H11.3782C10.5449 25.9974 9.7211 25.9974 9.02081 25.9467C8.73008 25.9256 8.41116 25.8933 8.07357 25.8364Z" />
      <path d="M27.3 25.9973C26.9229 25.9973 26.7343 25.9973 26.6172 26.1145C26.5 26.2316 26.5 26.4202 26.5 26.7973V45.3858C26.5 45.4474 26.5499 45.4973 26.6115 45.4973C29.8167 45.4973 32.3746 45.4974 34.3808 45.2277C36.4533 44.949 38.1601 44.358 39.5104 43.0077C40.8607 41.6574 41.4517 39.9506 41.7303 37.8781C42.0001 35.8719 42 33.314 42 30.1088V26.68C42 26.1887 42 25.943 41.8583 25.8232C41.7166 25.7033 41.4532 25.7477 40.9264 25.8364C40.5888 25.8933 40.2699 25.9256 39.9792 25.9467C39.2789 25.9974 38.4551 25.9974 37.6218 25.9973H27.3Z" />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0714 2.50012C12.9944 2.50012 10.5 4.99453 10.5 8.07155C10.5 12.7265 14.2736 16.5001 18.9286 16.5001H24.5H30.0714C34.7264 16.5001 38.5 12.7265 38.5 8.07155C38.5 4.99453 36.0056 2.50012 32.9286 2.50012H32.2143C29.0705 2.50012 26.2755 3.99352 24.5 6.3096C22.7245 3.99352 19.9295 2.50012 16.7857 2.50012H16.0714ZM22.5 12.2144C22.5 9.0585 19.9416 6.50012 16.7857 6.50012H16.0714C15.2036 6.50012 14.5 7.20368 14.5 8.07155C14.5 10.5174 16.4827 12.5001 18.9286 12.5001H22.5V12.2144ZM26.5 12.5001H30.0714C32.5173 12.5001 34.5 10.5174 34.5 8.07155C34.5 7.20368 33.7964 6.50012 32.9286 6.50012H32.2143C29.0584 6.50012 26.5 9.0585 26.5 12.2144V12.5001Z"
      fill="#00151A"
    />
  </Icon>
);

export const InvoicingIcon = (props: IconProps) => (
  <Icon
    width="49px"
    height="48px"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M28.6106 2.5H20.3894H20.3894C17.655 2.49996 15.4495 2.49993 13.7147 2.73528C11.912 2.97983 10.3952 3.50322 9.19194 4.71738C7.99051 5.92967 7.47432 7.4547 7.23281 9.26724C6.99993 11.0151 6.99996 13.2381 7 15.9995V15.9995L7.00001 37.4016C6.99992 38.8191 6.99985 40.0396 7.1298 40.9739C7.26304 41.9317 7.58494 43.0214 8.61169 43.6827C10.1287 44.6598 11.81 43.9835 12.7542 43.4895C13.2949 43.2066 14.8204 42.173 15.2419 41.8833C15.7875 41.5392 16.0896 41.3559 16.3158 41.2497C16.3592 41.2032 16.5024 41.1411 16.7281 41.2654C16.9565 41.3798 17.2483 41.5618 17.7581 41.8833L21.6333 44.3272C22.1026 44.6233 22.547 44.9036 22.9478 45.1013C23.3952 45.3221 23.9014 45.5 24.5 45.5C25.0986 45.5 25.6048 45.3221 26.0522 45.1013C26.4529 44.9036 26.8972 44.6234 27.3664 44.3274L27.3667 44.3273L31.2419 41.8833C31.7875 41.5392 32.0896 41.3559 32.3158 41.2497C32.366 41.2071 32.5187 41.1507 32.7281 41.2654C32.9565 41.3798 34.2657 42.2606 34.7755 42.5821C35.197 42.8719 35.7051 43.2066 36.2458 43.4895C37.19 43.9835 38.8713 44.6598 40.3883 43.6827C41.4151 43.0214 41.737 41.9317 41.8702 40.9739C42.0002 40.0396 42.0001 38.8191 42 37.4016L42 15.9996C42 13.2381 42.0001 11.0151 41.7672 9.26724C41.5257 7.4547 41.0095 5.92967 39.8081 4.71738C38.6048 3.50322 37.088 2.97983 35.2853 2.73528C33.5505 2.49993 31.345 2.49996 28.6106 2.5H28.6106Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.5 22C24.5 23.1046 23.6046 24 22.5 24H16.5C15.3954 24 14.5 23.1046 14.5 22C14.5 20.8954 15.3954 20 16.5 20H22.5C23.6046 20 24.5 20.8954 24.5 22Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.5 14C30.5 15.1046 29.6046 16 28.5 16H16.5C15.3954 16 14.5 15.1046 14.5 14C14.5 12.8954 15.3954 12 16.5 12L28.5 12C29.6046 12 30.5 12.8954 30.5 14Z"
      fill="#00151A"
    />
  </Icon>
);

export const POSIcon = (props: IconProps) => (
  <Icon
    width="49px"
    height="48"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M26.0927 2.00531C25.5632 2.00783 25.0346 2.01035 24.5073 2.01035C23.9801 2.01035 23.4515 2.00783 22.922 2.00531C20.0693 1.99172 17.1924 1.97801 14.3693 2.35751C11.6978 2.71666 9.48658 3.47988 7.7357 5.23055C6.13044 6.83563 5.3535 8.82998 4.95896 11.2167C4.37208 14.7671 4.51561 18.4204 4.51561 22.0086V26.1552C4.51556 30.2705 4.51552 33.5622 4.86282 36.1454C5.222 38.817 5.98531 41.0283 7.73618 42.7792C9.48706 44.5302 11.6983 45.2935 14.3698 45.6527C17.1929 46.0322 20.0698 46.0185 22.9225 46.0049H22.9226C23.452 46.0024 23.9806 45.9999 24.5078 45.9999C25.0351 45.9999 25.5637 46.0024 26.0931 46.0049H26.0932C28.9459 46.0185 31.8228 46.0322 34.6458 45.6527C37.3174 45.2935 39.5286 44.5302 41.2794 42.7792C43.0303 41.0283 43.7936 38.817 44.1528 36.1454C44.5001 33.5622 44.5001 30.2706 44.5 26.1552V22.0086C44.5 21.243 44.5009 20.5151 44.4975 19.7783C44.4879 16.3252 44.4327 13.4973 44.0557 11.2167C43.6612 8.82998 42.8842 6.83563 41.279 5.23055C39.5281 3.47988 37.3169 2.71666 34.6453 2.35751C31.8223 1.97801 28.9454 1.99172 26.0927 2.00531Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9003 6.31957C12.6721 6.61911 11.4453 7.17324 10.5612 8.05727C9.74713 8.87122 9.21539 9.97272 8.90202 11.8684C8.68434 13.1853 8.58716 14.782 8.54443 16.7891C8.53233 17.3574 8.52628 17.6416 8.70269 17.8218C8.8791 18.002 9.16546 18.002 9.73819 18.002H39.2728C39.8455 18.002 40.1319 18.002 40.3083 17.8218C40.4847 17.6416 40.4786 17.3574 40.4665 16.7891C40.4238 14.782 40.3266 13.1853 40.1089 11.8684C39.7956 9.97272 39.2638 8.87122 38.4498 8.05727C37.5657 7.17324 36.3389 6.61911 34.1107 6.31957C31.825 6.0123 28.803 6.00806 24.5055 6.00806C20.208 6.00806 17.186 6.0123 14.9003 6.31957ZM30.5001 10.0002C29.3956 10.0002 28.5001 10.8957 28.5001 12.0002C28.5001 13.1048 29.3956 14.0002 30.5001 14.0002L34.5001 14.0002C35.6047 14.0002 36.5001 13.1048 36.5001 12.0002C36.5001 10.8957 35.6047 10.0002 34.5001 10.0002L30.5001 10.0002Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5001 28.0002C12.5001 26.8957 13.3956 26.0002 14.5001 26.0002H15.5528C16.6573 26.0002 17.5528 26.8957 17.5528 28.0002C17.5528 29.1048 16.6573 30.0002 15.5528 30.0002H14.5001C13.3956 30.0002 12.5001 29.1048 12.5001 28.0002ZM21.9738 28.0002C21.9738 26.8957 22.8692 26.0002 23.9738 26.0002H25.0264C26.131 26.0002 27.0264 26.8957 27.0264 28.0002C27.0264 29.1048 26.131 30.0002 25.0264 30.0002H23.9738C22.8692 30.0002 21.9738 29.1048 21.9738 28.0002ZM31.4475 28.0002C31.4475 26.8957 32.3429 26.0002 33.4475 26.0002H34.5001C35.6047 26.0002 36.5001 26.8957 36.5001 28.0002C36.5001 29.1048 35.6047 30.0002 34.5001 30.0002H33.4475C32.3429 30.0002 31.4475 29.1048 31.4475 28.0002Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5001 36.0002C12.5001 34.8957 13.3956 34.0002 14.5001 34.0002H15.5528C16.6573 34.0002 17.5528 34.8957 17.5528 36.0002C17.5528 37.1048 16.6573 38.0002 15.5528 38.0002H14.5001C13.3956 38.0002 12.5001 37.1048 12.5001 36.0002ZM21.9738 36.0002C21.9738 34.8957 22.8692 34.0002 23.9738 34.0002H25.0264C26.131 34.0002 27.0264 34.8957 27.0264 36.0002C27.0264 37.1048 26.131 38.0002 25.0264 38.0002H23.9738C22.8692 38.0002 21.9738 37.1048 21.9738 36.0002ZM31.4475 36.0002C31.4475 34.8957 32.3429 34.0002 33.4475 34.0002H34.5001C35.6047 34.0002 36.5001 34.8957 36.5001 36.0002C36.5001 37.1048 35.6047 38.0002 34.5001 38.0002H33.4475C32.3429 38.0002 31.4475 37.1048 31.4475 36.0002Z"
      fill="#00151A"
    />
  </Icon>
);

export const BudgetingIcon = (props: IconProps) => (
  <Icon
    width="49px"
    height="48px"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M7.16406 23.3721C7.16406 18.3296 11.97 14.4453 17.616 14.4453C18.3026 14.4453 18.8592 14.9666 18.8592 15.6097V23.3721C18.8592 24.0151 18.3026 24.5364 17.616 24.5364H8.40725C7.72065 24.5364 7.16406 24.0151 7.16406 23.3721Z"
    />
    <path
      d="M9.11917 27.5391L9.23976 27.5391H17.5548C17.9009 27.5391 18.2329 27.6702 18.4777 27.9035C18.7225 28.1368 18.86 28.4532 18.86 28.7832L18.86 40.3946C18.86 41.0817 18.2756 41.6387 17.5548 41.6387C11.6167 41.6387 6.42435 38.609 4.05827 34.1395L4.0046 34.0382C3.62271 33.3177 3.23071 32.5782 3.0764 31.8594C2.88575 30.9714 3.04992 30.1532 3.59125 29.315C4.1907 28.3867 5.02961 27.9214 6.04132 27.7147C6.90294 27.5387 7.96604 27.5389 9.11917 27.5391Z"
      fill="#00151A"
    />
    <path
      opacity="0.4"
      d="M21.8985 28.8322C21.8985 28.118 22.4763 27.5391 23.189 27.5391H40.3966C41.1094 27.5391 41.6872 28.118 41.6872 28.8322C41.6872 36.4751 36.112 42.8138 28.636 44.9032L28.5335 44.9318C27.6023 45.1923 26.728 45.4368 25.9587 45.4917C25.0554 45.5562 24.2236 45.3709 23.4289 44.7663C22.5865 44.1254 22.2111 43.28 22.0455 42.3353C21.8982 41.4954 21.8983 40.4532 21.8984 39.2824L21.8985 39.1777V28.8322Z"
    />
    <path
      d="M28.6757 2.96584L28.7787 2.9891C36.7142 4.78076 43.0851 10.3468 45.3134 17.5715L45.3463 17.678L45.3463 17.678C45.6345 18.6118 45.9081 19.4981 45.9798 20.2875C46.0647 21.2222 45.8795 22.0813 45.2681 22.9125C44.6162 23.7987 43.7499 24.2002 42.7725 24.3774C41.9087 24.534 40.8379 24.5339 39.6406 24.5337H39.6405L39.5311 24.5337H21.8985V9.02216L21.8984 8.91844C21.8983 7.71492 21.8982 6.65104 22.0411 5.79468C22.2002 4.84086 22.5608 3.97409 23.3918 3.30764C24.1847 2.67184 25.0355 2.47123 25.9552 2.50324C26.7509 2.53093 27.6741 2.73952 28.6757 2.96584Z"
      fill="#00151A"
    />
  </Icon>
);

export const InsuranceIcon = (props: IconProps) => (
  <Icon
    width="49px"
    height="48px"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M14.4453 24.4073C17.4134 26.0577 20.8452 27 24.5016 27C28.158 27 31.5898 26.0577 34.558 24.4073C33.4458 14.5864 26.3801 7 24.5016 7C22.6231 7 15.5574 14.5865 14.4453 24.4073Z"
    />
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.5 2C25.6046 2 26.5 2.89543 26.5 4V7C26.5 8.10457 25.6046 9 24.5 9C23.3954 9 22.5 8.10457 22.5 7V4C22.5 2.89543 23.3954 2 24.5 2Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.77936 22.1079C7.61552 22.5044 8.66333 22.733 9.82973 22.8067C10.846 22.871 11.8413 22.8103 12.6672 22.7019C13.4719 18.0093 15.4705 13.9034 17.5345 10.8905C17.7141 10.6283 17.895 10.3732 18.0765 10.1257C12.6031 12.1186 8.37166 16.5832 6.77936 22.1079ZM24.5 5C13.6869 5 4.62651 12.5286 2.54156 22.5943C2.39447 23.3045 2.64332 24.0386 3.19191 24.5129C5.05775 26.1261 7.51757 26.6685 9.57731 26.7988C11.2822 26.9066 12.9211 26.7454 14.147 26.5158C17.2467 28.1038 20.77 29 24.5 29C28.23 29 31.7533 28.1038 34.853 26.5158C36.079 26.7454 37.718 26.9066 39.4229 26.7988C41.4827 26.6685 43.9426 26.1261 45.8082 24.5128C46.3567 24.0385 46.6055 23.3044 46.4584 22.5943C44.3735 12.5286 35.313 5 24.5 5ZM24.5 9.12567C24.2811 9.27023 23.9918 9.49458 23.6435 9.81361C22.8306 10.5583 21.8338 11.6924 20.8344 13.1511C19.035 15.7778 17.3261 19.3117 16.6274 23.276C19.0115 24.3808 21.6791 25 24.5 25C27.3209 25 29.9884 24.3808 32.3726 23.276C31.6739 19.3117 29.9649 15.7778 28.1656 13.1511C27.1662 11.6924 26.1694 10.5583 25.3565 9.81361C25.0082 9.49458 24.7188 9.27023 24.5 9.12567ZM36.3328 22.7019C35.5281 18.0093 33.5295 13.9034 31.4655 10.8905C31.2859 10.6283 31.105 10.3732 30.9235 10.1257C36.3969 12.1186 40.6284 16.5832 42.2206 22.108C41.3847 22.5044 40.3369 22.733 39.1705 22.8067C38.1542 22.871 37.1588 22.8103 36.3328 22.7019Z"
      fill="#00151A"
    />
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.5 25C25.6046 25 26.5 25.8954 26.5 27V41C26.5 43.7614 24.2614 46 21.5 46C18.7386 46 16.5 43.7614 16.5 41V40C16.5 38.8954 17.3954 38 18.5 38C19.6046 38 20.5 38.8954 20.5 40V41C20.5 41.5523 20.9477 42 21.5 42C22.0523 42 22.5 41.5523 22.5 41V27C22.5 25.8954 23.3954 25 24.5 25Z"
    />
  </Icon>
);

export const TravelIcon = (props: IconProps) => (
  <Icon
    width="49px"
    height="48px"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M34.2832 8.17703C36.9811 6.99515 39.4718 7.59586 41.6527 8.20495C42.5668 8.4587 43.59 8.74282 44.2198 9.19762C45.2039 9.90826 45.8481 11.0042 45.981 12.2123C46.0815 13.1261 45.7917 14.0442 45.5673 14.919C45.0106 17.0905 44.2887 19.532 41.8941 21.2525C40.9945 21.899 39.6079 22.6104 38.4991 23.1432C37.3596 23.6909 36.391 24.1072 36.2624 24.1622L21.8488 30.3532C20.1506 31.0811 19.7744 31.2819 19.524 31.5747C18.3583 32.9378 18.378 35.2127 17.953 36.8706C17.7393 37.704 17.1443 38.6187 16.4614 39.2834C15.8248 39.9032 14.6645 40.7298 13.2775 40.4418C11.8493 40.1452 11.3866 38.8299 11.2281 37.5558L10.2512 31.428C10.1908 31.0501 10.1606 30.8611 10.0664 30.6996C9.97227 30.5382 9.82264 30.4189 9.52338 30.1802L4.62225 26.2713C3.59037 25.5037 2.65982 24.4482 3.12153 23.0555C3.56973 21.7036 4.88938 21.1271 5.73945 20.8962C6.66148 20.6457 7.75315 20.5964 8.57975 20.8272C10.2589 21.2962 12.2383 22.4515 14.0337 22.1339C14.4218 22.0653 14.7875 21.8423 16.2733 20.7567L28.9137 11.5349C29.0266 11.4522 29.8765 10.8326 30.9269 10.1326C31.9492 9.45133 33.2667 8.62231 34.2832 8.17703Z"
      fill="#00151A"
    />
    <g opacity="0.4">
      <path d="M26.9158 30.8995C26.1294 31.2372 25.7361 31.4061 25.5754 31.7546C25.4146 32.1031 25.5414 32.5119 25.7948 33.3294L28.292 41.3838C28.5064 42.0751 28.9385 42.9668 29.9015 43.3429C30.8628 43.7183 31.7731 43.3529 32.3623 43.0151C33.385 42.4287 34.2353 41.7208 34.8149 40.7437C35.3937 39.7678 35.6157 38.6694 35.6432 37.4556L35.8506 28.2941C35.8633 27.7337 35.8696 27.4535 35.6886 27.3313C35.5076 27.2091 35.2501 27.3197 34.735 27.5409L26.9158 30.8995Z" />
      <path d="M17.3148 5.47534C16.1987 4.86284 15.0927 4.49016 13.9155 4.50039C12.7361 4.51064 11.6552 4.90378 10.5881 5.52098C9.97542 5.87539 9.18612 6.49696 9.0301 7.53891C8.87437 8.57895 9.44251 9.41826 9.95519 9.97126L15.6074 15.982C16.1833 16.5944 16.4712 16.9006 16.8478 16.9357C17.2244 16.9708 17.564 16.723 18.2431 16.2276L25.2387 11.1239C25.696 10.7903 25.9247 10.6234 25.9106 10.4041C25.8965 10.1849 25.6484 10.0487 25.1521 9.77631L17.3148 5.47534Z" />
    </g>
  </Icon>
);

export const MoviesIcon = (props: IconProps) => (
  <Icon
    width="44px"
    height="46px"
    viewBox="0 0 44 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.5297 18.3998C36.4034 18.8946 34.9454 19.765 32.7812 21.0637L32.5294 21.2148C31.5823 21.7832 30.3537 21.4761 29.7854 20.529C29.217 19.5818 29.5241 18.3533 30.4712 17.785L30.723 17.6338C30.7629 17.6099 30.8026 17.5861 30.8421 17.5624C32.8564 16.3536 34.5333 15.3473 35.9207 14.7377C37.3356 14.116 38.8918 13.6995 40.4782 14.2715C41.2686 14.5564 41.9308 15.0433 42.4193 15.7384C42.8797 16.3936 43.1151 17.1332 43.251 17.8318C43.5009 19.1167 43.5006 20.8047 43.5003 22.6713C43.5003 22.735 43.5003 22.799 43.5003 22.8631V25.1378C43.5003 25.2019 43.5003 25.2659 43.5003 25.3296C43.5006 27.1963 43.5009 28.8842 43.251 30.1691C43.1151 30.8678 42.8797 31.6073 42.4193 32.2625C41.9307 32.9576 41.2686 33.4445 40.4782 33.7295C38.8918 34.3014 37.3356 33.8849 35.9207 33.2632C34.5333 32.6537 32.8564 31.6473 30.8421 30.4385L30.4712 30.216C29.5241 29.6476 29.217 28.4191 29.7854 27.4719C30.3537 26.5248 31.5823 26.2178 32.5294 26.7861L32.7812 26.9372C34.9454 28.2359 36.4034 29.1063 37.5297 29.6011C38.6556 30.0958 39.0075 30.0076 39.1216 29.9665C39.1351 29.9616 39.1451 29.9575 39.1521 29.9543C39.1776 29.9137 39.254 29.7683 39.3245 29.4055C39.4912 28.5486 39.5003 27.2598 39.5003 25.1378V22.8631C39.5003 20.7411 39.4912 19.4523 39.3245 18.5955C39.254 18.2326 39.1776 18.0872 39.1521 18.0466C39.1451 18.0434 39.1351 18.0393 39.1216 18.0344C39.0075 17.9933 38.6556 17.9051 37.5297 18.3998Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.4992 5.80312C20.7319 5.80312 19.2992 7.23581 19.2992 9.00313C19.2992 10.7704 20.7319 12.2031 22.4992 12.2031C24.2665 12.2031 25.6992 10.7704 25.6992 9.00313C25.6992 7.23581 24.2665 5.80312 22.4992 5.80312ZM15.6992 9.00313C15.6992 5.24759 18.7437 2.20312 22.4992 2.20312C26.2548 2.20312 29.2992 5.24759 29.2992 9.00313C29.2992 12.7587 26.2548 15.8031 22.4992 15.8031C18.7437 15.8031 15.6992 12.7587 15.6992 9.00313Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4992 3.80312C9.17962 3.80312 7.29922 5.68353 7.29922 8.00313C7.29922 10.3227 9.17962 12.2031 11.4992 12.2031C13.8188 12.2031 15.6992 10.3227 15.6992 8.00313C15.6992 5.68353 13.8188 3.80312 11.4992 3.80312ZM3.69922 8.00313C3.69922 3.6953 7.1914 0.203125 11.4992 0.203125C15.807 0.203125 19.2992 3.6953 19.2992 8.00313C19.2992 12.3109 15.807 15.8031 11.4992 15.8031C7.1914 15.8031 3.69922 12.3109 3.69922 8.00313Z"
      fill="#00151A"
    />
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2104 35.4688L5.08579 40.5934C4.30474 41.3744 4.30474 42.6408 5.08579 43.4218C5.86684 44.2029 7.13317 44.2029 7.91421 43.4218L14.5 36.836L14.5 44.0076C14.5 45.1122 15.3954 46.0076 16.5 46.0076C17.6046 46.0076 18.5 45.1122 18.5 44.0076V36.836L25.0858 43.4218C25.8668 44.2029 27.1332 44.2029 27.9142 43.4218C28.6953 42.6408 28.6953 41.3744 27.9142 40.5934L22.7896 35.4688C21.2974 35.5076 19.5707 35.5076 17.5731 35.5076H15.427C13.4293 35.5076 11.7026 35.5076 10.2104 35.4688Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.427 12.5H17.573C20.8111 12.5 23.3374 12.5 25.3065 12.6654C27.2874 12.8319 28.9136 13.1774 30.2448 14.0094C31.6669 14.8982 32.3827 16.1118 32.7102 17.634C33.0004 18.983 33.0002 20.6662 33 22.5987C33 22.649 33 22.6994 33 22.75V25.25C33 25.3006 33 25.351 33 25.4013C33.0002 27.3338 33.0004 29.017 32.7102 30.366C32.3827 31.8882 31.6669 33.1018 30.2448 33.9906C28.9136 34.8226 27.2874 35.1681 25.3065 35.3346C23.3374 35.5 20.8111 35.5 17.5731 35.5H15.427C12.1889 35.5 9.6626 35.5 7.69352 35.3346C5.7126 35.1681 4.08646 34.8226 2.75527 33.9906C1.33314 33.1018 0.617299 31.8882 0.289848 30.366C-0.000355065 29.017 -0.000185078 27.3338 1.00678e-05 25.4013C1.51938e-05 25.3511 2.03198e-05 25.3006 2.03198e-05 25.25V22.75C2.03198e-05 22.6994 1.51938e-05 22.6489 1.00678e-05 22.5987C-0.000185078 20.6662 -0.000355065 18.983 0.289848 17.634C0.617299 16.1118 1.33314 14.8982 2.75527 14.0094C4.08646 13.1774 5.7126 12.8319 7.69352 12.6654C9.6626 12.5 12.189 12.5 15.427 12.5Z"
      fill="#00151A"
    />
  </Icon>
);

export const EventsIcon = (props: IconProps) => (
  <Icon
    width="43px"
    height="38px"
    viewBox="0 0 43 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M17.3943 0.5C14.1808 0.49998 11.6433 0.499965 9.62276 0.725423C7.55135 0.956561 5.84984 1.43926 4.38601 2.52432C3.37972 3.27023 2.50871 4.1936 1.80986 5.25016C0.519459 7.20106 0.13876 9.56614 0.00306702 12.6918C-0.0617561 14.185 1.19621 15.1875 2.43061 15.1875C4.2944 15.1875 5.94897 16.8128 5.94897 19C5.94897 21.1872 4.2944 22.8125 2.43061 22.8125C1.19621 22.8125 -0.0617561 23.815 0.00306702 25.3082C0.13876 28.4339 0.519459 30.7989 1.80986 32.7498C2.50871 33.8064 3.37971 34.7298 4.38601 35.4757C5.84984 36.5607 7.55135 37.0434 9.62276 37.2746C11.6433 37.5 14.1808 37.5 17.3942 37.5H17.3944H25.6073H25.6074C28.8208 37.5 31.3584 37.5 33.3788 37.2746C35.4503 37.0434 37.1518 36.5607 38.6156 35.4757C39.6219 34.7298 40.4929 33.8064 41.1918 32.7498C42.4823 30.7987 42.8629 28.4333 42.9986 25.3071C42.9995 25.2855 43 25.2638 43 25.2421V12.7579C43 12.7362 42.9995 12.7145 42.9986 12.6929C42.8629 9.56667 42.4823 7.20127 41.1917 5.25016C40.4929 4.1936 39.6219 3.27023 38.6156 2.52432C37.1518 1.43926 35.4503 0.956561 33.3788 0.725423C31.3583 0.499965 28.8208 0.49998 25.6073 0.5H25.6073H17.3943H17.3943Z"
    />
    <path
      d="M26.497 11.5C27.7147 11.5 28.4893 12.4102 28.8799 13.2011L28.8808 13.2029L29.8613 15.18L31.6058 15.4722C32.4822 15.6195 33.5317 16.1068 33.891 17.2338C34.2496 18.3587 33.6789 19.3633 33.0505 19.9934L33.0485 19.9954L31.6887 21.3665L32.0756 23.0533C32.2716 23.9111 32.3323 25.2732 31.2474 26.0705C30.1564 26.8725 28.8722 26.3957 28.1167 25.9458L26.4977 24.9795L24.8795 25.9453C24.1196 26.3999 22.8389 26.8692 21.7498 26.0679C20.668 25.272 20.7222 23.9148 20.9202 23.052L21.3068 21.3665L19.9433 19.9918C19.3188 19.3621 18.7504 18.359 19.1059 17.2365C19.4632 16.1083 20.5125 15.6196 21.3905 15.4721L23.1277 15.1811L24.11 13.2001L24.1114 13.1973C24.5048 12.4082 25.281 11.5 26.497 11.5Z"
      fill="#00151A"
    />
    <path
      d="M15 37.4997C13.9117 37.4938 12.9145 37.4794 12 37.4442V29.0037C12 28.1753 12.6716 27.5037 13.5 27.5037C14.3284 27.5037 15 28.1753 15 29.0037L15 37.4997Z"
      fill="#00151A"
    />
    <path
      d="M15 0.507812V9.00375C15 9.83217 14.3284 10.5037 13.5 10.5037C12.6716 10.5037 12 9.83217 12 9.00375V0.563331C12.9145 0.528107 13.9117 0.513701 15 0.507812Z"
      fill="#00151A"
    />
  </Icon>
);

export const OutletsIcon = (props: IconProps) => (
  <Icon
    width="43px"
    height="44px"
    viewBox="0 0 43 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M32.4318 0.500002C33.7028 0.499951 34.7856 0.499907 35.6724 0.604759C36.6205 0.716863 37.4948 0.962205 38.2863 1.55298C39.0734 2.14048 39.5657 2.91091 39.9611 3.79107C40.3343 4.622 40.6745 5.67904 41.078 6.93277L42.4705 11.2591L42.5005 11.3521C42.8526 12.4445 43.1349 13.3204 42.9282 14.6446C42.8426 15.1935 42.7332 15.6438 42.5478 16.0609C42.3734 16.4532 42.1559 16.7538 41.9893 16.9841L41.9645 17.0183C39.9962 19.7436 36.3871 21.5 33.0086 21.5C30.8491 21.5 28.8544 20.7866 27.2533 19.5845C25.6517 20.7874 23.6578 21.5 21.4978 21.5C19.339 21.5 17.3448 20.787 15.7439 19.5855C14.1425 20.7878 12.1491 21.5 9.98979 21.5C6.61124 21.5 3.00215 19.7436 1.03385 17.0183L1.00911 16.9841C0.842467 16.7538 0.625016 16.4532 0.450604 16.0609C0.26518 15.6438 0.155775 15.1935 0.0701248 14.6446C-0.136533 13.3204 0.145768 12.4445 0.4979 11.3521L0.527856 11.2591L1.89531 7.0106L1.92035 6.93279L1.92036 6.93278C2.32385 5.67905 2.66404 4.62201 3.0373 3.79107C3.43267 2.91091 3.925 2.14048 4.71208 1.55298C5.50355 0.962205 6.37783 0.716863 7.32598 0.604759C8.2128 0.499907 9.29555 0.499951 10.5666 0.500002L32.4318 0.500002Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 32C9.5 30.8954 10.3954 30 11.5 30L19.5 30C20.6046 30 21.5 30.8954 21.5 32C21.5 33.1046 20.6046 34 19.5 34H11.5C10.3954 34 9.5 33.1046 9.5 32Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.5 23.5C29.8325 23.5 26 27.2201 26 31.8686C26 34.517 27.3326 36.4954 28.7142 38.0786C29.2066 38.6428 29.7476 39.2023 30.2533 39.7252L30.2533 39.7253L30.2534 39.7254L30.2541 39.7261C30.4455 39.924 30.6318 40.1167 30.8085 40.3024C31.481 41.0093 32.0589 41.6593 32.5054 42.3231C32.879 42.8784 33.5467 43.5 34.5116 43.5C35.4927 43.5 36.1586 42.8599 36.5205 42.2832C36.9446 41.6074 37.5052 40.9586 38.1662 40.2621C38.3822 40.0345 38.62 39.7908 38.8666 39.5382L38.8666 39.5382L38.8668 39.5381C39.3261 39.0675 39.8157 38.566 40.2504 38.0797C41.6429 36.5217 43 34.5706 43 31.8686C43 27.2201 39.1675 23.5 34.5 23.5ZM34.4866 35C32.8371 35 31.5 33.6569 31.5 32C31.5 30.3431 32.8371 29 34.4866 29H34.5134C36.1629 29 37.5 30.3431 37.5 32C37.5 33.6569 36.1629 35 34.5134 35H34.4866Z"
      fill="#00151A"
    />
    <path
      d="M1.50001 17.6094L1.5 27.6399C1.49994 30.3481 1.49988 32.5814 1.73751 34.3489C1.987 36.2045 2.53094 37.8434 3.84315 39.1556C5.15537 40.4678 6.79422 41.0118 8.64988 41.2612C10.4174 41.4989 12.6506 41.4988 15.3589 41.4988H21.5693C22.7016 41.4988 23.608 40.5597 23.5681 39.4282C23.5301 38.3518 22.6465 37.4988 21.5693 37.4988H15.5C12.615 37.4988 10.6525 37.4945 9.18287 37.2969C7.77077 37.1071 7.11672 36.7723 6.67158 36.3272C6.22644 35.882 5.8917 35.228 5.70185 33.8159C5.50426 32.3463 5.50001 30.3837 5.50001 27.4988L5.50001 20.5215C3.95884 19.8453 2.55661 18.8456 1.50001 17.6094Z"
      fill="#00151A"
    />
  </Icon>
);

export const ManagementIcon = (props: IconProps) => (
  <Icon
    width="41px"
    height="42px"
    viewBox="0 0 41 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M1.00819 18.8442C4.84583 25.824 13.0956 28.4973 20.5002 28.4973C27.905 28.4973 36.155 25.8239 39.9925 18.8438C40.0001 18.9179 40.0023 18.9929 39.9987 19.0683L39.6875 25.6366C39.5279 28.9816 39.4006 31.6483 39.0095 33.7351C38.6045 35.8955 37.8834 37.639 36.3923 38.9961C34.9108 40.3444 33.0776 40.9389 30.8274 41.2218C28.6352 41.4974 25.8446 41.4974 22.3164 41.4973H18.6843C15.1561 41.4974 12.3655 41.4974 10.1733 41.2218C7.92312 40.9389 6.08997 40.3444 4.60846 38.9961C3.1173 37.639 2.39625 35.8955 1.99128 33.7351C1.60012 31.6483 1.47287 28.9815 1.31326 25.6366L1.00205 19.0683C0.998485 18.9931 1.0006 18.9182 1.00819 18.8442Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.463767 11.8176C1.17796 9.64585 2.89816 7.5 5.79621 7.5H35.2042C38.1022 7.5 39.8224 9.64585 40.5366 11.8176C41.2451 13.972 41.1645 16.6237 40.1335 18.5843C36.3601 25.7597 27.997 28.5 20.5002 28.5C13.0034 28.5 4.64033 25.7597 0.866948 18.5843C-0.164065 16.6237 -0.244737 13.972 0.463767 11.8176ZM20.4914 17C19.3918 17 18.5004 17.8954 18.5004 19C18.5004 20.1046 19.3918 21 20.4914 21H20.5093C21.6089 21 22.5004 20.1046 22.5004 19C22.5004 17.8954 21.6089 17 20.5093 17H20.4914Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.1502 6.96341e-06C20.3845 2.84421e-05 20.62 2.83103e-05 20.8529 6.96341e-06C22.1436 -0.000109146 23.3014 -0.00021334 24.2612 0.127631C25.3227 0.269019 26.3364 0.586547 27.2445 1.35014C28.1263 2.09163 28.6527 3.04015 29.0617 4.0659C29.4505 5.04092 29.804 6.27828 30.2206 7.73657L30.4246 8.45057L26.5785 9.54946L26.4019 8.93133C25.9504 7.35122 25.6508 6.3114 25.3462 5.54745C25.0533 4.81294 24.8359 4.55101 24.6702 4.41163C24.5307 4.29435 24.3249 4.17144 23.7331 4.09261C23.0686 4.00411 22.1805 4.00001 20.7355 4.00001H20.2676C18.8226 4.00001 17.9345 4.00411 17.27 4.09261C16.6782 4.17144 16.4724 4.29435 16.3329 4.41163C16.1672 4.55101 15.9498 4.81294 15.6569 5.54745C15.3523 6.3114 15.0527 7.35123 14.6012 8.93133L14.4246 9.54946L10.5785 8.45057C10.6465 8.21258 10.7145 7.97459 10.7825 7.73659C11.1991 6.27829 11.5526 5.04092 11.9414 4.0659C12.3504 3.04015 12.8768 2.09163 13.7586 1.35014C14.6666 0.586547 15.6804 0.269019 16.7419 0.127631C17.7017 -0.00021334 18.8595 -0.000109146 20.1502 6.96341e-06Z"
      fill="#00151A"
    />
  </Icon>
);

export const VirtualAccountIcon = (props: IconProps) => (
  <Icon
    width="43px"
    height="40px"
    viewBox="0 0 43 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.1699 8.43899C35.1478 7.61491 35.0861 6.91675 34.9154 6.28113C34.1925 3.58942 32.0851 1.48696 29.3871 0.765721C28.3871 0.498384 27.2326 0.499008 25.678 0.499848L5.86364 0.499944C2.62524 0.499944 1.37098e-06 3.11907 1.37098e-06 6.34992V22.0925C-5.10251e-05 25.6482 -9.32515e-05 28.5143 0.30367 30.7683C0.619046 33.1086 1.29374 35.0791 2.86237 36.6441C4.431 38.209 6.40607 38.8822 8.7518 39.1968C11.0112 39.4998 13.8839 39.4998 17.448 39.4998H29.4561C32.1027 39.4998 34.2853 39.4999 36.0126 39.2682C37.8261 39.0249 39.4277 38.4946 40.7101 37.2152C41.9925 35.9358 42.5241 34.3379 42.7679 32.5287C43.0001 30.8053 43.0001 28.6279 43 25.9874V21.8123C43.0001 19.1717 43.0001 16.9943 42.7679 15.271C42.5241 13.4617 41.9925 11.8639 40.7101 10.5845C39.4277 9.30505 37.8261 8.77472 36.0126 8.53147C35.7428 8.49528 35.4619 8.46475 35.1699 8.43899ZM25.4082 4.3999C27.3517 4.3999 27.94 4.41665 28.3745 4.53279C29.7235 4.89341 30.7772 5.94464 31.1386 7.29049C31.201 7.52259 31.2347 7.79872 31.2527 8.30288C30.6793 8.29985 30.0802 8.29986 29.4552 8.29988L5.86275 8.29988C4.78328 8.29988 3.9082 7.42684 3.9082 6.34989C3.9082 5.27294 4.78328 4.3999 5.86275 4.3999H25.4082Z"
    />
    <path
      d="M36.5 23.9998C36.5 21.7906 34.7091 19.9998 32.5 19.9998C30.2909 19.9998 28.5 21.7906 28.5 23.9998C28.5 26.2089 30.2909 27.9998 32.5 27.9998C34.7091 27.9998 36.5 26.2089 36.5 23.9998Z"
      fill="#00151A"
    />
  </Icon>
);

export const DocumentationIcon = (props: IconProps) => (
  <Icon
    width="35px"
    height="44px"
    viewBox="0 0 35 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M21 2.49927C21 1.55646 21 1.08506 20.7071 0.792162C20.4142 0.499269 19.9428 0.499269 19 0.499269L13.3903 0.499269C10.6551 0.499228 8.45043 0.499196 6.7165 0.732317C4.91629 0.974349 3.40054 1.49214 2.1967 2.69597C0.99287 3.8998 0.475083 5.41555 0.23305 7.21577C-6.96033e-05 8.94969 -3.80949e-05 11.1543 1.00906e-06 13.8895L1.00906e-06 30.109C-3.80949e-05 32.8442 -6.96033e-05 35.0489 0.23305 36.7828C0.475083 38.583 0.99287 40.0987 2.1967 41.3026C3.40054 42.5064 4.91629 43.0242 6.7165 43.2662C8.45044 43.4993 10.6551 43.4993 13.3903 43.4993L21.6097 43.4993C24.3449 43.4993 26.5496 43.4993 28.2835 43.2662C30.0837 43.0242 31.5995 42.5064 32.8033 41.3026C34.0071 40.0987 34.5249 38.583 34.767 36.7828C35.0001 35.0488 35 32.8442 35 30.109V16.4996C35 15.5568 35 15.0854 34.7071 14.7925C34.4142 14.4996 33.9428 14.4996 33 14.4996L28.8614 14.4996C27.424 14.4997 26.1969 14.4998 25.2166 14.368C24.1705 14.2273 23.1839 13.9123 22.3856 13.114C21.5873 12.3157 21.2723 11.3291 21.1317 10.283C20.9999 9.30274 20.9999 8.07569 21 6.63837L21 2.49927Z"
    />
    <path
      d="M34.726 11.4999C34.7318 11.4999 34.7358 11.494 34.7336 11.4886C34.4491 10.8019 33.9059 10.2822 33.3891 9.76734L25.7322 2.11048C25.2174 1.59363 24.6977 1.05045 24.011 0.765992C24.0057 0.763828 24 0.767677 24 0.773332V6.53838C24 8.10379 24.0032 9.12694 24.1049 9.88354C24.2008 10.597 24.3589 10.845 24.5069 10.993C24.6549 11.141 24.9029 11.2991 25.6164 11.395C26.373 11.4967 27.3961 11.4999 28.9615 11.4999H34.726Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 21.9996C8 21.1712 8.67157 20.4996 9.5 20.4996L25.5 20.4996C26.3284 20.4996 27 21.1712 27 21.9996C27 22.8281 26.3284 23.4996 25.5 23.4996L9.5 23.4996C8.67157 23.4996 8 22.8281 8 21.9996ZM8 27.9996C8 27.1712 8.67157 26.4996 9.5 26.4996L25.5 26.4996C26.3284 26.4996 27 27.1712 27 27.9996C27 28.8281 26.3284 29.4996 25.5 29.4996L9.5 29.4996C8.67157 29.4996 8 28.8281 8 27.9996ZM8 33.9996C8 33.1712 8.67157 32.4996 9.5 32.4996H22.5C23.3284 32.4996 24 33.1712 24 33.9996C24 34.8281 23.3284 35.4996 22.5 35.4996H9.5C8.67157 35.4996 8 34.8281 8 33.9996Z"
      fill="#00151A"
    />
  </Icon>
);

export const ApiIntegrationIcon = (props: IconProps) => (
  <Icon
    width="41px"
    height="42px"
    viewBox="0 0 41 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M40.9939 17.6848C40.9904 17.1275 40.9887 16.8489 40.8132 16.6744C40.6377 16.5 40.3578 16.5 39.7981 16.5L1.20191 16.5C0.642161 16.5 0.362287 16.5 0.186776 16.6744C0.0112658 16.8489 0.00956019 17.1275 0.00614905 17.6848C-1.2699e-05 18.6916 -6.3131e-06 19.7574 4.46315e-07 20.8856L4.46315e-07 21.1143C-2.58041e-05 25.4957 -4.6432e-05 28.9371 0.361188 31.624C0.731362 34.3773 1.50543 36.5618 3.22183 38.2782C4.93822 39.9946 7.12273 40.7686 9.87605 41.1388C12.5629 41.5 16.0042 41.5 20.3856 41.5H20.6143C24.9957 41.5 28.4371 41.5 31.124 41.1388C33.8773 40.7686 36.0618 39.9946 37.7782 38.2782C39.4946 36.5618 40.2686 34.3773 40.6388 31.624C41 28.9371 41 25.4958 41 21.1144V20.8857C41 19.7575 41 18.6916 40.9939 17.6848Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.6158 0.5H20.3871C16.0057 0.499974 12.5643 0.499953 9.87745 0.861188C7.12413 1.23136 4.93963 2.00543 3.22323 3.72183C1.50683 5.43822 0.732764 7.62273 0.36259 10.376C0.283763 10.9624 0.222138 11.5846 0.173962 12.2447C0.131516 12.8263 0.110292 13.1171 0.288296 13.3085C0.4663 13.5 0.763285 13.5 1.35725 13.5L39.6455 13.5C40.2395 13.5 40.5365 13.5 40.7145 13.3085C40.8925 13.1171 40.8713 12.8263 40.8288 12.2447C40.7807 11.5846 40.719 10.9624 40.6402 10.376C40.27 7.62273 39.496 5.43822 37.7796 3.72183C36.0632 2.00543 33.8787 1.23136 31.1254 0.861188C28.4385 0.499953 24.9972 0.499974 20.6158 0.5ZM8.5 7C8.5 5.89543 9.39143 5 10.4911 5H10.5089C11.6086 5 12.5 5.89543 12.5 7C12.5 8.10457 11.6086 9 10.5089 9H10.4911C9.39143 9 8.5 8.10457 8.5 7ZM18.4911 5C17.3914 5 16.5 5.89543 16.5 7C16.5 8.10457 17.3914 9 18.4911 9H18.5089C19.6086 9 20.5 8.10457 20.5 7C20.5 5.89543 19.6086 5 18.5089 5H18.4911Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3638 24.0207C10.8229 24.6482 10.8932 25.5954 11.5207 26.1362L13.9738 28.2506C14.3732 28.5949 14.637 28.8245 14.8183 29C14.637 29.1755 14.3732 29.4052 13.9738 29.7495L11.5207 31.8638C10.8932 32.4047 10.8229 33.3518 11.3638 33.9793C11.9047 34.6068 12.8518 34.6771 13.4793 34.1362L15.9324 32.0218C15.9533 32.0038 15.9742 31.9858 15.9951 31.9678C16.4561 31.5707 16.9101 31.1795 17.2364 30.8108C17.5974 30.4031 18 29.8092 18 29C18 28.1909 17.5974 27.597 17.2364 27.1892C16.9101 26.8205 16.4561 26.4294 15.9951 26.0323C15.9742 26.0143 15.9533 25.9962 15.9324 25.9782L13.4793 23.8638C12.8518 23.323 11.9047 23.3932 11.3638 24.0207Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 33C19 32.1716 19.6716 31.5 20.5 31.5L28.5 31.5C29.3284 31.5 30 32.1716 30 33C30 33.8284 29.3284 34.5 28.5 34.5H20.5C19.6716 34.5 19 33.8284 19 33Z"
      fill="#00151A"
    />
  </Icon>
);

export const AuditTrailIcon = (props: IconProps) => (
  <Icon
    width="41px"
    height="42px"
    viewBox="0 0 41 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.3"
      d="M20.6143 0.5C24.9958 0.499973 28.4371 0.499952 31.124 0.861187C33.8773 1.23136 36.0618 2.00543 37.7782 3.72183C39.4946 5.43822 40.2686 7.62273 40.6388 10.376C41 13.0629 41 16.5042 41 20.8856V20.8857V21.1143V21.1144C41 25.4958 41 28.9371 40.6388 31.624C40.2686 34.3773 39.4946 36.5618 37.7782 38.2782C36.0618 39.9946 33.8773 40.7686 31.124 41.1388C28.4371 41.5 24.9958 41.5 20.6144 41.5H20.6143H20.3857H20.3856C16.0042 41.5 12.5629 41.5 9.87605 41.1388C7.12273 40.7686 4.93822 39.9946 3.22183 38.2782C1.50543 36.5618 0.731361 34.3773 0.361187 31.624C-4.79221e-05 28.9371 -2.67095e-05 25.4958 0 21.1143V20.8857C-2.67095e-05 16.5042 -4.79221e-05 13.0629 0.361187 10.376C0.731361 7.62273 1.50543 5.43822 3.22183 3.72183C4.93822 2.00543 7.12273 1.23136 9.87605 0.861187C12.5629 0.499952 16.0042 0.499973 20.3857 0.5H20.6143Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 21.5C11.3284 21.5 12 22.1716 12 23L12 31C12 31.8284 11.3284 32.5 10.5 32.5C9.67157 32.5 9 31.8284 9 31L9 23C9 22.1716 9.67157 21.5 10.5 21.5Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5 9.5C21.3284 9.5 22 10.1716 22 11L22 31C22 31.8284 21.3284 32.5 20.5 32.5C19.6716 32.5 19 31.8284 19 31L19 11C19 10.1716 19.6716 9.5 20.5 9.5Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.5 17.5C31.3284 17.5 32 18.1716 32 19L32 31C32 31.8284 31.3284 32.5 30.5 32.5C29.6716 32.5 29 31.8284 29 31L29 19C29 18.1716 29.6716 17.5 30.5 17.5Z"
      fill="#00151A"
    />
  </Icon>
);

//idea or light bulb
export const LightBulbIcon = (props: IconProps) => (
  <Icon
    width="40px"
    height="32px"
    viewBox="0 0 40 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 16C0 7.16344 7.16344 0 16 0H24C32.8366 0 40 7.16344 40 16C40 24.8366 32.8366 32 24 32H16C7.16344 32 0 24.8366 0 16Z"
      fill="#EEE8FA"
    />
    <path d="M17.4035 23.2621L17.2142 23.9878L17.4035 23.2621ZM16.0436 21.6135L15.3289 21.8409L16.0436 21.6135ZM16.3741 22.4848L15.7327 22.8735L16.3741 22.4848ZM23.9587 21.6135L24.6734 21.8409L23.9587 21.6135ZM23.6281 22.4848L24.2695 22.8735L23.6281 22.4848ZM22.5987 23.2621L22.788 23.9878L22.5987 23.2621ZM23.7455 20.6671L24.0276 19.9722L23.7455 20.6671ZM24.0722 21.142L24.8214 21.1077L24.0722 21.142ZM16.2567 20.6671L15.9747 19.9722L16.2567 20.6671ZM15.93 21.142L15.1808 21.1077L15.93 21.142ZM23.3091 23.4562C23.387 23.0494 23.1204 22.6564 22.7136 22.5785C22.3068 22.5005 21.9138 22.7671 21.8359 23.1739L23.3091 23.4562ZM22.4616 23.8936L21.725 23.7525V23.7525L22.4616 23.8936ZM17.5405 23.8936L18.2771 23.7525V23.7525L17.5405 23.8936ZM18.1662 23.1739C18.0883 22.7671 17.6953 22.5005 17.2885 22.5785C16.8817 22.6564 16.6151 23.0494 16.693 23.4562L18.1662 23.1739ZM18.8125 25.9093L18.5685 26.6185L18.8125 25.9093ZM17.8581 25.0925L17.1991 25.4506L17.8581 25.0925ZM22.144 25.0925L22.8031 25.4506L22.8031 25.4506L22.144 25.0925ZM21.1896 25.9093L21.4337 26.6185L21.1896 25.9093ZM16.7196 21.3809H23.2826V19.8809H16.7196V21.3809ZM21.7052 22.5651H18.297V24.0651H21.7052V22.5651ZM18.297 22.5651C17.7942 22.5651 17.6804 22.5592 17.5928 22.5364L17.2142 23.9878C17.533 24.0709 17.8793 24.0651 18.297 24.0651V22.5651ZM15.3289 21.8409C15.4623 22.2601 15.563 22.5934 15.7327 22.8735L17.0155 22.0961C16.9608 22.0057 16.9159 21.8816 16.7583 21.3861L15.3289 21.8409ZM17.5928 22.5364C17.3624 22.4763 17.153 22.323 17.0155 22.0961L15.7327 22.8735C16.0655 23.4225 16.5933 23.8259 17.2142 23.9878L17.5928 22.5364ZM23.244 21.3861C23.0863 21.8816 23.0415 22.0057 22.9867 22.0961L24.2695 22.8735C24.4393 22.5934 24.54 22.2601 24.6734 21.8409L23.244 21.3861ZM21.7052 24.0651C22.1229 24.0651 22.4692 24.0709 22.788 23.9878L22.4095 22.5364C22.3219 22.5592 22.208 22.5651 21.7052 22.5651V24.0651ZM22.9867 22.0961C22.8492 22.323 22.6399 22.4763 22.4095 22.5364L22.788 23.9878C23.4089 23.8259 23.9368 23.4225 24.2695 22.8735L22.9867 22.0961ZM23.2826 21.3809C23.3462 21.3809 23.3958 21.3809 23.4386 21.3814C23.4815 21.3819 23.509 21.3828 23.5277 21.384C23.571 21.3866 23.5299 21.389 23.4634 21.362L24.0276 19.9722C23.8718 19.909 23.7238 19.8932 23.6202 19.8868C23.5182 19.8805 23.3976 19.8809 23.2826 19.8809V21.3809ZM24.6734 21.8409C24.7101 21.7255 24.7474 21.6089 24.7731 21.5091C24.7991 21.408 24.8287 21.2678 24.8214 21.1077L23.323 21.1763C23.3202 21.1165 23.3325 21.0882 23.3203 21.1359C23.3148 21.1571 23.3064 21.1865 23.2931 21.2299C23.2799 21.2732 23.264 21.3231 23.244 21.3861L24.6734 21.8409ZM23.4634 21.362C23.367 21.3229 23.3259 21.2414 23.323 21.1763L24.8214 21.1077C24.799 20.6185 24.5018 20.1647 24.0276 19.9722L23.4634 21.362ZM16.7196 19.8809C16.6046 19.8809 16.484 19.8805 16.3821 19.8868C16.2785 19.8932 16.1305 19.909 15.9747 19.9722L16.5388 21.362C16.4724 21.389 16.4313 21.3866 16.4745 21.384C16.4932 21.3828 16.5208 21.3819 16.5636 21.3814C16.6064 21.3809 16.6561 21.3809 16.7196 21.3809V19.8809ZM16.7583 21.3861C16.7382 21.3231 16.7224 21.2732 16.7091 21.2299C16.6958 21.1865 16.6874 21.1571 16.682 21.1359C16.6697 21.0882 16.682 21.1165 16.6793 21.1763L15.1808 21.1077C15.1735 21.2678 15.2032 21.408 15.2291 21.5091C15.2548 21.6089 15.2922 21.7255 15.3289 21.8409L16.7583 21.3861ZM15.9747 19.9722C15.5004 20.1647 15.2032 20.6185 15.1808 21.1077L16.6793 21.1763C16.6763 21.2414 16.6352 21.3229 16.5388 21.362L15.9747 19.9722ZM21.8359 23.1739L21.725 23.7525L23.1983 24.0347L23.3091 23.4562L21.8359 23.1739ZM18.2771 23.7525L18.1662 23.1739L16.693 23.4562L16.8039 24.0347L18.2771 23.7525ZM20.0011 25.2493C19.3253 25.2493 19.1704 25.2393 19.0566 25.2001L18.5685 26.6185C18.9776 26.7593 19.4408 26.7493 20.0011 26.7493V25.2493ZM16.8039 24.0347C16.9148 24.6139 16.9939 25.0729 17.1991 25.4506L18.5171 24.7345C18.4507 24.6122 18.4085 24.4386 18.2771 23.7525L16.8039 24.0347ZM19.0566 25.2001C18.8353 25.124 18.6404 24.9614 18.5171 24.7345L17.1991 25.4506C17.4957 25.9966 17.9813 26.4164 18.5685 26.6185L19.0566 25.2001ZM21.725 23.7525C21.5936 24.4386 21.5514 24.6122 21.485 24.7345L22.8031 25.4506C23.0082 25.0729 23.0873 24.6139 23.1983 24.0347L21.725 23.7525ZM20.0011 26.7493C20.5613 26.7493 21.0245 26.7593 21.4337 26.6185L20.9455 25.2001C20.8318 25.2393 20.6769 25.2493 20.0011 25.2493V26.7493ZM21.485 24.7345C21.3617 24.9614 21.1668 25.124 20.9455 25.2001L21.4337 26.6185C22.0209 26.4164 22.5064 25.9966 22.8031 25.4506L21.485 24.7345Z" />
    <path
      d="M14.0894 19C13.711 18.1494 13.5 17.2031 13.5 16.2059C13.5 12.5023 16.4101 9.5 20 9.5C23.5899 9.5 26.5 12.5023 26.5 16.2059C26.5 17.2031 26.289 18.1494 25.9106 19"
      stroke="#8B62DD"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M20 6V7"
      stroke="#8B62DD"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30 16L29 16"
      stroke="#8B62DD"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 16L10 16"
      stroke="#8B62DD"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.0703 8.92969L26.3632 9.63679"
      stroke="#8B62DD"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6367 9.63672L12.9296 8.92961"
      stroke="#8B62DD"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CircularBubbleIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_7263_9564)">
      <circle
        cx="4.16797"
        cy="5.83203"
        r="2.5"
        stroke="#00151A"
        strokeWidth="1.5"
      />
      <circle
        cx="6.66927"
        cy="14.9993"
        r="3.33333"
        stroke="#00151A"
        strokeWidth="1.5"
      />
      <ellipse
        cx="14.1667"
        cy="5.83268"
        rx="4.16667"
        ry="4.16667"
        stroke="#00151A"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_7263_9564">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export const DocumentAttachmentIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 11V10C21 6.22876 21 4.34315 19.7595 3.17157C18.519 2 16.5225 2 12.5294 2L11.4706 2C7.47752 2 5.48098 2 4.24049 3.17157C3 4.34315 3 6.22876 3 10L3 14C3 17.7712 3 19.6569 4.24049 20.8284C5.48098 22 7.47751 22 11.4706 22H12"
      stroke="#141B34"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 7H16"
      stroke="#141B34"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 12H13"
      stroke="#141B34"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M21 20.6471L21 17C21 15.5706 19.6569 14 18 14C16.3431 14 15 15.5706 15 17L15 20.5C15 21.2797 15.7326 22 16.6364 22C17.5401 22 18.2727 21.2797 18.2727 20.5L18.2727 17.7647"
      stroke="#141B34"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Icon>
);

export const BlackArrowLeftIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 12L20 12"
      stroke="#00151A"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.99996 17C8.99996 17 4.00001 13.3176 4 12C3.99999 10.6824 9 7 9 7"
      stroke="#00151A"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const PurpleDocumentIcon = (props: IconProps) => (
  <Icon
    width="42px"
    height="52px"
    viewBox="0 0 42 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M25.082 3.24935C25.082 2.14941 25.082 1.59943 24.7403 1.25773C24.3986 0.916017 23.8487 0.916017 22.7487 0.916017L16.204 0.916017C13.013 0.91597 10.4409 0.915932 8.41795 1.18791C6.3177 1.47028 4.54932 2.07436 3.14485 3.47884C1.74038 4.88331 1.13629 6.65168 0.853923 8.75193C0.58195 10.7748 0.581987 13.3469 0.582032 16.5379L0.582032 35.4607C0.581987 38.6517 0.58195 41.2239 0.853923 43.2468C1.13629 45.347 1.74038 47.1154 3.14485 48.5199C4.54932 49.9243 6.3177 50.5284 8.41795 50.8108C10.4409 51.0828 13.013 51.0827 16.204 51.0827H25.7934C28.9844 51.0827 31.5565 51.0828 33.5795 50.8108C35.6797 50.5284 37.4481 49.9243 38.8526 48.5199C40.257 47.1154 40.8611 45.347 41.1435 43.2468C41.4155 41.2238 41.4154 38.6518 41.4154 35.4607V19.5831C41.4154 18.4832 41.4154 17.9332 41.0737 17.5915C40.732 17.2498 40.182 17.2498 39.082 17.2498L34.2536 17.2498C32.5767 17.2498 31.1451 17.2499 30.0015 17.0962C28.781 16.9321 27.6299 16.5646 26.6986 15.6332C25.7673 14.7019 25.3997 13.5508 25.2356 12.3304C25.0819 11.1867 25.082 9.75518 25.082 8.0783L25.082 3.24935Z"
      fill="#8B62DD"
    />
    <path
      d="M41.0957 13.7502C41.1025 13.7502 41.1071 13.7433 41.1045 13.737C40.7727 12.9358 40.139 12.3295 39.536 11.7288L30.603 2.79585C30.0023 2.19286 29.396 1.55914 28.5948 1.22728C28.5887 1.22475 28.582 1.22924 28.582 1.23584V7.96173C28.582 9.78804 28.5857 10.9817 28.7044 11.8644C28.8163 12.6968 29.0008 12.9861 29.1735 13.1588C29.3461 13.3314 29.6354 13.5159 30.4678 13.6278C31.3505 13.7465 32.5442 13.7502 34.3705 13.7502L41.0957 13.7502Z"
      fill="#8B62DD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.91406 26C9.91406 25.0335 10.6976 24.25 11.6641 24.25L30.3307 24.25C31.2972 24.25 32.0807 25.0335 32.0807 26C32.0807 26.9665 31.2972 27.75 30.3307 27.75L11.6641 27.75C10.6976 27.75 9.91406 26.9665 9.91406 26ZM9.91406 33C9.91406 32.0335 10.6976 31.25 11.6641 31.25L30.3307 31.25C31.2972 31.25 32.0807 32.0335 32.0807 33C32.0807 33.9665 31.2972 34.75 30.3307 34.75L11.6641 34.75C10.6976 34.75 9.91406 33.9665 9.91406 33ZM9.91406 40C9.91406 39.0335 10.6976 38.25 11.6641 38.25H26.8307C27.7972 38.25 28.5807 39.0335 28.5807 40C28.5807 40.9665 27.7972 41.75 26.8307 41.75H11.6641C10.6976 41.75 9.91406 40.9665 9.91406 40Z"
      fill="#8B62DD"
    />
  </Icon>
);

export const PurpleCirclesIcon = (props: IconProps) => (
  <Icon
    width="51px"
    height="52px"
    viewBox="0 0 51 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.585938 14.332C0.585938 9.49954 4.50345 5.58203 9.33594 5.58203C14.1684 5.58203 18.0859 9.49954 18.0859 14.332C18.0859 19.1645 14.1684 23.082 9.33594 23.082C4.50345 23.082 0.585938 19.1645 0.585938 14.332Z"
      fill="#8B62DD"
    />
    <path
      d="M5.25391 39.9993C5.25391 33.8782 10.2161 28.916 16.3372 28.916C22.4584 28.916 27.4206 33.8782 27.4206 39.9993C27.4206 46.1205 22.4584 51.0827 16.3372 51.0827C10.2161 51.0827 5.25391 46.1205 5.25391 39.9993Z"
      fill="#8B62DD"
    />
    <path
      opacity="0.4"
      d="M23.918 14.3327C23.918 6.92286 29.9248 0.916016 37.3346 0.916016C44.7445 0.916016 50.7513 6.92286 50.7513 14.3327C50.7513 21.7425 44.7445 27.7494 37.3346 27.7494C29.9248 27.7494 23.918 21.7425 23.918 14.3327Z"
      fill="#8B62DD"
    />
  </Icon>
);

export const PurpleHeadsetIcon = (props: IconProps) => (
  <Icon
    width="51px"
    height="48px"
    viewBox="0 0 51 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M41.2815 15.2655C42.2087 15.1905 43.1474 15.3885 43.9618 15.8456C44.5473 16.1742 44.9843 16.6151 45.3001 16.9769C45.4745 17.1766 45.7103 17.4757 45.8819 17.6933C46.9459 18.9856 48.0337 20.3146 48.6724 21.2213C49.3319 22.1576 49.8315 23.0496 50.1077 24.0604C50.5152 25.552 50.5152 27.1146 50.1077 28.6062C49.7271 29.9992 48.961 31.1982 48.1965 32.1987C47.7337 32.8043 47.1725 33.4547 46.6781 34.0276L46.6781 34.0276C46.4076 34.341 46.0227 34.7951 45.8193 35.0421L45.8192 35.0422C45.2568 35.7284 44.7015 36.4059 43.9618 36.8211C43.1474 37.2782 42.2087 37.4762 41.2815 37.4012C40.4469 37.3337 39.3017 36.811 38.4549 36.4234C37.6239 36.0521 36.057 35.3521 35.4601 33.5855C35.2431 32.9431 35.2448 32.2562 35.2464 31.6171V21.0496C35.2448 20.4105 35.2431 19.7236 35.4601 19.0811C36.057 17.3146 37.6239 16.6145 38.455 16.2432C39.3017 15.8557 40.4469 15.333 41.2815 15.2655Z"
      fill="#8B62DD"
    />
    <path
      opacity="0.4"
      d="M9.37864 15.2655C8.45145 15.1905 7.51275 15.3885 6.69832 15.8456C6.11289 16.1742 5.6759 16.6151 5.3601 16.9769C5.18571 17.1766 4.94985 17.4757 4.77831 17.6933C3.71428 18.9856 2.62649 20.3146 1.98777 21.2213C1.32824 22.1576 0.828613 23.0496 0.552469 24.0604C0.144987 25.552 0.144987 27.1146 0.552469 28.6062C0.933024 29.9992 1.69913 31.1982 2.46365 32.1987C2.92647 32.8043 3.48767 33.4547 3.98205 34.0275L3.98209 34.0276C4.25251 34.341 4.6375 34.7951 4.84089 35.0421L4.84091 35.0422C5.40336 35.7284 5.95866 36.4059 6.69832 36.8211C7.51275 37.2782 8.45145 37.4762 9.37864 37.4012C10.2133 37.3337 11.3584 36.811 12.2052 36.4234C13.0362 36.0521 14.6032 35.3521 15.2 33.5855C15.4171 32.9431 15.4154 32.2562 15.4138 31.6171V21.0496C15.4154 20.4105 15.4171 19.7236 15.2 19.0811C14.6032 17.3146 13.0362 16.6145 12.2052 16.2432C11.3584 15.8557 10.2133 15.333 9.37864 15.2655Z"
      fill="#8B62DD"
    />
    <path
      d="M39.3281 36.8159V37.5361C39.3281 39.9122 36.7069 42.6695 32.3281 42.6695H27.6615C26.3728 42.6695 25.3281 43.7141 25.3281 45.0028C25.3281 46.2915 26.3728 47.3361 27.6615 47.3361H32.3281C38.2587 47.3361 43.9948 43.4075 43.9948 37.5361V36.8047C43.9836 36.8111 43.9724 36.8175 43.9611 36.8239C43.1466 37.281 42.2079 37.479 41.2808 37.404C40.7102 37.3578 39.9944 37.0989 39.3281 36.8159Z"
      fill="#8B62DD"
    />
    <path
      d="M11.3984 15.8806C12.0668 10.2206 17.746 5.33268 25.3324 5.33268C32.9191 5.33268 38.5984 10.2208 39.2665 15.881C39.9512 15.5872 40.6956 15.3125 41.2851 15.2648C42.2079 15.1902 43.1421 15.386 43.9539 15.8385C43.2679 7.0814 34.8745 0.666016 25.3324 0.666016C15.7902 0.666016 7.39657 7.08171 6.71094 15.8391C7.52296 15.3862 8.45762 15.1902 9.38087 15.2648C9.97005 15.3125 10.7139 15.587 11.3984 15.8806Z"
      fill="#8B62DD"
    />
  </Icon>
);

export const PauseIcon = (props: IconProps) => (
  <Icon
    width="10px"
    height="10px"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.66602 2.91675C1.66602 2.32749 1.66602 2.03286 1.84907 1.84981C2.03213 1.66675 2.32676 1.66675 2.91602 1.66675C3.50527 1.66675 3.7999 1.66675 3.98296 1.84981C4.16602 2.03286 4.16602 2.32749 4.16602 2.91675V7.08341C4.16602 7.67267 4.16602 7.9673 3.98296 8.15036C3.7999 8.33341 3.50527 8.33341 2.91602 8.33341C2.32676 8.33341 2.03213 8.33341 1.84907 8.15036C1.66602 7.9673 1.66602 7.67267 1.66602 7.08341V2.91675Z"
      stroke="#141B34"
      strokeWidth="0.7"
    />
    <path
      d="M5.83203 2.91675C5.83203 2.32749 5.83203 2.03286 6.01509 1.84981C6.19815 1.66675 6.49278 1.66675 7.08203 1.66675C7.67129 1.66675 7.96591 1.66675 8.14897 1.84981C8.33203 2.03286 8.33203 2.32749 8.33203 2.91675V7.08341C8.33203 7.67267 8.33203 7.9673 8.14897 8.15036C7.96591 8.33341 7.67129 8.33341 7.08203 8.33341C6.49278 8.33341 6.19815 8.33341 6.01509 8.15036C5.83203 7.9673 5.83203 7.67267 5.83203 7.08341V2.91675Z"
      stroke="#141B34"
      strokeWidth="0.7"
    />
  </Icon>
);

export const CancelIcon = (props: IconProps) => (
  <Icon
    width="10px"
    height="10px"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.24973 6.25L3.75 3.75M3.75027 6.25L6.25 3.75"
      stroke="#E54839"
      strokeWidth="0.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.16732 4.99984C9.16732 2.69865 7.30184 0.83317 5.00065 0.83317C2.69946 0.83317 0.833984 2.69865 0.833984 4.99984C0.833984 7.30102 2.69946 9.1665 5.00065 9.1665C7.30184 9.1665 9.16732 7.30102 9.16732 4.99984Z"
      stroke="#E54839"
      strokeWidth="0.7"
    />
  </Icon>
);

export const ResumeIcon = (props: IconProps) => (
  <Icon
    width="10px"
    height="10px"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.57346 0.624756H5.42654C6.24015 0.624745 6.89303 0.624737 7.40587 0.693686C7.93713 0.765113 8.38007 0.917333 8.73125 1.26851C9.08243 1.61969 9.23464 2.06263 9.30607 2.59389C9.37502 3.10673 9.37501 3.7596 9.375 4.57321V5.40232C9.375 5.90036 9.375 6.33495 9.36064 6.70951C9.36034 6.7173 9.36005 6.72516 9.35975 6.73309C9.35501 6.85864 9.34967 7.00034 9.32562 7.11584C9.29648 7.25581 9.22028 7.45431 9.0005 7.56275C8.77638 7.67333 8.56879 7.60708 8.44269 7.54551C8.33533 7.49311 8.21726 7.40947 8.11033 7.33373C8.10382 7.32911 8.09734 7.32452 8.09092 7.31998L7.53017 6.92323C7.34232 6.79031 7.29778 6.53028 7.4307 6.34243C7.56361 6.15458 7.82364 6.11004 8.0115 6.24295L8.40401 6.52067C8.45971 6.56008 8.48756 6.57979 8.50992 6.56854C8.53228 6.5573 8.53306 6.52333 8.53461 6.4554C8.54163 6.14928 8.54167 5.80021 8.54167 5.39559V4.60392C8.54167 3.75245 8.54078 3.15577 8.48017 2.70493C8.42117 2.26607 8.31253 2.0283 8.14199 1.85777C7.97145 1.68723 7.73369 1.57859 7.29483 1.51959C6.84399 1.45897 6.2473 1.45809 5.39583 1.45809H4.60417C3.7527 1.45809 3.15601 1.45897 2.70517 1.51959C2.26632 1.57859 2.02855 1.68723 1.85801 1.85777C1.68747 2.0283 1.57884 2.26607 1.51983 2.70493C1.45922 3.15577 1.45833 3.75245 1.45833 4.60392V5.39559C1.45833 6.24706 1.45922 6.84374 1.51983 7.29459C1.57884 7.73344 1.68747 7.97121 1.85801 8.14175C2.02855 8.31228 2.26632 8.42092 2.70517 8.47993C3.15601 8.54054 3.7527 8.54142 4.60417 8.54142H5.39583C6.26224 8.54142 6.86445 8.54045 7.31703 8.47687C7.54492 8.44486 7.7556 8.60364 7.78762 8.83152C7.81963 9.0594 7.66085 9.27009 7.43297 9.3021C6.91564 9.37478 6.25464 9.37477 5.4282 9.37476H4.57345C3.75984 9.37477 3.10697 9.37478 2.59413 9.30583C2.06287 9.2344 1.61993 9.08218 1.26876 8.731C0.917577 8.37982 0.765357 7.93689 0.693931 7.40563C0.624981 6.89278 0.624989 6.23991 0.625 5.42629V4.57322C0.624989 3.75961 0.624981 3.10673 0.693931 2.59389C0.765357 2.06263 0.917577 1.61969 1.26876 1.26851C1.61993 0.917333 2.06287 0.765113 2.59413 0.693686C3.10697 0.624737 3.75985 0.624745 4.57346 0.624756Z"
      fill="#00151A"
    />
    <path
      d="M5.37725 3.75362L5.34352 3.73573C5.0212 3.56481 4.75631 3.42435 4.53815 3.33775C4.31634 3.2497 4.08697 3.19326 3.8534 3.25504C3.69232 3.29764 3.54369 3.37902 3.42248 3.49315C3.24275 3.6624 3.18006 3.89008 3.15218 4.12009C3.12498 4.34436 3.12499 4.63297 3.125 4.97949V5.02019C3.12499 5.36671 3.12498 5.65533 3.15218 5.8796C3.18006 6.10962 3.24275 6.33729 3.42248 6.50654C3.54369 6.62067 3.69232 6.70205 3.8534 6.74465C4.08697 6.80643 4.31634 6.75 4.53815 6.66194C4.75631 6.57534 5.0212 6.43488 5.34352 6.26396L5.37725 6.24607C5.71067 6.06929 5.98433 5.92419 6.18197 5.78944C6.37971 5.65463 6.56423 5.49002 6.63214 5.24915C6.67818 5.0859 6.67818 4.91379 6.63214 4.75054C6.56423 4.50968 6.37971 4.34507 6.18197 4.21025C5.98433 4.0755 5.71068 3.93041 5.37725 3.75362Z"
      fill="#00151A"
    />
    <defs>
      <clipPath id="clip0_25103_85316">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export const CallIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.43113 1.07149C4.90337 1.16909 5.27945 1.48637 5.51311 1.90557L6.25746 3.24094C6.53163 3.73278 6.76236 4.14668 6.91303 4.50649C7.07287 4.88817 7.1678 5.26455 7.12441 5.68069C7.08101 6.09682 6.91047 6.44552 6.67532 6.78601C6.45365 7.10699 6.14248 7.46438 5.77273 7.88907L4.67856 9.14589C4.48249 9.37111 4.38445 9.48372 4.37549 9.62447C4.36653 9.76522 4.44688 9.88544 4.60758 10.1259C5.97724 12.1751 7.82319 14.0217 9.8741 15.3925C10.1145 15.5532 10.2348 15.6336 10.3755 15.6246C10.5163 15.6157 10.6289 15.5176 10.8541 15.3216L12.111 14.2273C12.5357 13.8576 12.8931 13.5464 13.2141 13.3247C13.5545 13.0896 13.9032 12.919 14.3194 12.8757C14.7355 12.8323 15.1119 12.9272 15.4936 13.087C15.8533 13.2377 16.2672 13.4684 16.759 13.7425L18.0945 14.4869C18.5137 14.7206 18.831 15.0967 18.9286 15.5689C19.0272 16.0461 18.8817 16.5257 18.5604 16.9199C17.3947 18.3502 15.5269 19.2609 13.5676 18.8657C12.3632 18.6227 11.1749 18.2179 9.73763 17.3937C6.84983 15.7375 4.2606 13.1469 2.60638 10.2624C1.78211 8.82518 1.37735 7.63685 1.1344 6.43247C0.739148 4.47311 1.64984 2.60538 3.08015 1.43963C3.47434 1.11834 3.95397 0.972866 4.43113 1.07149Z"
      fill="#00151A"
    />
  </Icon>
);

export const GreyCancelIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25C6.06294 1.25 1.25 6.06294 1.25 12Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.7071 8.29292C16.0976 8.68345 16.0976 9.31662 15.7071 9.70713L13.4141 12L15.7071 14.2929C16.0976 14.6834 16.0976 15.3165 15.7071 15.7071C15.3166 16.0976 14.6835 16.0976 14.2929 15.7071L11.9998 13.4142L9.70708 15.7067C9.31655 16.0972 8.68338 16.0972 8.29287 15.7067C7.90236 15.3162 7.90238 14.683 8.29292 14.2925L10.5855 12L8.29292 9.70752C7.90238 9.31701 7.90236 8.68385 8.29287 8.29331C8.68338 7.90277 9.31655 7.90275 9.70708 8.29326L11.9998 10.5858L14.2929 8.29287C14.6835 7.90236 15.3166 7.90238 15.7071 8.29292Z"
      fill="#8A9396"
    />
  </Icon>
);

export const PlusInCircleIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 7.5V12.5M12.5 10H7.5M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
      stroke="#32CC14"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const OutletBriefcaseFilledIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.50008 7.70834C2.96032 7.70834 3.33342 8.08144 3.33342 8.54168L3.33342 12.7083C3.33342 13.9104 3.33519 14.7281 3.41751 15.3405C3.49662 15.9289 3.6361 16.2014 3.82157 16.3869C4.00705 16.5723 4.27957 16.7118 4.86794 16.7909C5.48029 16.8732 6.29801 16.875 7.50008 16.875H12.5001C13.7022 16.875 14.5199 16.8732 15.1322 16.7909C15.7206 16.7118 15.9931 16.5723 16.1786 16.3869C16.3641 16.2014 16.5035 15.9289 16.5827 15.3405C16.665 14.7281 16.6667 13.9104 16.6667 12.7083V8.54168C16.6667 8.08144 17.0398 7.70834 17.5001 7.70834C17.9603 7.70834 18.3334 8.08144 18.3334 8.54168V12.7671C18.3334 13.8956 18.3335 14.8261 18.2345 15.5626C18.1305 16.3358 17.9039 17.0186 17.3571 17.5654C16.8103 18.1121 16.1275 18.3388 15.3543 18.4427C14.6178 18.5417 13.6873 18.5417 12.5589 18.5417L7.44127 18.5417C6.31284 18.5417 5.38233 18.5417 4.64586 18.4427C3.87267 18.3388 3.18982 18.1121 2.64306 17.5654C2.0963 17.0186 1.86966 16.3358 1.76571 15.5626C1.6667 14.8261 1.66672 13.8956 1.66675 12.7672L1.66675 8.54168C1.66675 8.08144 2.03985 7.70834 2.50008 7.70834Z"
      fill="#00151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.87686 13.4051C7.18238 13.0609 7.70909 13.0296 8.05329 13.3351C8.44146 13.6797 9.13858 13.9583 10.0001 13.9583C10.8616 13.9583 11.5587 13.6797 11.9469 13.3351C12.2911 13.0296 12.8178 13.0609 13.1233 13.4051C13.4288 13.7493 13.3975 14.276 13.0533 14.5816C12.3013 15.2491 11.1832 15.625 10.0001 15.625C8.81701 15.625 7.69888 15.2491 6.94689 14.5816C6.60269 14.276 6.57134 13.7493 6.87686 13.4051Z"
      fill="#00151A"
    />
    <path
      d="M14.555 1.45834C15.0846 1.45832 15.5357 1.45831 15.9052 1.50199C16.3003 1.5487 16.6646 1.65093 16.9944 1.89708C17.3223 2.14188 17.5275 2.46289 17.6922 2.82962C17.8477 3.17585 17.9895 3.61628 18.1576 4.13866L18.7378 5.94129L18.7503 5.98004C18.897 6.43524 19.0146 6.80016 18.9285 7.35194C18.8928 7.58063 18.8472 7.76828 18.77 7.94206C18.6973 8.10552 18.6067 8.23075 18.5373 8.32671L18.527 8.34099C17.7068 9.4765 16.2031 10.2083 14.7953 10.2083C13.8956 10.2083 13.0644 9.91111 12.3973 9.41023C11.73 9.91144 10.8992 10.2083 9.99918 10.2083C9.09967 10.2083 8.26873 9.91128 7.6017 9.41066C6.93448 9.9116 6.10388 10.2083 5.20416 10.2083C3.79643 10.2083 2.29265 9.4765 1.47252 8.34099L1.46221 8.32673C1.39278 8.23076 1.30217 8.10553 1.2295 7.94206C1.15224 7.76828 1.10665 7.58063 1.07097 7.35194C0.984859 6.80016 1.10248 6.43523 1.24921 5.98003L1.26169 5.94129L1.83146 4.17109L1.84189 4.13867L1.8419 4.13867C2.01002 3.61628 2.15176 3.17585 2.30729 2.82962C2.47203 2.46289 2.67717 2.14188 3.00511 1.89708C3.33489 1.65093 3.69918 1.5487 4.09424 1.50199C4.46374 1.45831 4.91488 1.45832 5.44446 1.45834H5.44449L14.555 1.45834H14.555Z"
      fill="#00151A"
    />
  </Icon>
);

export const OutletBriefcaseIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 8.75L2.5 12.9167C2.5 15.2737 2.5 16.4522 3.23223 17.1844C3.96447 17.9167 5.14298 17.9167 7.5 17.9167H12.5C14.857 17.9167 16.0355 17.9167 16.7678 17.1844C17.5 16.4522 17.5 15.2737 17.5 12.9167V8.75"
      stroke="#00151A"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12.5 14.1667C11.9299 14.6727 11.0223 15 10 15C8.97771 15 8.07008 14.6727 7.5 14.1667"
      stroke="#00151A"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M2.42674 4.36258L1.71281 4.13279L1.71281 4.13279L2.42674 4.36258ZM1.85697 6.13278L2.5709 6.36257L2.5709 6.36257L1.85697 6.13278ZM17.5734 4.36258L16.8595 4.59238L16.8595 4.59238L17.5734 4.36258ZM18.1432 6.13278L18.8571 5.90299L18.8571 5.90299L18.1432 6.13278ZM8.13599 8.05649C7.84498 7.76173 7.37011 7.75871 7.07536 8.04972C6.7806 8.34074 6.77757 8.81561 7.06859 9.11036L8.13599 8.05649ZM12.9317 8.05605C12.6408 7.76122 12.1659 7.75808 11.8711 8.04903C11.5762 8.33998 11.5731 8.81484 11.864 9.10967L12.9317 8.05605ZM1.97952 7.97504L2.58753 7.53591L2.58753 7.53591L1.97952 7.97504ZM9.18166 7.27153C9.28559 6.87056 9.0448 6.46127 8.64383 6.35734C8.24287 6.25341 7.83357 6.4942 7.72964 6.89516L9.18166 7.27153ZM13.9767 7.27153C14.0806 6.87056 13.8398 6.46127 13.4389 6.35734C13.0379 6.25341 12.6286 6.4942 12.5247 6.89516L13.9767 7.27153ZM18.0206 7.97504L17.4126 7.53591L17.4126 7.53591L18.0206 7.97504ZM18.3113 7.25557L17.5703 7.13993L17.5703 7.13993L18.3113 7.25557ZM1.68883 7.25557L0.947801 7.37121L0.947801 7.37121L1.68883 7.25557ZM3.37931 2.39794L2.93068 1.79691L2.93068 1.79691L3.37931 2.39794ZM1.71281 4.13279L1.14304 5.90299L2.5709 6.36257L3.14067 4.59238L1.71281 4.13279ZM16.8595 4.59238L17.4293 6.36258L18.8571 5.90299L18.2874 4.13279L16.8595 4.59238ZM5.48026 2.83334L14.5199 2.83334V1.33334L5.48026 1.33334V2.83334ZM9.99952 8.83334C9.26838 8.83334 8.60954 8.53612 8.13599 8.05649L7.06859 9.11036C7.81354 9.86488 8.85263 10.3333 9.99952 10.3333V8.83334ZM14.7957 8.83334C14.0643 8.83334 13.4053 8.53594 12.9317 8.05605L11.864 9.10967C12.609 9.86459 13.6484 10.3333 14.7957 10.3333V8.83334ZM5.2045 8.83334C4.21394 8.83334 3.13522 8.29423 2.58753 7.53591L1.37152 8.41417C2.21642 9.58398 3.75885 10.3333 5.2045 10.3333V8.83334ZM7.72964 6.89516C7.44146 8.00697 6.42189 8.83334 5.2045 8.83334V10.3333C7.11548 10.3333 8.72454 9.0351 9.18166 7.27153L7.72964 6.89516ZM12.5247 6.89516C12.2365 8.00696 11.2169 8.83334 9.99952 8.83334V10.3333C11.9105 10.3333 13.5196 9.0351 13.9767 7.27153L12.5247 6.89516ZM17.4126 7.53591C16.8649 8.29422 15.7862 8.83334 14.7957 8.83334V10.3333C16.2413 10.3333 17.7837 9.58398 18.6286 8.41417L17.4126 7.53591ZM17.4293 6.36258C17.5855 6.84806 17.6029 6.93115 17.5703 7.13993L19.0524 7.37121C19.146 6.77127 19.0092 6.3754 18.8571 5.90299L17.4293 6.36258ZM18.6286 8.41417C18.6982 8.3179 18.8021 8.17825 18.8845 7.99284C18.9681 7.80491 19.0158 7.6052 19.0524 7.37121L17.5703 7.13993C17.5437 7.3103 17.522 7.36529 17.5139 7.38349C17.5047 7.40421 17.4948 7.4221 17.4126 7.53591L18.6286 8.41417ZM18.2874 4.13279C18.1155 3.59887 17.9688 3.13957 17.8066 2.7784C17.6371 2.40119 17.4209 2.0592 17.0695 1.79691L16.1722 2.99897C16.2423 3.05128 16.3253 3.14159 16.4383 3.39305C16.5584 3.66054 16.6773 4.02627 16.8595 4.59238L18.2874 4.13279ZM14.5199 2.83334C15.0976 2.83334 15.4657 2.83456 15.7441 2.86748C16.0018 2.89794 16.1043 2.9483 16.1722 2.99897L17.0695 1.79691C16.7159 1.53298 16.3278 1.42604 15.9203 1.37786C15.5335 1.33213 15.0619 1.33334 14.5199 1.33334V2.83334ZM1.14304 5.90299C0.990984 6.3754 0.854178 6.77127 0.947801 7.37121L2.42986 7.13993C2.39728 6.93115 2.41464 6.84806 2.5709 6.36257L1.14304 5.90299ZM2.58753 7.53591C2.50533 7.4221 2.49548 7.40421 2.48627 7.38348C2.47818 7.36529 2.45645 7.3103 2.42986 7.13993L0.947801 7.37121C0.984316 7.6052 1.03207 7.80491 1.11562 7.99284C1.19805 8.17825 1.30199 8.3179 1.37152 8.41417L2.58753 7.53591ZM3.14067 4.59238C3.32288 4.02627 3.44173 3.66054 3.56189 3.39305C3.67485 3.14159 3.75786 3.05128 3.82793 2.99897L2.93068 1.79691C2.57929 2.0592 2.36305 2.40119 2.19361 2.7784C2.03137 3.13957 1.88467 3.59887 1.71281 4.13279L3.14067 4.59238ZM5.48026 1.33334C4.93831 1.33334 4.46665 1.33213 4.0799 1.37786C3.67235 1.42604 3.28427 1.53298 2.93068 1.79691L3.82793 2.99897C3.89582 2.9483 3.99839 2.89794 4.25603 2.86748C4.53448 2.83456 4.90256 2.83334 5.48026 2.83334V1.33334Z"
      fill="#00151A"
    />
  </Icon>
);

export const BlackPlusAddIcon = (props: IconProps) => (
  <Icon
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.0828 0.57412C19.2916 0.333297 16.9973 0.333311 14.0764 0.333329L13.9239 0.333329C11.003 0.333311 8.70875 0.333297 6.91753 0.57412C5.08198 0.820903 3.62564 1.33695 2.48138 2.48121C1.33712 3.62548 0.821071 5.08182 0.574288 6.91736C0.333464 8.70858 0.333479 11.0028 0.333496 13.9238L0.333496 14.0762C0.333479 16.9972 0.333464 19.2914 0.574288 21.0826C0.821071 22.9182 1.33712 24.3745 2.48138 25.5188C3.62564 26.663 5.08198 27.1791 6.91753 27.4259C8.70874 27.6667 11.003 27.6667 13.9239 27.6667H13.9239H14.0764H14.0765C16.9974 27.6667 19.2916 27.6667 21.0828 27.4259C22.9183 27.1791 24.3747 26.663 25.5189 25.5188C26.6632 24.3745 27.1793 22.9182 27.426 21.0826C27.6669 19.2914 27.6668 16.9972 27.6668 14.0763V14.0762V13.9238V13.9237C27.6668 11.0028 27.6669 8.70857 27.426 6.91736C27.1793 5.08182 26.6632 3.62548 25.5189 2.48121C24.3747 1.33695 22.9183 0.820903 21.0828 0.57412ZM15.3335 8.66666C15.3335 7.93028 14.7365 7.33333 14.0002 7.33333C13.2638 7.33333 12.6668 7.93028 12.6668 8.66666L12.6668 12.6667L8.66683 12.6667C7.93045 12.6667 7.3335 13.2636 7.3335 14C7.3335 14.7364 7.93045 15.3333 8.66683 15.3333L12.6668 15.3333L12.6668 19.3333C12.6668 20.0697 13.2638 20.6667 14.0002 20.6667C14.7365 20.6667 15.3335 20.0697 15.3335 19.3333L15.3335 15.3333L19.3335 15.3333C20.0699 15.3333 20.6668 14.7364 20.6668 14C20.6668 13.2636 20.0699 12.6667 19.3335 12.6667L15.3335 12.6667L15.3335 8.66666Z"
      fill="#141B34"
    />
  </Icon>
);

export const BlackCheckCircleIcon = (props: IconProps) => (
  <Icon
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.0415039 8.99999C0.0415039 13.9475 4.05229 17.9583 8.99984 17.9583C13.9474 17.9583 17.9582 13.9475 17.9582 8.99999C17.9582 4.05244 13.9474 0.0416565 8.99984 0.0416565C4.05229 0.0416565 0.0415039 4.05244 0.0415039 8.99999ZM12.8963 5.8857C13.2355 6.19669 13.2585 6.72383 12.9475 7.0631L8.36413 12.0631C8.21054 12.2306 7.99518 12.3282 7.76794 12.3331C7.5407 12.3381 7.3213 12.25 7.16058 12.0892L5.07725 10.0059C4.75181 9.68048 4.75181 9.15284 5.07725 8.82741C5.40269 8.50197 5.93032 8.50197 6.25576 8.82741L7.72366 10.2953L11.7189 5.93689C12.0299 5.59763 12.557 5.57471 12.8963 5.8857Z"
      fill="#141B34"
    />
  </Icon>
);

export const BlackMiniBriefcaseIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.4265 3.94591L1.71257 3.71611H1.71257L2.4265 3.94591ZM1.85672 5.7161L2.57065 5.9459L1.85672 5.7161ZM17.5732 3.94591L16.8592 4.1757V4.1757L17.5732 3.94591ZM18.143 5.7161L18.8569 5.48631L18.8569 5.48631L18.143 5.7161ZM8.13575 7.63981C7.84473 7.34506 7.36987 7.34203 7.07511 7.63304C6.78036 7.92406 6.77733 8.39893 7.06834 8.69368L8.13575 7.63981ZM12.9315 7.63937C12.6405 7.34455 12.1656 7.3414 11.8708 7.63235C11.576 7.9233 11.5729 8.39816 11.8638 8.69299L12.9315 7.63937ZM1.97928 7.55836L2.58728 7.11923H2.58728L1.97928 7.55836ZM9.18141 6.85485C9.28534 6.45388 9.04455 6.04459 8.64359 5.94066C8.24263 5.83673 7.83333 6.07752 7.7294 6.47848L9.18141 6.85485ZM13.9764 6.85485C14.0804 6.45388 13.8396 6.04459 13.4386 5.94066C13.0377 5.83673 12.6284 6.07752 12.5244 6.47848L13.9764 6.85485ZM18.0204 7.55836L17.4124 7.11923L17.4124 7.11923L18.0204 7.55836ZM18.3111 6.83889L17.5701 6.72325L17.5701 6.72325L18.3111 6.83889ZM1.68859 6.83889L0.947557 6.95453H0.947557L1.68859 6.83889ZM3.37906 1.98126L2.93044 1.38023L2.93044 1.38023L3.37906 1.98126ZM1.71257 3.71611L1.1428 5.48631L2.57065 5.9459L3.14043 4.1757L1.71257 3.71611ZM16.8592 4.1757L17.429 5.9459L18.8569 5.48631L18.2871 3.71611L16.8592 4.1757ZM5.48002 2.41666L14.5197 2.41666V0.916664L5.48002 0.916664V2.41666ZM9.99928 8.41666C9.26814 8.41666 8.6093 8.11944 8.13575 7.63981L7.06834 8.69368C7.81329 9.4482 8.85238 9.91666 9.99928 9.91666V8.41666ZM14.7954 8.41666C14.0641 8.41666 13.405 8.11926 12.9315 7.63937L11.8638 8.69299C12.6088 9.44791 13.6482 9.91666 14.7954 9.91666V8.41666ZM5.20426 8.41666C4.21369 8.41666 3.13497 7.87755 2.58728 7.11923L1.37128 7.99749C2.21617 9.1673 3.7586 9.91666 5.20426 9.91666V8.41666ZM7.7294 6.47848C7.44122 7.59029 6.42165 8.41666 5.20426 8.41666V9.91666C7.11523 9.91666 8.72429 8.61842 9.18141 6.85485L7.7294 6.47848ZM12.5244 6.47848C12.2362 7.59029 11.2167 8.41666 9.99928 8.41666V9.91666C11.9103 9.91666 13.5193 8.61842 13.9764 6.85485L12.5244 6.47848ZM17.4124 7.11923C16.8647 7.87755 15.786 8.41666 14.7954 8.41666V9.91666C16.2411 9.91666 17.7835 9.1673 18.6284 7.99749L17.4124 7.11923ZM17.429 5.9459C17.5853 6.43138 17.6026 6.51447 17.5701 6.72325L19.0521 6.95453C19.1457 6.35459 19.0089 5.95872 18.8569 5.48631L17.429 5.9459ZM18.6284 7.99749C18.6979 7.90123 18.8019 7.76157 18.8843 7.57616C18.9678 7.38823 19.0156 7.18852 19.0521 6.95453L17.5701 6.72325C17.5435 6.89362 17.5217 6.94861 17.5136 6.96681C17.5044 6.98753 17.4946 7.00543 17.4124 7.11923L18.6284 7.99749ZM18.2871 3.71611C18.1153 3.18219 17.9686 2.72289 17.8063 2.36172C17.6369 1.98451 17.4206 1.64252 17.0692 1.38023L16.172 2.58229C16.2421 2.6346 16.3251 2.72491 16.438 2.97637C16.5582 3.24386 16.677 3.60959 16.8592 4.1757L18.2871 3.71611ZM14.5197 2.41666C15.0974 2.41666 15.4654 2.41788 15.7439 2.4508C16.0015 2.48126 16.1041 2.53162 16.172 2.58229L17.0692 1.38023C16.7156 1.1163 16.3276 1.00936 15.92 0.961177C15.5333 0.91545 15.0616 0.916664 14.5197 0.916664V2.41666ZM1.1428 5.48631C0.99074 5.95872 0.853934 6.35459 0.947557 6.95453L2.42962 6.72325C2.39704 6.51447 2.41439 6.43138 2.57065 5.9459L1.1428 5.48631ZM2.58728 7.11923C2.50508 7.00543 2.49524 6.98753 2.48603 6.96681C2.47793 6.94861 2.45621 6.89362 2.42962 6.72325L0.947557 6.95453C0.984072 7.18852 1.03183 7.38823 1.11537 7.57616C1.1978 7.76157 1.30175 7.90123 1.37128 7.99749L2.58728 7.11923ZM3.14043 4.1757C3.32264 3.60959 3.44149 3.24386 3.56165 2.97637C3.6746 2.72491 3.75761 2.6346 3.82769 2.58229L2.93044 1.38023C2.57905 1.64252 2.36281 1.98451 2.19336 2.36172C2.03112 2.72289 1.88442 3.18219 1.71257 3.71611L3.14043 4.1757ZM5.48002 0.916664C4.93807 0.916664 4.4664 0.91545 4.07966 0.961177C3.6721 1.00936 3.28403 1.1163 2.93044 1.38023L3.82769 2.58229C3.89557 2.53162 3.99814 2.48126 4.25578 2.4508C4.53423 2.41788 4.90231 2.41666 5.48002 2.41666V0.916664Z"
      fill="white"
    />
    <path
      d="M2.5 8.33333L2.5 12.5C2.5 14.857 2.5 16.0355 3.23223 16.7678C3.96447 17.5 5.14298 17.5 7.5 17.5H10"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M5.83301 14.1667L9.16634 14.1667"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M15.4167 11.25C17.0275 11.25 18.3333 12.5313 18.3333 14.1119C18.3333 15.8998 16.5703 16.7788 15.7292 18.1191C15.5499 18.4047 15.2963 18.4047 15.1042 18.1191C14.2368 16.8297 12.5 15.8625 12.5 14.1119C12.5 12.5313 13.8058 11.25 15.4167 11.25Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M15.4165 14.1667L15.424 14.1667"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const BlackChevronDownIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 7.50004C15 7.50004 11.3176 12.5 9.99996 12.5C8.68237 12.5 5 7.5 5 7.5"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const SaveIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6875 1.23903C12.1584 1.04152 11.6084 1.04162 10.7824 1.04176L10.669 1.04176C8.80144 1.04175 7.33781 1.04174 6.19287 1.1915C5.02152 1.34471 4.0933 1.6642 3.35462 2.37078C3.30328 2.41988 3.25305 2.47011 3.20396 2.52145C2.49741 3.26017 2.17793 4.18842 2.02473 5.35983C1.87498 6.50483 1.87499 7.96852 1.875 9.83617V10.8716C1.87499 12.4021 1.87499 13.6018 1.97811 14.5537C2.08334 15.525 2.30194 16.312 2.79013 16.984C3.08568 17.3908 3.44341 17.7485 3.8502 18.0441C4.52213 18.5323 5.30912 18.7509 6.2804 18.8561C6.40485 18.8696 6.53355 18.8813 6.66667 18.8915C7.55726 18.9584 8.63796 18.9584 9.95091 18.9584H10.0493C11.3621 18.9584 12.4428 18.9584 13.3333 18.8915C13.4665 18.8814 13.5951 18.8696 13.7196 18.8561C14.6909 18.7509 15.4779 18.5323 16.1498 18.0441C16.5566 17.7485 16.9143 17.3908 17.2099 16.984C17.6981 16.312 17.9167 15.525 18.0219 14.5537C18.125 13.6019 18.125 12.4022 18.125 10.8717V10.8717L18.125 8.04106C18.1256 7.02064 18.126 6.3111 17.83 5.6791C17.534 5.0471 16.9887 4.59315 16.2045 3.94031L14.1937 2.26462C13.6002 1.76957 13.188 1.42581 12.6875 1.23903ZM8.33333 5.00008C7.8731 5.00008 7.5 5.37318 7.5 5.83342C7.5 6.29365 7.8731 6.66675 8.33333 6.66675H11.6667C12.1269 6.66675 12.5 6.29365 12.5 5.83342C12.5 5.37318 12.1269 5.00008 11.6667 5.00008H8.33333ZM6.66667 16.3935C6.66667 16.7587 6.66667 16.9414 6.78316 17.0624C6.89965 17.1834 7.07647 17.1901 7.43012 17.2036C8.12708 17.2301 8.96441 17.2306 10.0001 17.2306C11.0357 17.2306 11.873 17.2301 12.5699 17.2036C12.9235 17.1901 13.1004 17.1834 13.2168 17.0624C13.3333 16.9414 13.3333 16.7588 13.3333 16.3935V15.8336C13.3333 14.2621 13.3333 13.4764 12.8452 12.9883C12.357 12.5001 11.5713 12.5001 9.99999 12.5001C8.42865 12.5001 7.64298 12.5001 7.15482 12.9883C6.66667 13.4764 6.66667 14.2621 6.66667 15.8336V16.3935Z"
      fill="#00111A"
    />
  </Icon>
);

export const LeadingIcon = (props: IconProps) => (
  <Icon
    width="21px"
    height="20px"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.6667 4.99984C14.5943 3.81696 14.3957 3.06371 13.8509 2.52078C12.9935 1.6665 11.6137 1.6665 8.85408 1.6665C6.09444 1.6665 4.71462 1.6665 3.85731 2.52078C3 3.37505 3 4.74998 3 7.49984V12.4998C3 15.2497 3 16.6246 3.85731 17.4789C4.71462 18.3332 6.09444 18.3332 8.85408 18.3332C11.6137 18.3332 12.9935 18.3332 13.8509 17.4789C14.3957 16.936 14.5943 16.1827 14.6667 14.9998"
      stroke="#00151A"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8.83337 15.833H8.84086"
      stroke="#00151A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.347 11.9713C15.055 12.2651 15.0565 12.7399 15.3502 13.0319C15.644 13.3239 16.1189 13.3225 16.4109 13.0287L15.347 11.9713ZM17.1214 11.25L16.5895 10.7213V10.7213L17.1214 11.25ZM17.1214 8.75001L16.5895 9.27873V9.27873L17.1214 8.75001ZM16.4109 6.97128C16.1189 6.6775 15.644 6.67606 15.3502 6.96807C15.0564 7.26007 15.055 7.73494 15.347 8.02872L16.4109 6.97128ZM9.66663 9.25001C9.25241 9.25001 8.91663 9.5858 8.91663 10C8.91663 10.4142 9.25241 10.75 9.66663 10.75L9.66663 9.25001ZM16.4109 13.0287L17.6533 11.7787L16.5895 10.7213L15.347 11.9713L16.4109 13.0287ZM17.6533 8.22129L16.4109 6.97128L15.347 8.02872L16.5895 9.27873L17.6533 8.22129ZM17.6533 11.7787C17.9313 11.4991 18.194 11.2371 18.3779 10.9945C18.5751 10.7345 18.75 10.4116 18.75 10L17.25 10C17.25 9.95455 17.2784 9.96203 17.1827 10.0881C17.0738 10.2317 16.8972 10.4117 16.5895 10.7213L17.6533 11.7787ZM16.5895 9.27873C16.8972 9.58837 17.0738 9.76827 17.1827 9.91188C17.2784 10.038 17.25 10.0455 17.25 10L18.75 10C18.75 9.58842 18.5751 9.26553 18.3779 9.00549C18.194 8.76294 17.9313 8.50091 17.6533 8.22128L16.5895 9.27873ZM18 9.25001L9.66663 9.25001L9.66663 10.75L18 10.75V9.25001Z"
      fill="#00151A"
    />
  </Icon>
);

export const FullEyeIcon = (props: IconProps) => (
  <Icon
    width="12px"
    height="12px"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_29828_146812)">
      <path
        d="M1 4C1 4 3.23858 1.5 6 1.5C8.76142 1.5 11 4 11 4"
        stroke="#334448"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10.772 6.52249C10.924 6.73565 11 6.84223 11 7C11 7.15777 10.924 7.26435 10.772 7.47751C10.089 8.43528 8.34461 10.5 6 10.5C3.65539 10.5 1.91105 8.43528 1.22802 7.47751C1.07601 7.26435 1 7.15777 1 7C1 6.84223 1.07601 6.73565 1.22802 6.52249C1.91105 5.56472 3.65539 3.5 6 3.5C8.34461 3.5 10.089 5.56472 10.772 6.52249Z"
        stroke="#334448"
        strokeWidth="1.5"
      />
      <path
        d="M7.5 7C7.5 6.17157 6.82843 5.5 6 5.5C5.17157 5.5 4.5 6.17157 4.5 7C4.5 7.82843 5.17157 8.5 6 8.5C6.82843 8.5 7.5 7.82843 7.5 7Z"
        stroke="#334448"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_29828_146812">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export const FilledInformationSquareIcon = (props: IconProps) => (
  <Icon
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.03906 1.16638C9.49953 1.16637 10.6474 1.16706 11.543 1.28748C12.4605 1.41089 13.1887 1.66856 13.7607 2.2406C14.3328 2.81264 14.5905 3.54081 14.7139 4.45837C14.8343 5.35399 14.835 6.50181 14.835 7.96228V8.03845C14.835 9.4988 14.8343 10.6458 14.7139 11.5414C14.5905 12.459 14.3327 13.1871 13.7607 13.7592C13.1887 14.3312 12.4606 14.5899 11.543 14.7133C10.6474 14.8337 9.49954 14.8334 8.03906 14.8334H7.96289C6.50257 14.8334 5.35551 14.8337 4.45996 14.7133C3.54219 14.5899 2.81432 14.3313 2.24219 13.7592C1.67007 13.187 1.41148 12.4591 1.28809 11.5414C1.16769 10.6458 1.16796 9.49877 1.16797 8.03845V7.96228C1.16796 6.50181 1.16767 5.35399 1.28809 4.45837C1.4115 3.54077 1.67013 2.81266 2.24219 2.2406C2.81428 1.66861 3.54232 1.41086 4.45996 1.28748C5.35551 1.16707 6.50256 1.16637 7.96289 1.16638H8.03906ZM7.33398 7.00037C6.96607 7.00054 6.66818 7.29848 6.66797 7.66638C6.66797 8.03446 6.96594 8.3332 7.33398 8.33337V11.0004C7.33413 11.3684 7.63287 11.6664 8.00098 11.6664C8.36908 11.6664 8.66783 11.3684 8.66797 11.0004V8.30701C8.66805 8.17393 8.6677 8.01556 8.64941 7.87927C8.62728 7.71466 8.56809 7.4866 8.375 7.29334C8.18172 7.10005 7.95375 7.0401 7.78906 7.01794C7.65262 6.9996 7.4936 7.00028 7.36035 7.00037C7.35156 7.00037 7.34255 7.00037 7.33398 7.00037ZM7.99805 4.33337C7.6315 4.33337 7.33398 4.63218 7.33398 5.00037C7.33414 5.36842 7.6316 5.66638 7.99805 5.66638H8.00391C8.37027 5.66629 8.66683 5.36836 8.66699 5.00037C8.66699 4.63223 8.37037 4.33347 8.00391 4.33337H7.99805Z"
      fill={String(props.fill) ?? '#148FCC'}
    />
  </Icon>
);

export const MainFootballIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.04167 9.99996C1.04167 5.05241 5.05245 1.04163 10 1.04163C14.9476 1.04163 18.9583 5.05241 18.9583 9.99996C18.9583 14.9475 14.9476 18.9583 10 18.9583C5.05245 18.9583 1.04167 14.9475 1.04167 9.99996ZM4.03062 5.9551C3.99546 5.87542 4.00403 5.78301 4.05502 5.71241C4.88473 4.5639 6.03907 3.66537 7.38351 3.15135C7.45974 3.12221 7.54532 3.13391 7.61206 3.18087L9.06078 4.20017C9.12732 4.24699 9.16692 4.32327 9.16692 4.40463V7.06844C9.16692 7.14631 9.13063 7.21973 9.06877 7.26703L7.3417 8.58759C7.28125 8.63381 7.20304 8.64998 7.12922 8.63153L5.09272 8.1224C5.01784 8.10368 4.9558 8.05142 4.92464 7.98081L4.03062 5.9551ZM3.71 13.5004C3.61763 13.5013 3.53199 13.4513 3.48947 13.3693C3.12195 12.6606 2.86676 11.8842 2.74747 11.0638C2.73447 10.9744 2.77286 10.8856 2.84556 10.8319L4.32198 9.74141C4.38202 9.69706 4.45873 9.68187 4.53114 9.69997L6.91829 10.2968C7.00289 10.3179 7.07035 10.3816 7.09632 10.4649L7.46764 11.6554C7.49237 11.7347 7.47609 11.8211 7.42419 11.886L6.22532 13.3846C6.17839 13.4433 6.10758 13.4777 6.03247 13.4784L3.71 13.5004ZM10.0004 17.3295C9.19146 17.3295 8.41316 17.1985 7.68553 16.9565C7.58464 16.9229 7.51846 16.8271 7.5195 16.7208L7.5413 14.4929C7.54185 14.4369 7.56113 14.3828 7.59607 14.3391L8.51197 13.1943C8.55998 13.1343 8.63292 13.0997 8.70976 13.1005L10.9499 13.1236C11.0326 13.1244 11.1095 13.1661 11.1553 13.2349L12.2256 14.8402C12.2281 14.8441 12.2287 14.849 12.2272 14.8533L11.4522 17.0598C11.4228 17.1436 11.3512 17.2058 11.2637 17.221C10.8533 17.2923 10.4312 17.3295 10.0004 17.3295ZM17.2265 10.0105C17.2911 10.0582 17.3291 10.1342 17.3268 10.2145C17.2786 11.8906 16.6678 13.4256 15.6766 14.6374C15.6202 14.7064 15.5304 14.7382 15.4427 14.7223L14.0772 14.4752C14.0104 14.4631 13.9514 14.4243 13.9137 14.3678L12.4626 12.1912C12.4209 12.1286 12.4096 12.0505 12.4318 11.9786L13.0597 9.95032C13.0826 9.87645 13.1383 9.81732 13.2107 9.79017L15.5492 8.91323C15.6285 8.88351 15.7174 8.89592 15.7855 8.94622L17.2265 10.0105ZM12.3917 3.18317C12.4586 3.13557 12.5447 3.12359 12.6214 3.15296C13.7944 3.60225 14.8225 4.3443 15.6162 5.28968C15.6736 5.35796 15.6881 5.45214 15.6562 5.53538L14.9978 7.25016C14.9721 7.31693 14.9191 7.36952 14.8522 7.39463L12.4729 8.28687C12.3926 8.31696 12.3025 8.30385 12.2342 8.25212L10.9327 7.26701C10.8703 7.21976 10.8336 7.14598 10.8336 7.06768V4.42057C10.8336 4.33966 10.8727 4.26375 10.9387 4.21685L12.3917 3.18317Z"
      fill="#00111A"
    />
  </Icon>
);

export const XOutlinedIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5699 3.42998C16.9767 3.83677 16.9767 4.49632 16.5699 4.90311L4.90324 16.5698C4.49644 16.9766 3.83689 16.9766 3.4301 16.5698C3.0233 16.163 3.0233 15.5034 3.4301 15.0966L15.0968 3.42998C15.5036 3.02318 16.1631 3.02318 16.5699 3.42998Z"
      fill="#334148"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.4301 3.42998C3.83689 3.02318 4.49644 3.02318 4.90324 3.42998L16.5699 15.0966C16.9767 15.5034 16.9767 16.163 16.5699 16.5698C16.1631 16.9766 15.5036 16.9766 15.0968 16.5698L3.4301 4.90311C3.0233 4.49632 3.0233 3.83677 3.4301 3.42998Z"
      fill="#334148"
    />
  </Icon>
);

export const CircuitCalendarIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.83329 1.66671C5.83329 1.20647 5.4602 0.833374 4.99996 0.833374C4.53972 0.833374 4.16663 1.20647 4.16663 1.66671V2.04075C4.48356 1.94022 4.82124 1.86844 5.1794 1.81638C5.38602 1.78635 5.6039 1.76234 5.83329 1.74315V1.66671Z"
      fill="#546066"
    />
    <path
      d="M15.8333 2.04075C15.5164 1.94022 15.1787 1.86844 14.8205 1.81638C14.6139 1.78635 14.396 1.76234 14.1666 1.74315V1.66671C14.1666 1.20647 14.5397 0.833374 15 0.833374C15.4602 0.833374 15.8333 1.20647 15.8333 1.66671V2.04075Z"
      fill="#546066"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8573 1.66663H9.14269C7.51912 1.6666 6.20951 1.66658 5.17944 1.8163C4.10445 1.97254 3.214 2.30647 2.51502 3.06213C1.82458 3.80855 1.52732 4.74389 1.3868 5.87384C1.24997 6.97408 1.24998 8.37835 1.25 10.1449V10.6884C1.24998 12.4549 1.24997 13.8592 1.3868 14.9594C1.52732 16.0894 1.82458 17.0247 2.51502 17.7711C3.214 18.5268 4.10445 18.8607 5.17944 19.017C6.20952 19.1667 7.51911 19.1667 9.14269 19.1666H10.8573C12.4809 19.1667 13.7905 19.1667 14.8206 19.017C15.8955 18.8607 16.786 18.5268 17.485 17.7711C18.1754 17.0247 18.4727 16.0894 18.6132 14.9594C18.75 13.8592 18.75 12.4549 18.75 10.6884V10.1449C18.75 8.37836 18.75 6.97408 18.6132 5.87384C18.4727 4.74389 18.1754 3.80855 17.485 3.06213C16.786 2.30647 15.8955 1.97254 14.8206 1.8163C13.7905 1.66658 12.4809 1.6666 10.8573 1.66663ZM3.74819 7.49996C3.366 7.49996 3.17491 7.49996 3.05321 7.6201C2.93151 7.74023 2.92906 7.9289 2.92417 8.30622C2.91689 8.86719 2.91667 9.49511 2.91667 10.2027V10.6306C2.91667 12.468 2.91819 13.7684 3.04073 14.7537C3.16106 15.7213 3.38552 16.2578 3.73852 16.6394C4.08297 17.0118 4.55392 17.2419 5.41917 17.3676C6.31548 17.4979 7.50354 17.5 9.20833 17.5H10.7917C12.4965 17.5 13.6845 17.4979 14.5808 17.3676C15.4461 17.2419 15.917 17.0118 16.2615 16.6394C16.6145 16.2578 16.8389 15.7213 16.9593 14.7537C17.0818 13.7684 17.0833 12.468 17.0833 10.6306V10.2027C17.0833 9.49511 17.0831 8.86719 17.0758 8.30622C17.0709 7.9289 17.0685 7.74023 16.9468 7.6201C16.8251 7.49996 16.634 7.49996 16.2518 7.49996H3.74819Z"
      fill="#546066"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.625 10.8333C5.625 10.258 6.09137 9.79163 6.66667 9.79163H6.67414C7.24944 9.79163 7.71581 10.258 7.71581 10.8333C7.71581 11.4086 7.24944 11.875 6.67414 11.875H6.66667C6.09137 11.875 5.625 11.4086 5.625 10.8333ZM8.9546 10.8333C8.9546 10.258 9.42096 9.79163 9.99626 9.79163H10.0037C10.579 9.79163 11.0454 10.258 11.0454 10.8333C11.0454 11.4086 10.579 11.875 10.0037 11.875H9.99626C9.42096 11.875 8.9546 11.4086 8.9546 10.8333ZM12.2842 10.8333C12.2842 10.258 12.7506 9.79163 13.3259 9.79163H13.3333C13.9086 9.79163 14.375 10.258 14.375 10.8333C14.375 11.4086 13.9086 11.875 13.3333 11.875H13.3259C12.7506 11.875 12.2842 11.4086 12.2842 10.8333ZM5.625 14.1666C5.625 13.5913 6.09137 13.125 6.66667 13.125H6.67414C7.24944 13.125 7.71581 13.5913 7.71581 14.1666C7.71581 14.7419 7.24944 15.2083 6.67414 15.2083H6.66667C6.09137 15.2083 5.625 14.7419 5.625 14.1666ZM8.9546 14.1666C8.9546 13.5913 9.42096 13.125 9.99626 13.125H10.0037C10.579 13.125 11.0454 13.5913 11.0454 14.1666C11.0454 14.7419 10.579 15.2083 10.0037 15.2083H9.99626C9.42096 15.2083 8.9546 14.7419 8.9546 14.1666Z"
      fill="#546066"
    />
  </Icon>
);

export const ClockIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 1.04199C14.9476 1.04199 18.958 5.05245 18.958 10C18.958 14.9476 14.9476 18.958 10 18.958C5.05245 18.958 1.04199 14.9476 1.04199 10C1.04199 5.05245 5.05245 1.04199 10 1.04199ZM13.9229 6.07715C13.5975 5.75177 13.0696 5.75187 12.7441 6.07715L10 8.82129L8.50586 7.32715C8.18041 7.00187 7.65253 7.00177 7.32715 7.32715C7.00178 7.65254 7.00188 8.18042 7.32715 8.50586L8.82129 10L8.57715 10.2441C8.25187 10.5696 8.25177 11.0975 8.57715 11.4229C8.90253 11.7482 9.43041 11.7481 9.75586 11.4229L10 11.1787L10.2441 11.4219C10.5696 11.7473 11.0974 11.7473 11.4229 11.4219C11.7478 11.0965 11.7478 10.5695 11.4229 10.2441L11.1787 10L13.9229 7.25586C14.2481 6.93041 14.2482 6.40253 13.9229 6.07715Z"
      fill="#546066"
    />
  </Icon>
);

export const PriceIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2897 2.70837H11.2897H8.71047H8.71046H8.71046C7.17795 2.70837 5.97439 2.70836 5.02557 2.81554C4.0571 2.92494 3.27175 3.15306 2.61894 3.66861C2.42351 3.82295 2.24231 3.99342 2.07757 4.17821C1.52242 4.80088 1.27452 5.55562 1.15644 6.48158C1.04173 7.3811 1.04174 8.51941 1.04175 9.95607V9.95608V9.95609V10.044V10.044V10.044C1.04174 11.4807 1.04173 12.619 1.15644 13.5185C1.27452 14.4445 1.52242 15.1992 2.07757 15.8219C2.24231 16.0067 2.42351 16.1771 2.61894 16.3315C3.27175 16.847 4.0571 17.0751 5.02557 17.1845C5.97438 17.2917 7.17794 17.2917 8.71043 17.2917H8.71046H11.2897H11.2897C12.8222 17.2917 14.0258 17.2917 14.9746 17.1845C15.9431 17.0751 16.7284 16.847 17.3812 16.3315C17.5767 16.1771 17.7578 16.0067 17.9226 15.8219C18.4777 15.1992 18.7256 14.4445 18.8437 13.5185C18.9584 12.619 18.9584 11.4807 18.9584 10.044V9.95608C18.9584 8.51941 18.9584 7.3811 18.8437 6.48158C18.7256 5.55562 18.4777 4.80089 17.9226 4.17821C17.7578 3.99342 17.5767 3.82295 17.3812 3.66861C16.7284 3.15306 15.9431 2.92494 14.9746 2.81554C14.0258 2.70836 12.8222 2.70837 11.2897 2.70837ZM10.0001 12.5C11.3808 12.5 12.5001 11.3808 12.5001 10C12.5001 8.61933 11.3808 7.50004 10.0001 7.50004C8.61937 7.50004 7.50008 8.61933 7.50008 10C7.50008 11.3808 8.61937 12.5 10.0001 12.5ZM15.425 9.16671C15.8853 9.16671 16.2584 9.5398 16.2584 10C16.2584 10.4603 15.8853 10.8334 15.425 10.8334H15.4176C14.9573 10.8334 14.5842 10.4603 14.5842 10C14.5842 9.5398 14.9573 9.16671 15.4176 9.16671H15.425ZM5.41772 10C5.41772 9.5398 5.04463 9.16671 4.58439 9.16671H4.57691C4.11667 9.16671 3.74357 9.5398 3.74357 10C3.74357 10.4603 4.11667 10.8334 4.57691 10.8334H4.58439C5.04463 10.8334 5.41772 10.4603 5.41772 10Z"
      fill="#546066"
    />
  </Icon>
);

export const CircuitLinkIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1741 9.3258C11.8836 8.0353 9.81081 8.0031 8.48177 9.22921C8.14349 9.54129 7.61628 9.52005 7.30421 9.18178C6.99214 8.8435 7.01338 8.31629 7.35165 8.00422C9.33538 6.17412 12.4271 6.22181 14.3526 8.14729C16.327 10.1217 16.327 13.3228 14.3526 15.2972L11.964 17.6857C9.98966 19.6601 6.78855 19.6601 4.81416 17.6857C2.83978 15.7113 2.83978 12.5102 4.81416 10.5358L5.20112 10.1489C5.52655 9.82344 6.05419 9.82344 6.37963 10.1489C6.70507 10.4743 6.70506 11.002 6.37963 11.3274L5.99267 11.7143C4.66916 13.0379 4.66916 15.1837 5.99267 16.5072C7.31618 17.8307 9.46202 17.8307 10.7855 16.5072L13.1741 14.1187C14.4976 12.7951 14.4976 10.6493 13.1741 9.3258Z"
      fill="#546066"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0073 3.49231C12.6838 2.1688 10.538 2.1688 9.21447 3.49231L6.82593 5.88085C5.50242 7.20436 5.50242 9.3502 6.82593 10.6737C8.11642 11.9642 10.1892 11.9964 11.5182 10.7703C11.8565 10.4582 12.3837 10.4795 12.6958 10.8177C13.0079 11.156 12.9866 11.6832 12.6484 11.9953C10.6646 13.8254 7.5729 13.7777 5.64741 11.8522C3.67303 9.87784 3.67303 6.67673 5.64741 4.70234L8.03596 2.3138C10.0103 0.339412 13.2115 0.339412 15.1858 2.3138C17.1602 4.28818 17.1602 7.48929 15.1858 9.46367L14.7989 9.85063C14.4734 10.1761 13.9458 10.1761 13.6204 9.85063C13.2949 9.52519 13.2949 8.99755 13.6204 8.67212L14.0073 8.28516C15.3308 6.96165 15.3308 4.81582 14.0073 3.49231Z"
      fill="#546066"
    />
  </Icon>
);

export const GreenLinkIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_35761_12666)">
      <path
        d="M7.5 12.5C7.5 10.143 7.5 8.96447 8.23223 8.23223C8.96447 7.5 10.143 7.5 12.5 7.5L13.3333 7.5C15.6904 7.5 16.8689 7.5 17.6011 8.23223C18.3333 8.96447 18.3333 10.143 18.3333 12.5V13.3333C18.3333 15.6904 18.3333 16.8689 17.6011 17.6011C16.8689 18.3333 15.6904 18.3333 13.3333 18.3333H12.5C10.143 18.3333 8.96447 18.3333 8.23223 17.6011C7.5 16.8689 7.5 15.6904 7.5 13.3333L7.5 12.5Z"
        stroke="#12BA4B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1666 7.50033C14.1647 5.03608 14.1274 3.75967 13.4101 2.88568C13.2716 2.7169 13.1168 2.56214 12.9481 2.42362C12.0261 1.66699 10.6563 1.66699 7.91675 1.66699C5.17718 1.66699 3.8074 1.66699 2.88544 2.42362C2.71666 2.56214 2.56189 2.7169 2.42338 2.88568C1.66675 3.80764 1.66675 5.17742 1.66675 7.91699C1.66675 10.6566 1.66675 12.0263 2.42338 12.9483C2.56189 13.1171 2.71666 13.2718 2.88544 13.4104C3.75942 14.1276 5.03584 14.1649 7.50008 14.1669"
        stroke="#12BA4B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_35761_12666">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export const MinusIcon = (props: IconProps) => (
  <Icon
    width="16px"
    height="16px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.25 12C21.25 12.6904 20.6904 13.25 20 13.25H4C3.30964 13.25 2.75 12.6904 2.75 12C2.75 11.3096 3.30964 10.75 4 10.75L20 10.75C20.6904 10.75 21.25 11.3096 21.25 12Z"
      fill="#00111A"
    />
  </Icon>
);

export const RoundedPlusIcon = (props: IconProps) => (
  <Icon
    width="16px"
    height="16px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2.75C12.6904 2.75 13.25 3.30964 13.25 4V10.75H20C20.6904 10.75 21.25 11.3096 21.25 12C21.25 12.6904 20.6904 13.25 20 13.25H13.25V20C13.25 20.6904 12.6904 21.25 12 21.25C11.3096 21.25 10.75 20.6904 10.75 20V13.25H4C3.30964 13.25 2.75 12.6904 2.75 12C2.75 11.3096 3.30964 10.75 4 10.75H10.75V4C10.75 3.30964 11.3096 2.75 12 2.75Z"
      fill="#00111A"
    />
  </Icon>
);

export const ShopPlusIcon = (props: IconProps) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M17.5436 9.58333L17.7755 8.19984C17.9271 7.29524 18.0029 6.84293 17.7601 6.54647C17.5173 6.25 17.0711 6.25 16.1786 6.25L3.82128 6.25C2.92876 6.25 2.4825 6.25 2.2397 6.54647C1.99689 6.84293 2.07271 7.29524 2.22436 8.19984L3.22733 14.1829C3.55976 16.1659 3.72598 17.1574 4.40463 17.7454C5.08327 18.3333 6.06155 18.3333 8.0181 18.3333H9.99992"
      stroke="#334148"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11.6667 15.0003L18.3334 15.0003M15.0001 18.3337L15.0001 11.667"
      stroke="#334148"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M14.5834 6.25033C14.5834 3.71902 12.5314 1.66699 10.0001 1.66699C7.46878 1.66699 5.41675 3.71902 5.41675 6.25033"
      stroke="#334148"
      strokeWidth="1.5"
    />
  </Icon>
);

export const ColoredShopIcon = (props: IconProps) => (
  <Icon
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="10"
      cy="10"
      r="10"
      transform="rotate(90 10 10)"
      fill={props.color as string}
    />
    <path
      d="M4.51834 19.856L3.11418 11.4798C2.90187 10.2133 2.79572 9.5801 3.13565 9.16505C3.47558 8.75 4.10034 8.75 5.34987 8.75L22.65 8.75C23.8996 8.75 24.5243 8.75 24.8643 9.16505C25.2042 9.5801 25.098 10.2133 24.8857 11.4798L23.4816 19.856C23.0162 22.6323 22.7835 24.0204 21.8334 24.8435C20.8833 25.6667 19.5137 25.6667 16.7745 25.6667H11.2254C8.48624 25.6667 7.11666 25.6667 6.16655 24.8435C5.21644 24.0204 4.98374 22.6323 4.51834 19.856Z"
      stroke="#00151A"
      strokeWidth="1.5"
    />
    <path
      d="M20.4167 8.74967C20.4167 5.20585 17.5439 2.33301 14 2.33301C10.4562 2.33301 7.58337 5.20585 7.58337 8.74967"
      stroke="#00111A"
      strokeWidth="1.5"
    />
  </Icon>
);

export const PercentCircleIcon = (props: IconProps) => (
  <Icon
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="10"
      cy="10"
      r="10"
      transform="rotate(90 10 10)"
      fill="#EFC9B6"
    />
    <path
      d="M9.33325 18.6663L18.6666 9.33301M11.6666 10.4997C11.6666 11.144 11.1443 11.6663 10.4999 11.6663C9.85559 11.6663 9.33325 11.144 9.33325 10.4997C9.33325 9.85534 9.85559 9.33301 10.4999 9.33301C11.1443 9.33301 11.6666 9.85534 11.6666 10.4997ZM18.6666 17.2994C18.6666 17.9438 18.1443 18.4661 17.4999 18.4661C16.8556 18.4661 16.3333 17.9438 16.3333 17.2994C16.3333 16.6551 16.8556 16.1328 17.4999 16.1328C18.1443 16.1328 18.6666 16.6551 18.6666 17.2994Z"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle
      cx="13.9999"
      cy="13.9997"
      r="11.6667"
      stroke="#00111A"
      strokeWidth="1.5"
    />
  </Icon>
);

export const GreenCoinsIcon = (props: IconProps) => (
  <Icon
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="10"
      cy="10"
      r="10"
      transform="rotate(90 10 10)"
      fill="#B6EFC9"
    />
    <path
      d="M16.3333 20.9997C21.488 20.9997 25.6667 16.821 25.6667 11.6663C25.6667 6.51168 21.488 2.33301 16.3333 2.33301C11.1787 2.33301 7 6.51168 7 11.6663C7 16.821 11.1787 20.9997 16.3333 20.9997Z"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M15.3614 24.4638C14.0735 25.228 12.5698 25.6668 10.9637 25.6668C6.19722 25.6668 2.33325 21.8028 2.33325 17.0364C2.33325 15.4302 2.772 13.9266 3.53617 12.6387"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Icon>
);

export const ShoppingBasketSecureIcon = (props: IconProps) => (
  <Icon
    width="48px"
    height="48px"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M9.07086 13.5C8.08644 13.4999 7.18952 13.4998 6.47162 13.6047C5.68231 13.7201 4.84152 13.9961 4.21498 14.7611C3.59528 15.5178 3.47977 16.3943 3.50266 17.1913C3.52381 17.9276 3.67497 18.8288 3.84322 19.8319L6.28239 34.3822C6.66771 36.6809 6.97937 38.5402 7.40824 39.994C7.85383 41.5044 8.47364 42.7563 9.5891 43.7227C10.7091 44.693 12.0272 45.1143 13.5668 45.3115C15.0398 45.5001 16.8807 45.5001 19.143 45.5H23.3497C24.7131 45.5 25.3948 45.5 25.5606 45.168C25.7263 44.836 25.2813 44.2442 24.3913 43.0607C21.8184 39.6394 20.9853 35.1784 21.8154 30.8026C21.8506 30.6154 21.9385 30.1486 22.0524 29.7695C22.2081 29.251 22.53 28.4184 23.2698 27.6373C24.1014 26.7592 25.092 26.3923 25.3803 26.2855C25.7032 26.1653 26.1699 26.0208 26.4934 25.9225C26.5351 25.9098 26.5559 25.9035 26.576 25.8958C26.5961 25.8881 26.6156 25.8789 26.6547 25.8606L27.7255 25.3587C28.003 25.2132 28.3401 25.0364 28.7316 24.8437C29.9451 24.2464 31.7213 23.5 33.9989 23.5C36.2763 23.5 38.0528 24.2463 39.2664 24.8433C39.6579 25.0359 39.995 25.2126 40.2726 25.3581C40.939 25.7074 41.2283 25.838 41.4719 25.9119C41.5263 25.9283 41.5969 25.9518 41.6786 25.9801C42.3188 26.202 42.6389 26.3129 42.8784 26.1708C43.1179 26.0287 43.1725 25.703 43.2817 25.0516L44.1568 19.8318C44.325 18.8287 44.4762 17.9276 44.4973 17.1913C44.5202 16.3943 44.4047 15.5178 43.785 14.7611C43.1585 13.9961 42.3177 13.7201 41.5284 13.6047C40.8105 13.4998 39.9135 13.4999 38.9291 13.5L9.07086 13.5Z"
      fill="#6276DD"
    />
    <path
      d="M30.0559 27.5354C31.1068 27.0181 32.3948 26.5 33.9985 26.5C35.6021 26.5 36.8905 27.0181 37.9419 27.5353C38.2987 27.7108 38.6075 27.8727 38.8882 28.0198C39.5086 28.345 39.9918 28.5982 40.5536 28.7684C40.9132 28.8773 41.2884 28.991 41.5502 29.0884C41.7748 29.172 42.2119 29.341 42.552 29.7C42.8519 30.0166 42.9937 30.3634 43.0746 30.6325C43.1412 30.8544 43.1975 31.1516 43.237 31.3603C44.3521 37.2335 41.8961 42.9119 35.8707 45.1036C35.3244 45.3026 34.7823 45.5 34.0013 45.5C33.2202 45.5 32.678 45.3026 32.1317 45.1036C26.1064 42.9121 23.6479 37.2341 24.7627 31.3604C24.8022 31.1517 24.8584 30.8545 24.9251 30.6327C25.0059 30.3636 25.1477 30.0168 25.4475 29.7002C25.7876 29.3412 26.2248 29.1721 26.4493 29.0886C26.7111 28.9911 27.0863 28.8774 27.4459 28.7684C28.0073 28.5983 28.4899 28.3451 29.1098 28.02C29.3904 27.8729 29.6991 27.711 30.0559 27.5354Z"
      fill="#6276DD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 6.5C19.5817 6.5 16 10.0817 16 14.5V15.5C16 16.6046 15.1046 17.5 14 17.5C12.8954 17.5 12 16.6046 12 15.5V14.5C12 7.87258 17.3726 2.5 24 2.5C30.6274 2.5 36 7.87258 36 14.5V15.5C36 16.6046 35.1046 17.5 34 17.5C32.8954 17.5 32 16.6046 32 15.5V14.5C32 10.0817 28.4183 6.5 24 6.5Z"
      fill="#6276DD"
    />
  </Icon>
);

export const PresentationBarChartIcon = (props: IconProps) => (
  <Icon
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="10"
      cy="10"
      r="10"
      transform="rotate(90 10 10)"
      fill="#E6E8E8"
    />
    <path
      d="M14 21V25.6667"
      stroke="#00151A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6667 21L5.83337 25.6667"
      stroke="#00151A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3334 21L22.1667 25.6667"
      stroke="#00151A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.91663 13.9997C2.91663 17.2995 2.91663 18.9494 3.94175 19.9745C4.96688 20.9997 6.61679 20.9997 9.91663 20.9997H18.0833C21.3831 20.9997 23.033 20.9997 24.0582 19.9745C25.0833 18.9494 25.0833 17.2995 25.0833 13.9997V9.33301C25.0833 6.03318 25.0833 4.38326 24.0582 3.35813C23.033 2.33301 21.3831 2.33301 18.0833 2.33301H9.91663C6.61679 2.33301 4.96688 2.33301 3.94175 3.35813C2.91663 4.38326 2.91663 6.03318 2.91663 9.33301V13.9997Z"
      stroke="#00151A"
      strokeWidth="1.5"
    />
    <path
      d="M9.33337 15.167V11.667M14 15.167V8.16699M18.6667 15.167V12.8337"
      stroke="#00151A"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Icon>
);

export const FilterIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.38121 10.4217C5.30751 8.87135 3.8297 7.16596 3.02278 6.20722C2.773 5.91044 2.69115 5.69325 2.64194 5.31067C2.47343 4.00067 2.38917 3.34567 2.77329 2.92283C3.15742 2.5 3.8367 2.5 5.19527 2.5H14.8047C16.1633 2.5 16.8426 2.5 17.2267 2.92283C17.6108 3.34567 17.5266 4.00067 17.3581 5.31067C17.3089 5.69326 17.227 5.91045 16.9772 6.20722C16.1692 7.16718 14.6884 8.87559 12.6105 10.428C12.4225 10.5684 12.2986 10.7973 12.2756 11.0512C12.0697 13.3266 11.8799 14.573 11.7618 15.2035C11.571 16.2214 10.1276 16.8338 9.35501 17.3803C8.89505 17.7055 8.33692 17.3183 8.27731 16.8148C8.16369 15.8551 7.94967 13.9053 7.71606 11.0512C7.69507 10.7949 7.57071 10.5634 7.38121 10.4217Z"
      stroke="#334148"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ShoppingBasketLockedIcon = (props: IconProps) => (
  <Icon
    width="48px"
    height="48px"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M9.07086 13.5L9.17126 13.5L38.9291 13.5C39.9135 13.4999 40.8105 13.4998 41.5284 13.6047C42.3177 13.7201 43.1585 13.9961 43.785 14.7611C44.4047 15.5178 44.5202 16.3943 44.4973 17.1913C44.4762 17.9276 44.325 18.8287 44.1568 19.8318L41.7176 34.3821L41.7176 34.3822C41.3323 36.6809 41.0206 38.5402 40.5917 39.994C40.1461 41.5044 39.5263 42.7563 38.4109 43.7227C37.2909 44.693 35.9728 45.1143 34.4331 45.3115C32.9602 45.5001 31.1193 45.5001 28.857 45.5H19.143C16.8807 45.5001 15.0398 45.5001 13.5668 45.3115C12.0272 45.1143 10.7091 44.693 9.5891 43.7227C8.47364 42.7563 7.85383 41.5044 7.40824 39.994C6.97937 38.5402 6.66771 36.6809 6.28239 34.3822L3.85929 19.9276L3.84322 19.8319C3.67497 18.8288 3.52381 17.9276 3.50266 17.1913C3.47977 16.3943 3.59528 15.5178 4.21498 14.7611C4.84152 13.9961 5.68231 13.7201 6.47162 13.6047C7.18952 13.4998 8.08644 13.4999 9.07086 13.5Z"
      fill="#5114CC"
    />
    <mask
      id="path-2-outside-1_37155_24961"
      maskUnits="userSpaceOnUse"
      x="25.0732"
      y="25.4893"
      width="18"
      height="21"
      fill="black"
    >
      <rect fill="white" x="25.0732" y="25.4893" width="18" height="21" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 27.4893C36.4047 27.4893 38.3545 29.439 38.3545 31.8438V33.2529C39.5951 33.633 40.5321 34.7229 40.71 36.0439C40.8272 36.9149 40.9267 37.8301 40.9268 38.7705C40.9268 39.7111 40.8273 40.6269 40.71 41.498C40.495 43.0947 39.1721 44.3565 37.543 44.4316C36.4121 44.4836 35.2634 44.5107 34 44.5107C32.7366 44.5107 31.5879 44.4836 30.457 44.4316C28.8279 44.3565 27.505 43.0947 27.29 41.498C27.1727 40.6269 27.0732 39.7111 27.0732 38.7705C27.0733 37.8301 27.1728 36.9149 27.29 36.0439C27.4679 34.7229 28.4049 33.633 29.6455 33.2529V31.8438C29.6455 29.439 31.5953 27.4893 34 27.4893ZM33.9951 37.583C33.3423 37.583 32.8127 38.1148 32.8125 38.7705C32.8125 39.4263 33.3422 39.958 33.9951 39.958H34.0049C34.6578 39.958 35.1875 39.4263 35.1875 38.7705C35.1873 38.1148 34.6577 37.583 34.0049 37.583H33.9951ZM34 29.0732C32.4697 29.0732 31.2295 30.3135 31.2295 31.8438V33.0791C32.1143 33.0477 33.0227 33.0312 34 33.0312C34.9773 33.0312 35.8857 33.0477 36.7705 33.0791V31.8438C36.7705 30.3135 35.5303 29.0732 34 29.0732Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34 27.4893C36.4047 27.4893 38.3545 29.439 38.3545 31.8438V33.2529C39.5951 33.633 40.5321 34.7229 40.71 36.0439C40.8272 36.9149 40.9267 37.8301 40.9268 38.7705C40.9268 39.7111 40.8273 40.6269 40.71 41.498C40.495 43.0947 39.1721 44.3565 37.543 44.4316C36.4121 44.4836 35.2634 44.5107 34 44.5107C32.7366 44.5107 31.5879 44.4836 30.457 44.4316C28.8279 44.3565 27.505 43.0947 27.29 41.498C27.1727 40.6269 27.0732 39.7111 27.0732 38.7705C27.0733 37.8301 27.1728 36.9149 27.29 36.0439C27.4679 34.7229 28.4049 33.633 29.6455 33.2529V31.8438C29.6455 29.439 31.5953 27.4893 34 27.4893ZM33.9951 37.583C33.3423 37.583 32.8127 38.1148 32.8125 38.7705C32.8125 39.4263 33.3422 39.958 33.9951 39.958H34.0049C34.6578 39.958 35.1875 39.4263 35.1875 38.7705C35.1873 38.1148 34.6577 37.583 34.0049 37.583H33.9951ZM34 29.0732C32.4697 29.0732 31.2295 30.3135 31.2295 31.8438V33.0791C32.1143 33.0477 33.0227 33.0312 34 33.0312C34.9773 33.0312 35.8857 33.0477 36.7705 33.0791V31.8438C36.7705 30.3135 35.5303 29.0732 34 29.0732Z"
      fill="#5114CC"
    />
    <path
      d="M34 27.4893V25.9893V27.4893ZM38.3545 31.8438H39.8545V31.8438H38.3545ZM38.3545 33.2529H36.8545V34.3622L37.9151 34.6871L38.3545 33.2529ZM40.71 36.0439L42.1965 35.8438L42.1965 35.8438L40.71 36.0439ZM40.9268 38.7705H42.4268V38.7705L40.9268 38.7705ZM40.71 41.498L42.1965 41.6982L42.1965 41.6982L40.71 41.498ZM37.543 44.4316L37.6119 45.9301L37.612 45.93L37.543 44.4316ZM34 44.5107V46.0107V44.5107ZM30.457 44.4316L30.388 45.93L30.3881 45.9301L30.457 44.4316ZM27.29 41.498L25.8035 41.6982L25.8035 41.6982L27.29 41.498ZM27.0732 38.7705L25.5732 38.7705V38.7705H27.0732ZM27.29 36.0439L25.8035 35.8438L25.8035 35.8438L27.29 36.0439ZM29.6455 33.2529L30.0849 34.6871L31.1455 34.3622V33.2529H29.6455ZM29.6455 31.8438H28.1455V31.8438H29.6455ZM32.8125 38.7705L31.3125 38.7701V38.7705H32.8125ZM35.1875 38.7705H36.6875V38.7701L35.1875 38.7705ZM34 29.0732V27.5732V27.5732V29.0732ZM31.2295 31.8438H29.7295V31.8438H31.2295ZM31.2295 33.0791H29.7295V34.6333L31.2827 34.5782L31.2295 33.0791ZM34 33.0312V31.5312V31.5312V33.0312ZM36.7705 33.0791L36.7173 34.5782L38.2705 34.6333V33.0791H36.7705ZM36.7705 31.8438H38.2705V31.8438H36.7705ZM34 27.4893V28.9893C35.5763 28.9893 36.8545 30.2674 36.8545 31.8438H38.3545H39.8545C39.8545 28.6106 37.2332 25.9893 34 25.9893V27.4893ZM38.3545 31.8438H36.8545V33.2529H38.3545H39.8545V31.8438H38.3545ZM38.3545 33.2529L37.9151 34.6871C38.5953 34.8955 39.1236 35.5033 39.2234 36.2441L40.71 36.0439L42.1965 35.8438C41.9406 33.9425 40.5949 32.3705 38.7939 31.8187L38.3545 33.2529ZM40.71 36.0439L39.2234 36.2441C39.3378 37.0936 39.4267 37.9308 39.4268 38.7705L40.9268 38.7705L42.4268 38.7705C42.4267 37.7294 42.3167 36.7362 42.1965 35.8438L40.71 36.0439ZM40.9268 38.7705H39.4268C39.4268 39.6105 39.3378 40.4483 39.2234 41.2979L40.71 41.498L42.1965 41.6982C42.3167 40.8056 42.4268 39.8117 42.4268 38.7705H40.9268ZM40.71 41.498L39.2234 41.2979C39.1016 42.2021 38.353 42.8927 37.4739 42.9332L37.543 44.4316L37.612 45.93C39.9911 45.8204 41.8883 43.9873 42.1965 41.6982L40.71 41.498ZM37.543 44.4316L37.4741 42.9332C36.3669 42.9841 35.2411 43.0107 34 43.0107V44.5107V46.0107C35.2857 46.0107 36.4574 45.9831 37.6119 45.9301L37.543 44.4316ZM34 44.5107V43.0107C32.7589 43.0107 31.6331 42.9841 30.5259 42.9332L30.457 44.4316L30.3881 45.9301C31.5426 45.9831 32.7143 46.0107 34 46.0107V44.5107ZM30.457 44.4316L30.5261 42.9332C29.647 42.8927 28.8984 42.2021 28.7766 41.2979L27.29 41.498L25.8035 41.6982C26.1117 43.9873 28.0089 45.8204 30.388 45.93L30.457 44.4316ZM27.29 41.498L28.7766 41.2979C28.6622 40.4483 28.5732 39.6105 28.5732 38.7705H27.0732H25.5732C25.5732 39.8117 25.6833 40.8056 25.8035 41.6982L27.29 41.498ZM27.0732 38.7705L28.5732 38.7705C28.5733 37.9308 28.6622 37.0936 28.7766 36.2441L27.29 36.0439L25.8035 35.8438C25.6833 36.7362 25.5733 37.7294 25.5732 38.7705L27.0732 38.7705ZM27.29 36.0439L28.7766 36.2441C28.8764 35.5033 29.4047 34.8955 30.0849 34.6871L29.6455 33.2529L29.2061 31.8187C27.4051 32.3705 26.0594 33.9425 25.8035 35.8438L27.29 36.0439ZM29.6455 33.2529H31.1455V31.8438H29.6455H28.1455V33.2529H29.6455ZM29.6455 31.8438H31.1455C31.1455 30.2674 32.4237 28.9893 34 28.9893V27.4893V25.9893C30.7668 25.9893 28.1455 28.6106 28.1455 31.8438H29.6455ZM33.9951 37.583V36.083C32.5079 36.083 31.3129 37.2923 31.3125 38.7701L32.8125 38.7705L34.3125 38.7709C34.3125 38.9373 34.1768 39.083 33.9951 39.083V37.583ZM32.8125 38.7705H31.3125C31.3125 40.2491 32.5082 41.458 33.9951 41.458V39.958V38.458C34.1763 38.458 34.3125 38.6036 34.3125 38.7705H32.8125ZM33.9951 39.958V41.458H34.0049V39.958V38.458H33.9951V39.958ZM34.0049 39.958V41.458C35.4918 41.458 36.6875 40.2491 36.6875 38.7705H35.1875H33.6875C33.6875 38.6036 33.8237 38.458 34.0049 38.458V39.958ZM35.1875 38.7705L36.6875 38.7701C36.6871 37.2923 35.4921 36.083 34.0049 36.083V37.583V39.083C33.8232 39.083 33.6875 38.9373 33.6875 38.7709L35.1875 38.7705ZM34.0049 37.583V36.083H33.9951V37.583V39.083H34.0049V37.583ZM34 29.0732V27.5732C31.6413 27.5732 29.7295 29.485 29.7295 31.8438H31.2295H32.7295C32.7295 31.1419 33.2981 30.5732 34 30.5732V29.0732ZM31.2295 31.8438H29.7295V33.0791H31.2295H32.7295V31.8438H31.2295ZM31.2295 33.0791L31.2827 34.5782C32.1492 34.5474 33.0399 34.5312 34 34.5312V33.0312V31.5312C33.0055 31.5312 32.0793 31.548 31.1763 31.58L31.2295 33.0791ZM34 33.0312V34.5312C34.9601 34.5312 35.8508 34.5474 36.7173 34.5782L36.7705 33.0791L36.8237 31.58C35.9207 31.548 34.9945 31.5312 34 31.5312V33.0312ZM36.7705 33.0791H38.2705V31.8438H36.7705H35.2705V33.0791H36.7705ZM36.7705 31.8438H38.2705C38.2705 29.485 36.3587 27.5732 34 27.5732V29.0732V30.5732C34.7019 30.5732 35.2705 31.1419 35.2705 31.8438H36.7705Z"
      fill="white"
      mask="url(#path-2-outside-1_37155_24961)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 6.5C19.5817 6.5 16 10.0817 16 14.5V15.5C16 16.6046 15.1046 17.5 14 17.5C12.8954 17.5 12 16.6046 12 15.5V14.5C12 7.87258 17.3726 2.5 24 2.5C30.6274 2.5 36 7.87258 36 14.5V15.5C36 16.6046 35.1046 17.5 34 17.5C32.8954 17.5 32 16.6046 32 15.5V14.5C32 10.0817 28.4183 6.5 24 6.5Z"
      fill="#5114CC"
    />
  </Icon>
);

export const AdjustmentFilterIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.08301 9.99967C2.08301 6.26772 2.08301 4.40175 3.24238 3.24238C4.40175 2.08301 6.26772 2.08301 9.99967 2.08301C13.7316 2.08301 15.5976 2.08301 16.757 3.24238C17.9163 4.40175 17.9163 6.26772 17.9163 9.99967C17.9163 13.7316 17.9163 15.5976 16.757 16.757C15.5976 17.9163 13.7316 17.9163 9.99967 17.9163C6.26772 17.9163 4.40175 17.9163 3.24238 16.757C2.08301 15.5976 2.08301 13.7316 2.08301 9.99967Z"
      stroke="#334448"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M8.33301 12.917C8.33301 13.6073 7.77336 14.167 7.08301 14.167C6.39265 14.167 5.83301 13.6073 5.83301 12.917C5.83301 12.2266 6.39265 11.667 7.08301 11.667C7.77336 11.667 8.33301 12.2266 8.33301 12.917Z"
      stroke="#334448"
      strokeWidth="1.5"
    />
    <path
      d="M14.167 7.08301C14.167 6.39265 13.6073 5.83301 12.917 5.83301C12.2266 5.83301 11.667 6.39265 11.667 7.08301C11.667 7.77336 12.2266 8.33301 12.917 8.33301C13.6073 8.33301 14.167 7.77336 14.167 7.08301Z"
      stroke="#334448"
      strokeWidth="1.5"
    />
    <path
      d="M7.08301 11.6663L7.08301 5.83301"
      stroke="#334448"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12.917 8.33366L12.917 14.167"
      stroke="#334448"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Icon>
);

export const FileCertificateIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.55882 18.3337C6.23126 18.3337 4.56748 18.3337 3.53374 17.3573C2.5 16.381 2.5 14.8097 2.5 11.667L2.5 8.33366C2.5 5.19096 2.5 3.61961 3.53374 2.6433C4.56748 1.66699 6.23126 1.66699 9.55883 1.66699L10.4412 1.66699C13.7687 1.66699 15.4325 1.66699 16.4663 2.6433C17.5 3.61961 17.5 5.19096 17.5 8.33366M9.58333 18.3337H10.8333"
      stroke="#334148"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M6.66699 5.83301H13.3337"
      stroke="#334148"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M6.66699 10H10.8337"
      stroke="#334148"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M14.583 15.491L13.8312 18.1187C13.7973 18.2506 13.9279 18.3651 14.0546 18.3145L15.7092 17.6537C15.7887 17.622 15.8773 17.622 15.9568 17.6537L17.6273 18.3208C17.7509 18.3702 17.8797 18.2621 17.8523 18.1321L17.2154 15.4089M18.333 13.3289C18.333 11.9505 17.2137 10.833 15.833 10.833C14.4523 10.833 13.333 11.9505 13.333 13.3289C13.333 14.7074 14.4523 15.8249 15.833 15.8249C17.2137 15.8249 18.333 14.7074 18.333 13.3289Z"
      stroke="#334148"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </Icon>
);

export const RocketIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.5 9.93582C9.7272 2.05725 14.9908 1.9664 17.0942 2.90579C18.0336 5.0092 17.9428 10.2728 10.0642 14.5C9.98252 14.0303 9.52813 12.7999 8.36412 11.6359C7.2001 10.4719 5.9697 10.0175 5.5 9.93582Z"
      stroke="#546066"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.125 14.125C12.6571 14.875 12.8207 16.2199 13.0329 17.5C13.0329 17.5 16.2418 15.1279 14.1892 11.875"
      stroke="#546066"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.87497 8.93912C5.12497 7.40703 3.78012 7.24346 2.5 7.03122C2.5 7.03122 4.87209 3.82235 8.12498 5.87494"
      stroke="#546066"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.01507 12.426C4.58854 12.8526 3.86344 14.0895 4.37528 15.625C5.91078 16.1368 7.14771 15.4117 7.57424 14.9852"
      stroke="#546066"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4174 7.04173C14.4174 6.23631 13.7645 5.58339 12.9591 5.58339C12.1537 5.58339 11.5007 6.23631 11.5007 7.04173C11.5007 7.84714 12.1537 8.50006 12.9591 8.50006C13.7645 8.50006 14.4174 7.84714 14.4174 7.04173Z"
      stroke="#546066"
      strokeWidth="1.5"
    />
  </Icon>
);

export const ArrowLeftV2Icon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.33301 10.0003L16.6664 10.0003"
      stroke="#334148"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.49964 14.167C7.49964 14.167 3.33302 11.0982 3.33301 10.0003C3.333 8.90226 7.49967 5.83362 7.49967 5.83362"
      stroke="#334148"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const WobbleLineIcon = (props: IconProps) => (
  <Icon
    width="100%"
    height="5px"
    viewBox="0 0 417 5"
    preserveAspectRatio="none"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.5 0.512146C3.28519 0.667053 5.61745 2.2851 6.50963 4.5H8.50063C9.43932 2.16962 11.9721 0.5 14.9494 0.5C17.9266 0.5 20.4594 2.16962 21.3981 4.5H23.3891C24.3278 2.16962 26.8607 0.5 29.8379 0.5C32.8151 0.5 35.348 2.16962 36.2866 4.5H38.2776C39.2163 2.16962 41.7492 0.5 44.7264 0.5C47.7036 0.5 50.2365 2.16962 51.1752 4.5H53.1662C54.1048 2.16962 56.6377 0.5 59.6149 0.5C62.5922 0.5 65.125 2.16962 66.0637 4.5H68.0547C68.9934 2.16962 71.5262 0.5 74.5034 0.5C77.4807 0.5 80.0135 2.16962 80.9522 4.5H82.9432C83.8819 2.16962 86.4147 0.5 89.3919 0.5C92.3692 0.5 94.902 2.16962 95.8407 4.5H97.8317C98.7704 2.16962 101.303 0.5 104.28 0.5C107.258 0.5 109.791 2.16962 110.729 4.5H112.72C113.659 2.16962 116.192 0.5 119.169 0.5C122.146 0.5 124.679 2.16962 125.618 4.5H127.609C128.547 2.16962 131.08 0.5 134.057 0.5C137.035 0.5 139.568 2.16962 140.506 4.5H142.497C143.436 2.16962 145.969 0.5 148.946 0.5C151.923 0.5 154.456 2.16962 155.395 4.5H157.386C158.324 2.16962 160.857 0.5 163.834 0.5C166.812 0.5 169.345 2.16962 170.283 4.5H172.274C173.213 2.16962 175.746 0.5 178.723 0.5C181.7 0.5 184.233 2.16962 185.172 4.5H187.163C188.101 2.16962 190.634 0.5 193.612 0.5C196.589 0.5 199.122 2.16962 200.06 4.5H202.051C202.99 2.16962 205.523 0.5 208.5 0.5C211.477 0.5 214.01 2.16962 214.949 4.5H216.94C217.878 2.16962 220.411 0.5 223.389 0.5C226.366 0.5 228.899 2.16962 229.837 4.5H231.828C232.767 2.16962 235.3 0.5 238.277 0.5C241.254 0.5 243.787 2.16962 244.726 4.5H246.717C247.656 2.16962 250.188 0.5 253.166 0.5C256.143 0.5 258.676 2.16962 259.614 4.5H261.605C262.544 2.16962 265.077 0.5 268.054 0.5C271.031 0.5 273.564 2.16962 274.503 4.5H276.494C277.433 2.16962 279.965 0.5 282.943 0.5C285.92 0.5 288.453 2.16962 289.391 4.5H291.382C292.321 2.16962 294.854 0.5 297.831 0.5C300.808 0.5 303.341 2.16962 304.28 4.5H306.271C307.21 2.16962 309.742 0.5 312.72 0.5C315.697 0.5 318.23 2.16962 319.168 4.5H321.159C322.098 2.16962 324.631 0.5 327.608 0.5C330.585 0.5 333.118 2.16962 334.057 4.5H336.048C336.986 2.16962 339.519 0.5 342.497 0.5C345.474 0.5 348.007 2.16962 348.945 4.5H350.936C351.875 2.16962 354.408 0.5 357.385 0.5C360.362 0.5 362.895 2.16962 363.834 4.5H365.825C366.763 2.16962 369.296 0.5 372.274 0.5C375.251 0.5 377.784 2.16962 378.722 4.5H380.713C381.652 2.16962 384.185 0.5 387.162 0.5C390.139 0.5 392.672 2.16962 393.611 4.5H395.602C396.54 2.16962 399.073 0.5 402.051 0.5C405.028 0.5 407.561 2.16962 408.499 4.5H410.49C411.382 2.28503 413.715 0.666992 416.5 0.512146"
      stroke="#DEE1E1"
      strokeLinecap="round"
    />
  </Icon>
);

export const FilledShoppingBasketIcon = (props: IconProps) => (
  <Icon
    width="64px"
    height="64px"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M12.0946 18L12.2284 18L51.9056 18C53.2181 17.9999 54.414 17.9997 55.3712 18.1396C56.4236 18.2935 57.5447 18.6615 58.3801 19.6815C59.2063 20.6903 59.3604 21.8591 59.3298 22.9218C59.3016 23.9035 59.1001 25.105 58.8758 26.4424L55.6235 45.8428L55.6235 45.8429C55.1098 48.9079 54.6942 51.387 54.1224 53.3253C53.5283 55.3392 52.7019 57.0084 51.2146 58.2969C49.7212 59.5906 47.9638 60.1525 45.9109 60.4153C43.947 60.6668 41.4925 60.6667 38.4761 60.6667H25.5241C22.5077 60.6667 20.0532 60.6668 18.0892 60.4153C16.0364 60.1525 14.2789 59.5906 12.7855 58.2969C11.2983 57.0084 10.4719 55.3392 9.87773 53.3253C9.30591 51.387 8.89036 48.9079 8.37661 45.8429L8.37661 45.8429L5.1458 26.5702L5.12438 26.4425C4.90004 25.105 4.6985 23.9035 4.6703 22.9218C4.63977 21.8591 4.79379 20.6903 5.62006 19.6815C6.45544 18.6615 7.57649 18.2935 8.62891 18.1396C9.58611 17.9997 10.782 17.9999 12.0946 18Z"
      fill={String(props.fill) ?? '#00111A'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32 8.66683C26.109 8.66683 21.3333 13.4425 21.3333 19.3335V20.6668C21.3333 22.1396 20.1394 23.3335 18.6667 23.3335C17.1939 23.3335 16 22.1396 16 20.6668V19.3335C16 10.4969 23.1634 3.3335 32 3.3335C40.8366 3.3335 48 10.4969 48 19.3335V20.6668C48 22.1396 46.8061 23.3335 45.3333 23.3335C43.8606 23.3335 42.6667 22.1396 42.6667 20.6668V19.3335C42.6667 13.4425 37.891 8.66683 32 8.66683Z"
      fill={String(props.fill) ?? '#00111A'}
    />
  </Icon>
);

export const FilledGreyShoppingBasketIcon = (props: IconProps) => (
  <Icon
    width="64px"
    height="64px"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M12.0946 18L12.2284 18L51.9056 18C53.2181 17.9999 54.414 17.9997 55.3712 18.1396C56.4236 18.2935 57.5447 18.6615 58.3801 19.6815C59.2063 20.6903 59.3604 21.8591 59.3298 22.9218C59.3016 23.9035 59.1001 25.105 58.8758 26.4424L55.6235 45.8428L55.6235 45.8429C55.1098 48.9079 54.6942 51.387 54.1224 53.3253C53.5283 55.3392 52.7019 57.0084 51.2146 58.2969C49.7212 59.5906 47.9638 60.1525 45.9109 60.4153C43.947 60.6668 41.4925 60.6667 38.4761 60.6667H25.5241C22.5077 60.6667 20.0532 60.6668 18.0892 60.4153C16.0364 60.1525 14.2789 59.5906 12.7855 58.2969C11.2983 57.0084 10.4719 55.3392 9.87773 53.3253C9.30591 51.387 8.89036 48.9079 8.37661 45.8429L8.37661 45.8429L5.1458 26.5702L5.12438 26.4425C4.90004 25.105 4.6985 23.9035 4.6703 22.9218C4.63977 21.8591 4.79379 20.6903 5.62006 19.6815C6.45544 18.6615 7.57649 18.2935 8.62891 18.1396C9.58611 17.9997 10.782 17.9999 12.0946 18Z"
      fill={String(props.fill) ?? '#00111A'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32 8.66683C26.109 8.66683 21.3333 13.4425 21.3333 19.3335V20.6668C21.3333 22.1396 20.1394 23.3335 18.6667 23.3335C17.1939 23.3335 16 22.1396 16 20.6668V19.3335C16 10.4969 23.1634 3.3335 32 3.3335C40.8366 3.3335 48 10.4969 48 19.3335V20.6668C48 22.1396 46.8061 23.3335 45.3333 23.3335C43.8606 23.3335 42.6667 22.1396 42.6667 20.6668V19.3335C42.6667 13.4425 37.891 8.66683 32 8.66683Z"
      fill={String(props.fill) ?? '#00111A'}
    />{' '}
  </Icon>
);

export const LeadIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.04163 5C1.04163 2.81387 2.81383 1.04167 4.99996 1.04167C7.18609 1.04167 8.95829 2.81387 8.95829 5C8.95829 7.18613 7.18609 8.95833 4.99996 8.95833C2.81383 8.95833 1.04163 7.18613 1.04163 5Z"
      strokeWidth="1.5"
    />
    <path
      d="M1.04163 15C1.04163 12.8139 2.81383 11.0417 4.99996 11.0417C7.18609 11.0417 8.95829 12.8139 8.95829 15C8.95829 17.1861 7.18609 18.9583 4.99996 18.9583C2.81383 18.9583 1.04163 17.1861 1.04163 15Z"
      strokeWidth="1.5"
    />
    <path
      d="M11.0416 15C11.0416 12.8139 12.8138 11.0417 15 11.0417C17.1861 11.0417 18.9583 12.8139 18.9583 15C18.9583 17.1861 17.1861 18.9583 15 18.9583C12.8138 18.9583 11.0416 17.1861 11.0416 15Z"
      strokeWidth="1.5"
    />
    <path
      d="M11.0416 5C11.0416 2.81387 12.8138 1.04167 15 1.04167C17.1861 1.04167 18.9583 2.81387 18.9583 5C18.9583 7.18613 17.1861 8.95833 15 8.95833C12.8138 8.95833 11.0416 7.18613 11.0416 5Z"
      strokeWidth="1.5"
    />
  </Icon>
);

export const MoneyWithEllipseIcon = (props: IconProps) => (
  <Icon
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="10"
      cy="10"
      r="10"
      transform="rotate(90 10 10)"
      fill="#BFC4C6"
    />
    <path
      d="M16.9738 14C16.9738 15.6108 15.668 16.9167 14.0572 16.9167C12.4463 16.9167 11.1405 15.6108 11.1405 14C11.1405 12.3892 12.4463 11.0833 14.0572 11.0833C15.668 11.0833 16.9738 12.3892 16.9738 14Z"
      stroke="#00151A"
      strokeWidth="1.5"
    />
    <path
      d="M2.33337 14C2.33337 9.87294 2.33337 7.80941 3.56164 6.43172C3.75809 6.21137 3.97462 6.00758 4.20874 5.82269C5.67253 4.66667 7.86503 4.66667 12.25 4.66667H15.75C20.135 4.66667 22.3276 4.66667 23.7913 5.82269C24.0255 6.00758 24.242 6.21137 24.4384 6.43172C25.6667 7.80941 25.6667 9.87294 25.6667 14C25.6667 18.1271 25.6667 20.1906 24.4384 21.5683C24.242 21.7886 24.0255 21.9924 23.7913 22.1773C22.3276 23.3333 20.135 23.3333 15.75 23.3333H12.25C7.86503 23.3333 5.67253 23.3333 4.20874 22.1773C3.97462 21.9924 3.75809 21.7886 3.56164 21.5683C2.33337 20.1906 2.33337 18.1271 2.33337 14Z"
      stroke="#00151A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.5947 14H21.5842"
      stroke="#00151A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.41663 14H6.40615"
      stroke="#00151A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowUpBlackBgIcon = (props: IconProps) => (
  <Icon
    width="12px"
    height="12px"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6Z"
      fill="#00111A"
    />
    <path
      d="M8.08333 3.91669L3.5 8.50002"
      stroke="white"
      strokeLinecap="round"
    />
    <path
      d="M5.58325 3.5548C5.58325 3.5548 7.93056 3.35692 8.28678 3.71314C8.643 4.06935 8.4451 6.41667 8.4451 6.41667"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CheckmarkCircleIcon = (props: IconProps) => (
  <Icon
    width="12px"
    height="12px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19ZM14.3566 8.19113C14.6002 7.85614 14.5261 7.38708 14.1911 7.14345C13.8561 6.89982 13.3871 6.97388 13.1434 7.30887L9.15969 12.099L7.28033 10.2197C6.98744 9.92678 6.51256 9.92678 6.21967 10.2197C5.92678 10.5126 5.92678 10.9874 6.21967 11.2803L8.71967 13.7803C8.87477 13.9354 9.08999 14.0149 9.30867 13.9977C9.52734 13.9805 9.72754 13.8685 9.85655 13.6911L14.3566 8.19113Z"
      fill="currentColor"
    />
  </Icon>
);

export const CopyOutlineIcon = (props: IconProps) => (
  <Icon
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="5.75"
      y="2.75"
      width="7.5"
      height="7.5"
      rx="2.25"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M10.25 12.25V12.35C10.25 12.9023 9.80228 13.35 9.25 13.35H4.75C3.64543 13.35 2.75 12.4546 2.75 11.35V6.85C2.75 6.29772 3.19772 5.85 3.75 5.85H3.85"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Icon>
);

export const ArrowLeftRightIcon = (props: IconProps) => (
  <Icon
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.333 8.167H5.833M8.167 4.667L4.667 8.167L8.167 11.667M4.667 19.833H23.333M19.833 16.333L23.333 19.833L19.833 23.333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ChevronRightMiniIcon = (props: IconProps) => (
  <Icon
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 4L10 8L6 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowUpRightMiniIcon = (props: IconProps) => (
  <Icon
    width="10px"
    height="10px"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 7.5L7.083 2.917M4.583 2.5H7.5V5.417"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowDownLeftMiniIcon = (props: IconProps) => (
  <Icon
    width="10px"
    height="10px"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 2.5L2.917 7.083M2.5 4.583V7.5H5.417"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const MoneyOutlineIcon = (props: IconProps) => (
  <Icon
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.974 14C16.974 15.6108 15.6681 16.9167 14.0573 16.9167C12.4465 16.9167 11.1406 15.6108 11.1406 14C11.1406 12.3892 12.4465 11.0833 14.0573 11.0833C15.6681 11.0833 16.974 12.3892 16.974 14Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M2.3334 14C2.3334 9.87292 2.3334 7.80939 3.56167 6.43171C3.75812 6.21135 3.97465 6.00757 4.20877 5.82267C5.67256 4.66666 7.86506 4.66666 12.2501 4.66666H15.7501C20.1351 4.66666 22.3276 4.66666 23.7914 5.82267C24.0255 6.00757 24.242 6.21135 24.4385 6.43171C25.6667 7.80939 25.6667 9.87292 25.6667 14C25.6667 18.1271 25.6667 20.1906 24.4385 21.5683C24.242 21.7886 24.0255 21.9924 23.7914 22.1773C22.3276 23.3333 20.1351 23.3333 15.7501 23.3333H12.2501C7.86506 23.3333 5.67256 23.3333 4.20877 22.1773C3.97465 21.9924 3.75812 21.7886 3.56167 21.5683C2.3334 20.1906 2.3334 18.1271 2.3334 14Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.5948 14H21.5843"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.41669 14H6.40621"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ChartIncreaseIcon = (props: IconProps) => (
  <Icon
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.3333 24.5H10.5C6.65018 24.5 4.72527 24.5 3.52929 23.304C2.33331 22.108 2.33331 20.1831 2.33331 16.3333V3.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7 19.8333C10.6467 19.8333 13.8863 18.7856 16.2304 16.5723C18.4907 14.4381 19.5517 11.4356 19.5517 8.16668"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M16.9368 9.33334L18.4293 7.72135C18.9755 7.13143 19.2486 6.83647 19.5517 6.83647C19.8548 6.83647 20.1279 7.13143 20.6741 7.72135L22.1667 9.33334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ChartDecreaseIcon = (props: IconProps) => (
  <Icon
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.5 24.5H11.6667C7.81686 24.5 5.89196 24.5 4.69598 23.304C3.5 22.108 3.5 20.1831 3.5 16.3333V3.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8.16663 7C11.8133 7 15.0529 8.04769 17.397 10.261C19.6573 12.3952 20.7184 15.3977 20.7184 18.6667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M18.1034 17.5L19.5959 19.112C20.1421 19.7019 20.4152 19.9968 20.7184 19.9968C21.0215 19.9968 21.2946 19.7019 21.8408 19.112L23.3333 17.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ChartLineDataIcon = (props: IconProps) => (
  <Icon
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="9.91666"
      cy="12.25"
      r="1.75"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <circle
      cx="16.9167"
      cy="18.0833"
      r="1.75"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <circle
      cx="21.5833"
      cy="8.75"
      r="1.75"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M18.0064 16.679L21 10.5M11.1796 13.4965L15.4044 16.679M3.5 22.1667L8.8545 13.8591"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.3333 24.5H10.5C6.65021 24.5 4.7253 24.5 3.52932 23.304C2.33334 22.108 2.33334 20.1831 2.33334 16.3333V3.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Icon>
);

export const ChartRoseIcon = (props: IconProps) => (
  <Icon
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.3319 9.30371C7.70576 9.30371 4.76624 11.9354 4.76624 15.1817H11.3319V9.30371Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M2.95699 18.5804C4.40209 21.4294 7.60793 23.4107 11.3307 23.4107L11.3307 15.1816H5.68423C3.97644 15.1816 3.12254 15.1816 2.60335 16.0206C2.08417 16.8597 2.37511 17.4333 2.95699 18.5804Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M14.8336 25.2893C19.6504 23.953 23.1489 19.933 23.1489 15.1815H11.3308V22.235C11.3308 23.9542 11.3308 24.8139 12.0316 25.3431C12.7323 25.8723 13.4327 25.678 14.8336 25.2893Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M25.2477 11.7067C23.8624 7.25013 19.8779 3.76284 14.8483 2.63618C13.3906 2.30963 12.6617 2.14636 11.9962 2.6758C11.3308 3.20525 11.3308 4.06244 11.3308 5.77682V15.1815H22.2297C23.9563 15.1815 24.8195 15.1815 25.3509 14.4648C25.8823 13.748 25.6708 13.0676 25.2477 11.7067Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </Icon>
);

export const PresentationBarChartOutlineIcon = (props: IconProps) => (
  <Icon
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 21V25.6667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6667 21L5.83334 25.6667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3333 21L22.1667 25.6667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.91666 14C2.91666 17.2998 2.91666 18.9497 3.94178 19.9749C4.96691 21 6.61682 21 9.91666 21H18.0833C21.3832 21 23.0331 21 24.0582 19.9749C25.0833 18.9497 25.0833 17.2998 25.0833 14V9.33331C25.0833 6.03348 25.0833 4.38357 24.0582 3.35844C23.0331 2.33331 21.3832 2.33331 18.0833 2.33331H9.91666C6.61682 2.33331 4.96691 2.33331 3.94178 3.35844C2.91666 4.38357 2.91666 6.03348 2.91666 9.33331V14Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M9.33334 15.1667V11.6667M14 15.1667V8.16669M18.6667 15.1667V12.8334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Icon>
);

export const InformationCircleMiniIcon = (props: IconProps) => (
  <Icon
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M0.833313 8.00002C0.833313 11.9581 4.04194 15.1667 7.99998 15.1667C11.958 15.1667 15.1666 11.9581 15.1666 8.00002C15.1666 4.04198 11.958 0.833355 7.99998 0.833355C4.04194 0.833355 0.833313 4.04198 0.833313 8.00002Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.78794 7.35153C7.95264 7.37367 8.18047 7.43294 8.37379 7.62627C8.56712 7.8196 8.6264 8.04742 8.64854 8.21212C8.66688 8.34856 8.66678 8.5072 8.6667 8.64045C8.66669 8.64932 8.66669 8.65808 8.66669 8.66671V11.3334C8.66669 11.7016 8.36821 12 8.00002 12C7.63183 12 7.33335 11.7016 7.33335 11.3334V8.66671C6.96516 8.66671 6.66669 8.36823 6.66669 8.00004C6.66669 7.63185 6.96516 7.33338 7.33335 7.33338C7.34198 7.33338 7.35074 7.33337 7.35961 7.33337C7.49286 7.33328 7.6515 7.33318 7.78794 7.35153Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.3333 5.33335C7.3333 4.96516 7.63044 4.66669 7.99698 4.66669H8.00294C8.36949 4.66669 8.66663 4.96516 8.66663 5.33335C8.66663 5.70154 8.36949 6.00002 8.00294 6.00002H7.99698C7.63044 6.00002 7.3333 5.70154 7.3333 5.33335Z"
      fill="currentColor"
    />
  </Icon>
);

export const ChevronDownMiniIcon = (props: IconProps) => (
  <Icon
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 6.00003C12 6.00003 9.05404 9.99999 7.99997 10C6.94589 10 4 6 4 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const TrendUpMiniIcon = (props: IconProps) => (
  <Icon
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.3333 4.66672L4 12.0001"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7.33331 4.08765C7.33331 4.08765 11.089 3.77105 11.659 4.34099C12.2289 4.91093 11.9123 8.66664 11.9123 8.66664"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const TrendDownMiniIcon = (props: IconProps) => (
  <Icon
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.3332 11.3334L3.99988 4.00003"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7.33325 11.9124C7.33325 11.9124 11.0889 12.229 11.6589 11.659C12.2288 11.0891 11.9122 7.33336 11.9122 7.33336"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const AccountWalletIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.3333 11.6667C13.3333 12.357 13.893 12.9167 14.5833 12.9167C15.2737 12.9167 15.8333 12.357 15.8333 11.6667C15.8333 10.9763 15.2737 10.4167 14.5833 10.4167C13.893 10.4167 13.3333 10.9763 13.3333 11.6667Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M15.75 6.66667C15.8047 6.39741 15.8333 6.11873 15.8333 5.83334C15.8333 3.53215 13.9679 1.66667 11.6667 1.66667C9.36549 1.66667 7.50001 3.53215 7.50001 5.83334C7.50001 6.11873 7.5287 6.39741 7.58336 6.66667"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M5.83332 6.66103H13.3333C15.6903 6.66103 16.8689 6.66103 17.6011 7.39361C18.3333 8.1262 18.3333 9.30528 18.3333 11.6634V13.3309C18.3333 15.6891 18.3333 16.8682 17.6011 17.6007C16.8689 18.3333 15.6903 18.3333 13.3333 18.3333H8.33332C5.19063 18.3333 3.61928 18.3333 2.64297 17.3565C1.66666 16.3798 1.66666 14.8077 1.66666 11.6634V9.99597C1.66666 6.85175 1.66666 5.27965 2.64297 4.30286C3.42887 3.51658 4.60035 3.36323 6.66666 3.33333H8.33332"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Icon>
);

export const CopyMiniIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 12.5C7.5 10.143 7.5 8.96447 8.23223 8.23223C8.96447 7.5 10.143 7.5 12.5 7.5L13.3333 7.5C15.6904 7.5 16.8689 7.5 17.6011 8.23223C18.3333 8.96447 18.3333 10.143 18.3333 12.5V13.3333C18.3333 15.6904 18.3333 16.8689 17.6011 17.6011C16.8689 18.3333 15.6904 18.3333 13.3333 18.3333H12.5C10.143 18.3333 8.96447 18.3333 8.23223 17.6011C7.5 16.8689 7.5 15.6904 7.5 13.3333L7.5 12.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1666 7.5C14.1646 5.03576 14.1273 3.75935 13.41 2.88536C13.2715 2.71658 13.1167 2.56182 12.948 2.4233C12.026 1.66667 10.6562 1.66667 7.91666 1.66667C5.17709 1.66667 3.8073 1.66667 2.88535 2.4233C2.71657 2.56182 2.5618 2.71658 2.42329 2.88536C1.66666 3.80732 1.66666 5.1771 1.66666 7.91667C1.66666 10.6562 1.66666 12.026 2.42329 12.948C2.5618 13.1168 2.71656 13.2715 2.88535 13.41C3.75933 14.1273 5.03575 14.1646 7.49999 14.1666"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const SendMiniIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5398 2.5441C15.7248 0.589464 2.07211 5.37766 2.08338 7.12583C2.09616 9.10822 7.41511 9.71809 8.88939 10.1317C9.77595 10.3804 10.0134 10.6354 10.2178 11.5651C11.1436 15.7754 11.6085 17.8695 12.6679 17.9164C14.3565 17.991 19.3112 4.45166 17.5398 2.5441Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M9.58325 10.4167L12.4999 7.49998"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const PlusMiniIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 3.33333V16.6667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33337 10H16.6667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
